const fr = {
    common: {
        english: "Anglais",
        spanish: "Espagnol",
        french: "Français",
        login: "Connexion",
        register: "S’inscrire",
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier",
        loading: "Chargement...",
        language: "Langue",
        divisions: "Divisions",
        seasons: "Saisons",
        season: "Saison",
        teams: "Équipes",
        players: "Joueurs",
        referees: "Arbitres / Umpires",
        getStarted: "Commencer",
        learnMore: "En savoir plus",
        sending: "Envoi en cours...",
        backToLogin: "Retour à la connexion",
        table: {
            subtitle: "Gérez les éléments de cette liste",
            add: "Ajouter",
            prev: "Précédent",
            next: "Suivant",
            page: "Page",
            of: "sur"
        },
        previous: "Précédent",
        next: "Suivant",
        collapse: "Réduire",
        expand: "Développer"
    },
    nav: {
        home: "Accueil",
        organizations: "Organisations",
        notifications: "Notifications",
        settings: "Paramètres",
        financial: "Finances",
        subscription: "Abonnement",
        advertise: "Publicité",
    },
    marketplaceCategories: {
        "sports-equipment": "Équipement sportif",
        "uniforms-apparel": "Uniformes et vêtements de sport",
        "team-equipment": "Équipement pour équipes",
        "facility-rentals": "Location d’installations",
        "training-equipment": "Équipement d’entraînement",
        "coaching-services": "Services d’entraînement",
        "officiating-services": "Services d’arbitrage",
        "sports-photography": "Photographie sportive",
        "equipment-repair": "Réparation d’équipement",
        "tournament-services": "Services pour tournois",
    },
    marketplacePage: {
        title: "Marketplace",
        details: "Détails de l’annonce",
        category: "Catégorie",
        allCategories: "Toutes les catégories",
        type: "Type",
        allTypes: "Tous les types",
        sale: "À vendre",
        rental: "À louer",
        city: "Ville",
        cityPlaceholder: "Rechercher par ville",
        search: "Rechercher",
        searchPlaceholder: "Rechercher par nom d’annonce ou catégorie",
        catalogSubtitle: "Parcourez les annonces de la communauté sportive.",
        clearFilters: "Effacer les filtres",
        noListings: "Aucune annonce trouvée.",
        noImage: "Aucune image",
        locationNotAvailable: "Lieu non disponible",
        pageOf: "Page {page} sur {pages}",
        contactSeller: "Contacter le vendeur",
        favorite: "Enregistrer l’annonce",
        favoriteUpdated: "Favori mis à jour.",
        conversationStarted: "Conversation démarrée.",
        report: "Signaler",
        reportPrompt: "Indiquez pourquoi vous signalez cette annonce.",
        reportSubmitted: "Signalement envoyé.",
        rentalTerms: "Conditions de location",
        seller: "Vendeur",
        sellerPrivateContact: "Les coordonnées restent privées jusqu’à ce que le vendeur les partage.",
        moreFromSeller: "Autres annonces de ce vendeur",
        blockSeller: "Bloquer le vendeur",
        confirmBlockSeller: "Bloquer ce vendeur ? Ses annonces ne vous seront plus proposées.",
        sellerBlocked: "Vendeur bloqué.",
        blockedUsers: "Utilisateurs marketplace bloqués",
        blockedUsersDescription: "Gérez les vendeurs que vous avez bloqués. Leurs annonces ne seront plus affichées.",
        blockedUserHint: "Leurs annonces du marketplace sont masquées pour vous.",
        noBlockedUsers: "Vous n’avez bloqué aucun utilisateur du marketplace.",
        blockedSeller: "Utilisateur {id}",
        unblock: "Débloquer",
        safetyTitle: "Sécurité du marketplace",
        safetyText: "Rendez-vous dans des lieux publics, vérifiez indépendamment l’article et la transaction et ne partagez pas d’informations personnelles inutiles. Les paiements, dépôts, livraisons, remboursements et litiges de location sont organisés en dehors de AngeonX Sports.",
    },
    marketplaceManagementPage: {
        title: "Mes annonces",
        subtitle: "Gérez vos annonces du marketplace, vos images, conditions de location et campagnes promotionnelles.",
        availableCredits: "Crédits d’annonce",
        enterpriseIncluded: "Inclus avec Enterprise",
        listingUsage: "Utilisation des annonces",
        search: "Rechercher des annonces",
        searchPlaceholder: "Rechercher par nom d’annonce ou catégorie",
        statusFilter: "Statut de l’annonce",
        allStatuses: "Toutes",
        createListing: "Créer une annonce",
        noListings: "Vous n’avez pas encore créé d’annonce.",
        noImage: "Aucune image",
        locationNotAvailable: "Lieu non disponible",
        view: "Voir",
        edit: "Modifier",
        editTitle: "Modifier l’annonce",
        createTitle: "Créer une annonce",
        saved: "Annonce enregistrée.",
        sections: {details: "Détails de l’annonce", location: "Emplacement", images: "Images"},
        fields: {title: "Titre", type: "Type", condition: "État", description: "Description", category: "Catégorie", sport: "Sport", price: "Prix", currency: "Devise", city: "Ville", region: "Région", state: "État / province", country: "Pays", searchLocation: "Rechercher un emplacement", locationPlaceholder: "Rechercher une ville, une région ou un pays", locationLoading: "Chargement de la recherche...", locationHint: "Sélectionnez une suggestion Google Maps afin d’enregistrer précisément l’emplacement et les coordonnées.", primaryImage: "Image principale", imagesSelected: "images sélectionnées", imagesHint: "Sélectionner une ou plusieurs images", rentalPrice: "Prix de location", pricingPeriod: "Période tarifaire", hour: "Heure", day: "Jour", week: "Semaine", month: "Mois", minimumPeriod: "Période minimale", maximumPeriod: "Période maximale", depositRequired: "Dépôt requis", rentalTerms: "Conditions de location"},
        imageDeleted: "Image supprimée.",
        statusUpdated: "Statut de l’annonce mis à jour.",
        promote: "Promouvoir l’annonce",
        promotionTitle: "Promouvoir l’annonce",
        promotionName: "Nom de la campagne",
        promotionSponsor: "Commanditaire",
        promotionSelectSponsor: "Sélectionner un commanditaire",
        promotionZones: "Emplacements publicitaires",
        promotionSubmit: "Créer la promotion",
        promotionCreated: "Brouillon de promotion créé.",
        promotionStatus: "Promotion",
        managePromotion: "Gérer la promotion",
        promotionStatuses: {draft: "Brouillon", scheduled: "Planifiée", running: "Active", paused: "En pause"},
        promotionAlreadyExists: "Cette annonce possède déjà une campagne promotionnelle. Elle sera ouverte maintenant.",
        promotionBudgetHint: "Ensuite, complétez les dates, les pays, la devise et le ciblage. Le budget final est calculé avec les tarifs actuels des emplacements au paiement.",
        promotionConfirmTitle: "Créer une campagne promotionnelle ?",
        promotionConfirmMessage: "Un brouillon sera créé pour {title}. Vous pourrez vérifier les dates, l’audience et le paiement requis avant l’activation.",
        promotionConfirmHint: "Les membres d’une ligue Enterprise peuvent recevoir cette promotion sans frais supplémentaires.",
        promotionConfirm: "Continuer",
        promotionBadge: "PROMOTION",
        promotionNoSponsorTitle: "Créez d’abord un profil de commanditaire",
        promotionNoSponsorMessage: "Un profil de commanditaire est requis pour créer et gérer une campagne publicitaire pour cette annonce.",
        promotionCreateSponsor: "Créer un commanditaire",
        actions: {updateStatus: "Modifier le statut", remove: "Supprimer l’annonce", confirmStatus: "Modifier cette annonce à « {{status}} » ?", confirmRemove: "Supprimer cette annonce ?"},
        conditions: {new: "Neuf", likeNew: "Comme neuf", used: "Usagé", notApplicable: "Sans objet"},
        filters: {title: "Filtrer les annonces", subtitle: "Affinez le marketplace par type, état, emplacement et prix.", all: "Tous", listingType: "Type d’annonce", condition: "État", status: "Statut", category: "Catégorie", sport: "Sport", city: "Ville", cityPlaceholder: "Saisir la ville", region: "Province / Région", regionPlaceholder: "Saisir la province ou la région", state: "État / province", statePlaceholder: "Saisir la province ou la région", country: "Pays", countryPlaceholder: "Saisir le pays", minPrice: "Prix minimum", maxPrice: "Prix maximum", apply: "Appliquer les filtres"},
        statuses: {available: "Disponible", reserved: "Réservée", paused: "En pause", sold: "Vendu", rented: "Loué", expired: "Expiré", removed: "Supprimé"},
    },
    marketplaceModerationPage: {
        searchRank: "#", searchTerm: "Recherche", searches: "Recherches", reportListing: "Annonce", reportReason: "Motif", reportActions: "Actions",
        title: "Modération du marketplace", subtitle: "Examinez les signalements et gérez la visibilité des annonces.", staffTools: "Outils du personnel", moderation: "Modération", analyticsPeriod: "Période d’analyse", last7Days: "7 derniers jours", last30Days: "30 derniers jours", last90Days: "90 derniers jours", allTime: "Toutes les périodes", allListings: "Toutes les annonces", activeListings: "Annonces actives", hiddenListings: "Annonces masquées", reports: "Signalements", search: "Rechercher des annonces", searchPlaceholder: "Rechercher par nom d’annonce ou catégorie", filters: "Filtres", filtersSubtitle: "Filtrez par type, catégorie, sport ou ville.", listingType: "Type d’annonce", category: "Catégorie", sport: "Sport", city: "Ville", cityPlaceholder: "Saisir la ville", all: "Tous", sale: "À vendre", rental: "À louer", apply: "Appliquer les filtres", clear: "Effacer les filtres", listings: "Annonces du marketplace", listingsSubtitle: "Examinez le contenu et la visibilité des annonces.", noListings: "Aucune annonce trouvée.", topSearches: "Recherches principales", topSearchesSubtitle: "Recherches les plus fréquentes pour la période sélectionnée.", noSearchActivity: "Aucune activité de recherche enregistrée.", pendingReports: "Signalements en attente", reportsSubtitle: "Examinez les signalements envoyés par les utilisateurs.", noPendingReports: "Aucun signalement en attente.", deletedListing: "Annonce supprimée", noDetails: "Aucun détail", dismiss: "Ignorer", markReviewed: "Marquer comme examiné", moderationUpdated: "Modération de l’annonce mise à jour.", unableToModerate: "Impossible de modérer l’annonce.", reportReviewed: "Signalement examiné.", unableToReview: "Impossible d’examiner le signalement.", staffRequired: "L’accès du personnel est requis.", removalAction: "Action de modération", listing: "Annonce", removeListing: "Supprimer l’annonce", removalNotice: "Cette annonce sera retirée des résultats du marketplace. Le vendeur sera informé.", removalReason: "Motif de suppression", removalPlaceholder: "Expliquez pourquoi cette annonce est supprimée.", removalRequired: "Le motif de suppression est obligatoire.", cancel: "Annuler", removing: "Suppression…", removed: "Annonce supprimée du marketplace.", close: "Fermer", resolution: "Résolution :",
    },
    auth: {
        loginTitle: "Connexion",
        signingIn: "Connexion en cours…",
        registerTitle: "Créer un compte",
        forgotPassword: "Mot de passe oublié ?",
        resendActivation: "Renvoyer l’email d’activation",
        new: "Nouveau sur AngeonX Sports ?",
        signUpTitle: "Inscrivez-vous",
        didntReceived: "Vous n’avez pas reçu l’email d’activation ?",
        email: "Adresse e-mail",
        password: "Mot de passe",
        toast: {
            invalid: "Identifiants invalides. Veuillez réessayer. Si l'erreur persiste, contactez le support AngeonX Sports."
        },
        title: "Connectez-vous pour commencer votre session"
    },
    signUp: {
        titleManager: "Enregistrer un nouveau gestionnaire et une organisation",
        addSponsor: "Enregistrer un nouveau sponsor / annonceur",
        addAccount: "Enregistrer un nouveau compte",
        yourInfo: "Vos informations",
        role: "Je m’inscris en tant que :",
        orgInfo: "Informations de l’organisation",
        sponsorInfo: "Informations de l’entreprise / du sponsor",
        form: {
            firstName: "Prénom",
            lastName: "Nom de famille",
            dob: "Date de naissance",
            dobHint: "Utilisé pour valider l’éligibilité selon l’âge, les divisions et la vérification du joueur.",
            gender: "Genre",
            genderNotSpecified: "Préfère ne pas répondre",
            genderMale: "Masculin",
            genderFemale: "Féminin",
            email: "Adresse e-mail",
            mobile: "Téléphone mobile",
            password: "Mot de passe",
            password2: "Répéter le mot de passe",
            manager: "Gestionnaire de ligue / académie",
            sponsor: "Sponsor / annonceur",
            orgType: "Type d’organisation",
            orgName: "Nom de l’organisation",
            sponsorName: "Nom de l’entreprise / sponsor",
            website: "Site web",
            contactName: "Nom du contact",
            contactEmail: "Email du contact",
            sportAudience: "Sport principal / public cible",
            orgLocation: "Où se trouve votre ligue ou académie ?",
            orgLocationInfo: "Nous utilisons cela pour afficher votre organisation dans les recherches locales, les cartes et Connect.",
            sponsorLocation: "Où se trouve votre entreprise ?",
            sponsorLocationInfo: "Nous utilisons cela pour le ciblage local (par exemple, montrer votre promotion aux personnes proches de vous).",
            yourLocation: "Votre localisation",
            orgLabelLocation: "La localisation aide les équipes et les joueurs à découvrir votre ligue ou académie.",
            sponsorLabelLocation: "La localisation nous aide à montrer votre promotion aux joueurs et utilisateurs proches.",
            agreeTo: "J’accepte les",
            terms: "Conditions d'utilisation",
            creatingLabel: "Création du compte...",
            sports: {
                "american-football": "Football américain",
                baseball: "Baseball",
                basketball: "Basket-ball",
                hockey: "Hockey",
                rugby: "Rugby",
                soccer: "Football",
                softball: "Softball",
                volleyball: "Volley-ball",
                multi: "Sports multiples / généraux"
            },
            "player": "Joueur",
            "playerDescription": "Rejoignez des équipes, gérez votre profil et participez aux événements.",
            "managerDescription": "Créez des ligues, académies, équipes, calendriers et gérez les événements.",
            "sponsorDescription": "Faites la promotion de votre entreprise auprès des communautés sportives locales.",
            "locationInfo": "Informations de localisation",
            "yourLocationInfo": "Votre emplacement nous aide à vous connecter avec des équipes, ligues, événements et opportunités sportives à proximité.",
            "playerLabelLocation": "Utilisé pour vous connecter avec des opportunités sportives à proximité."
        },
        alreadyHaveAccount: "J’ai déjà un compte",
        toast: {
            created: "Compte créé ! Vérifiez votre email pour l'activer, puis vous pourrez vous connecter.",
            error: "Une erreur s'est produite. Veuillez réessayer plus tard ou contacter le support AngeonX Sports."
        }
    },
    resenActivation: {
        title: "Entrez votre email pour renvoyer le lien d’activation",
        status: "✅ L’email d’activation a été envoyé avec succès !",
        toast: {
            sent: "Email d’activation envoyé !",
            unknownError: "Une erreur inconnue s’est produite.",
            failed: "❌ Impossible de renvoyer l’email d’activation.",
            wrong: "⚠️ Une erreur s’est produite. Veuillez réessayer.",
            error: "Erreur lors de l’envoi de l’email. Réessayez plus tard."
        }
    },
    forgotPassword: {
        title: "Entrez votre adresse e-mail pour réinitialiser votre mot de passe",
        button: "Envoyer le lien de réinitialisation"
    },
    policy: {
        title: "Conditions d’utilisation et Politique de confidentialité",
    },
    topBar: {
        passion: "Là où la passion rencontre la performance !",
        powerAi: "Gestion sportive intelligente, propulsée par l’IA",
        ourTech: "Votre jeu, votre technologie"
    },
    home: {
        hero: {
            title: "Bienvenue sur",
            subtitle: "Portail officiel de la ligue. Suivez les divisions, les calendriers, les résultats et les statistiques en un seul endroit.",
        },
        divisions: {
            noItems: "Aucune division disponible pour le moment.",
            open: "OUVERT",
            closed: "FERMÉ",
            seasonStart: "Début de la saison",
            seasonEnd: "Fin de la saison",
        },
        upcomingGames: {
            title: "Matchs à venir",
            noItems: "Aucun match à venir n’est programmé."
        },
        latestResults: {
            title: "Derniers résultats",
            noItems: "Aucun résultat disponible pour le moment."
        },
        game: {
            home: "Domicile",
            visitor: "Extérieur",
            noPlay: "Non joué",
            final: "Final",
            noScore: "Aucun score",
            field: "Terrain"
        },
        eventStatus: {
            draft: "Brouillon",
            scheduled: "Programmé",
            in_progress: "En cours",
            completed: "Terminé",
            canceled: "Annulé",
            forfeit: "Forfait",
            double_forfeit: "Double forfait",
            extra: "Prolongation"
        },
        partners: {
            title: "Partenaires officiels",
            subtitle: "Fièrement soutenu par des organisations de confiance"
        },
        footer: {
            brandTitle: "Portail officiel sur AngeonX Sports",
            terms: "Conditions générales",
            contact: "Contact",
            rights: "© {year} AngeonX Inc. Tous droits réservés.",
            angeonx: "AngeonX Sports™ est un produit de AngeonX Inc. (angeonx.com | angeonx.ca)",
            poweredBy: "Propulsé par",
            version: "Version"
        }
    },
    defaultHome: {
        hero: {
            title: "Révolutionner la gestion sportive",
            subtitle: "Planification propulsée par l’IA, suivi des résultats et analyse de la performance. Plateforme de gestion sportive pour les ligues, les tournois et les académies. Sports d’équipe et sports individuels."
        },
        youtube: {
            title: "Regardez les tutoriels sur YouTube",
            subtitle: "AngeonX Sports transforme la façon dont les ligues, tournois et académies gèrent le sport — le tout depuis une seule plateforme conçue pour offrir flexibilité et contrôle.",
            why: "Pourquoi AngeonX Sports ?",
            because: "Parce que vous avez besoin de plus que de simples feuilles de calcul et des discussions — vous avez besoin d’outils puissants qui fonctionnent ensemble.",
            visitButton: "Voir la chaîne"
        },
        keyFeatures: {
            title: "Fonctionnalités clés",
            feature1: {
                title: "Planification intelligente",
                subtitle: "Planification automatisée réduisant les conflits."
            },
            feature2: {
                title: "Analyse des performances",
                subtitle: "Analyse des performances des joueurs et des équipes grâce à l’IA."
            },
            feature3: {
                title: "Résultats et statistiques",
                subtitle: "Suivez facilement les résultats des matchs et les classements."
            },
            feature4: {
                title: "Évaluation des arbitres",
                subtitle: "Évaluez les arbitres selon leur performance."
            },
            feature5: {
                title: "Connect",
                subtitle: "Trouvez des organisations, des équipes, des joueurs et des arbitres."
            }
        },
        advertise: {
            title: "Pour les sponsors et les entreprises locales",
            subtitle: "Faites connaître votre marque auprès des joueurs, des parents et des équipes de votre région — directement dans l’application AngeonX Sports.",
            bullet1: "Diffusez votre publicité dans notre application mobile",
            bullet2: "Ciblez par sport et par localisation (soccer, baseball, etc.)",
            bullet3: "Sans contrat à long terme — lancez des campagnes hebdomadaires"
        },
        elevate: {
            title: "Prêt à faire passer votre organisation sportive au niveau supérieur ?",
            subtitle: "Commencez à gérer votre ligue avec une planification intelligente et des analyses alimentées par l’IA."
        },
        download: {
            title: "Téléchargez l’application AngeonX Sports",
            subtitle: "Restez connecté à votre ligue, votre équipe et vos événements — directement depuis votre téléphone.",
            scanLabel: "Scannez pour télécharger"
        }
    },

    termsPolicy: {
        heroTitle: "Conditions d'utilisation et Politique de confidentialité",
        effectiveDateLabel: "Date d'entrée en vigueur",
        effectiveDate: "9 mars 2025",
        lastUpdatedLabel: "Dernière mise à jour",
        lastUpdated: "19 mai 2026",

        intro: {
            p1: "AngeonX Sports (« nous », « notre », « nos ») est exploité par AngeonX Inc., une société constituée au Manitoba, Canada.",
            p2: "En accédant au site web ou aux applications mobiles de AngeonX Sports (la « Plateforme ») ou en les utilisant, vous acceptez d’être lié par les présentes Conditions d’utilisation et Politique de confidentialité (les « Conditions »). Si vous n’êtes pas d’accord, vous ne devez pas utiliser la Plateforme."
        },
        summary: {
            title: "Résumé en langage simple",
            p1: "Pour exploiter les ligues et les avantages utilisateurs, nous pouvons partager des données personnelles limitées avec des partenaires autorisés uniquement lorsque cela est nécessaire pour fournir les services demandés.",
            bullets: {
                item1: "Cela peut inclure le prénom, le nom, l’e-mail, le numéro mobile et la date de naissance lorsque cela est requis pour les opérations de ligue ou la gestion d’assurance/avantages.",
                item2: "Nous partageons uniquement les données minimales nécessaires à la finalité précise du service.",
                item3: "En créant un compte ou en continuant à utiliser AngeonX Sports, vous acceptez ces conditions d’utilisation et de partage des données."
            }
        },

        termsOfService: {
            title: "1. Conditions d'utilisation",

            eligibility: {
                title: "1.1 Admissibilité",
                p1: "Vous devez avoir au moins 13 ans pour utiliser la Plateforme. Si vous n’avez pas atteint l’âge de la majorité dans votre juridiction, vous ne pouvez utiliser la Plateforme que sous la supervision et avec le consentement d’un parent ou tuteur légal. Les parents ou tuteurs sont responsables de la surveillance de l’utilisation de la Plateforme par les mineurs."
            },

            userAccounts: {
                title: "1.2 Comptes utilisateurs",
                p1: "Pour utiliser AngeonX Sports, vous devez fournir des informations d’inscription exactes, notamment votre nom, votre adresse e-mail et votre numéro de téléphone mobile. Vous acceptez de :",
                bullets: {
                    item1: "Préserver la confidentialité de vos identifiants de connexion.",
                    item2: "Assumer la responsabilité de toute activité effectuée sous votre compte.",
                    item3: "Nous informer immédiatement de tout accès ou usage non autorisé."
                },
                p2: "Nous nous réservons le droit de suspendre ou de résilier les comptes qui enfreignent les présentes Conditions."
            },

            platformPurpose: {
                title: "1.3 Objet de la Plateforme",
                p1: "AngeonX Sports est une plateforme de gestion sportive permettant :",
                bullets: {
                    item1: "La gestion des ligues et académies.",
                    item2: "La gestion des équipes et des joueurs.",
                    item3: "La planification des matchs et des événements.",
                    item4: "Les scores en direct et les classements.",
                    item5: "La messagerie et la communication.",
                    item6: "Les interactions dans Connect.",
                    item7: "Les évaluations et commentaires sur les arbitres.",
                    item8: "Des fonctionnalités premium basées sur un abonnement."
                },
                p2: "La Plateforme est fournie uniquement comme outil de gestion. Nous ne sommes pas responsables des événements sportifs réels, des performances des joueurs, des décisions arbitrales ou des résultats réels."
            },

            userConduct: {
                title: "1.4 Conduite de l’utilisateur",
                p1: "En utilisant AngeonX Sports, vous acceptez de ne pas :",
                bullets: {
                    item1: "Participer à du harcèlement, à des discours haineux ou à un comportement abusif.",
                    item2: "Publier des informations diffamatoires, fausses ou trompeuses.",
                    item3: "Utiliser la Plateforme à des fins frauduleuses ou illégales.",
                    item4: "Tenter d’obtenir un accès non autorisé à toute partie de la Plateforme.",
                    item5: "Faire de l’ingénierie inverse, décompiler ou tenter autrement d’obtenir le code source de la Plateforme."
                },
                p2: "Nous nous réservons le droit de supprimer du contenu ou de suspendre des comptes à notre discrétion si nous estimons que les présentes Conditions ont été violées."
            },

            userGeneratedContent: {
                title: "1.5 Contenu généré par les utilisateurs",
                p1: "Les utilisateurs peuvent soumettre du contenu, notamment des messages, évaluations, statistiques, annonces, photos et informations de profil (collectivement, le « Contenu utilisateur »).",
                p2: "Vous conservez la propriété de votre Contenu utilisateur, mais vous accordez à AngeonX Sports (AngeonX Inc.) une licence non exclusive, mondiale et libre de redevances pour utiliser, héberger, stocker, reproduire, modifier et afficher ce contenu uniquement aux fins d’exploitation, de maintenance et d’amélioration de la Plateforme.",
                p3: "Vous êtes seul responsable du Contenu utilisateur que vous soumettez. Nous ne sommes pas responsables du Contenu utilisateur publié par les utilisateurs, mais nous pouvons supprimer tout contenu qui viole les présentes Conditions ou la législation applicable."
            },

            refereeRatings: {
                title: "1.6 Évaluations et avis sur les arbitres",
                p1: "Les utilisateurs peuvent soumettre des évaluations ou commentaires concernant les arbitres, umpires, entraîneurs ou autres participants. En soumettant ces évaluations, vous acceptez de :",
                bullets: {
                    item1: "Fournir des évaluations véridiques et équitables fondées sur votre expérience.",
                    item2: "Ne pas publier de contenu diffamatoire, discriminatoire ou malveillant."
                },
                p2: "Les opinions exprimées dans les évaluations et commentaires sont celles des utilisateurs concernés et ne représentent pas nécessairement celles de AngeonX Sports. Nous ne sommes pas responsables du contenu de ces évaluations, mais nous pouvons les supprimer ou les modérer le cas échéant."
            },

            subscriptions: {
                title: "1.7 Abonnements, facturation et politique de remboursement",
                p1: "Certaines fonctionnalités de la Plateforme ne sont disponibles que via des abonnements payants ou des forfaits premium. En vous abonnant, vous acceptez de :",
                bullets1: {
                    item1: "Payer tous les frais applicables associés au forfait choisi.",
                    item2: "Accepter le renouvellement automatique de votre abonnement à la fin de chaque période de facturation, sauf si vous annulez avant le renouvellement.",
                    item3: "Reconnaître que les prix peuvent varier selon la devise et la région, et que des taxes peuvent s’appliquer."
                },
                p2: "Vous pouvez annuler votre abonnement à tout moment via la Plateforme, et vous conserverez l’accès aux fonctionnalités premium jusqu’à la fin de la période de facturation en cours. Sauf obligation légale, les frais d’abonnement ne sont pas remboursables.",
                p3: "Si une période d’essai gratuite est proposée, les utilisateurs auront accès aux fonctionnalités premium pendant toute la durée de l’essai sans frais.",
                p4: "À la fin de la période d’essai :",
                bullets2: {
                    item1: "L’abonnement ne sera pas automatiquement converti en forfait payant.",
                    item2: "Le compte de l’utilisateur sera automatiquement rétrogradé vers le forfait Free, sauf si l’utilisateur souscrit activement à un forfait payant.",
                    item3: "Aucun frais ne sera facturé sauf si l’utilisateur finalise explicitement l’achat d’un abonnement payant."
                },
                p5: "Les détails relatifs à la durée de l’essai et aux fonctionnalités incluses seront fournis au moment de l’inscription."
            },

            stripe: {
                title: "1.8 Traitement des paiements avec Stripe",
                p1: "Toutes les transactions de paiement sur AngeonX Sports sont traitées par Stripe, Inc. (« Stripe »). Nous ne collectons, ne stockons ni ne traitons directement l’intégralité de vos informations de carte de crédit ou de paiement. Lorsque vous effectuez un achat ou souscrivez à un forfait, vos informations de paiement sont transmises directement à Stripe et sont soumises à ses politiques.",
                p2: "En effectuant un paiement via la Plateforme, vous :",
                bullets: {
                    item1: "Acceptez d’être lié par les Conditions d’utilisation et la Politique de confidentialité de Stripe.",
                    item2: "Reconnaissez que les services de traitement des paiements sont fournis par Stripe et soumis à ses propres accords."
                },
                p3: "Les politiques actuelles de Stripe sont disponibles sur",
                legalLinkLabel: "Mentions légales Stripe",
                privacyLinkLabel: "Confidentialité Stripe",
                p4: "Nous ne sommes pas responsables de :",
                bullets2: {
                    item1: "Retards ou échecs dans le traitement des paiements.",
                    item2: "Autorisations de carte ou contrôles antifraude effectués par Stripe ou votre banque.",
                    item3: "Gestion des rétrofacturations ou litiges régis par les règles de Stripe.",
                    item4: "Taux de conversion appliqués par Stripe ou votre institution financière."
                }
            },

            thirdParty: {
                title: "1.9 Services tiers",
                p1: "Nous pouvons faire appel à des prestataires tiers pour exploiter et soutenir la Plateforme, notamment :",
                bullets: {
                    item1: "Des processeurs de paiement (ex. Stripe).",
                    item2: "Des fournisseurs d’hébergement cloud.",
                    item3: "Des services de notification et de messagerie.",
                    item4: "Des fournisseurs d’analytique.",
                    item5: "Des partenaires sportifs autorisés (comme des ligues et fédérations) et des fournisseurs d’avantages (comme des compagnies d’assurance) lorsque cela est nécessaire pour fournir les services ou avantages demandés."
                },
                p2: "L’utilisation de ces services tiers peut être soumise à leurs propres conditions et politiques de confidentialité."
            },

            intellectualProperty: {
                title: "1.10 Propriété intellectuelle",
                p1: "Tout le contenu et les éléments présents sur la Plateforme, y compris notamment le nom AngeonX Sports, le logo, l’identité de marque, le code logiciel, le design de l’interface utilisateur et les marques, appartiennent à AngeonX Inc. ou à ses concédants et sont protégés par les lois sur la propriété intellectuelle.",
                p2: "Vous ne pouvez pas reproduire, distribuer, modifier, créer des œuvres dérivées ni afficher publiquement une quelconque partie de la Plateforme sans notre autorisation écrite préalable.",
                p3: "Les abonnements White-label ou Elite peuvent permettre une personnalisation visuelle de la marque (par ex. logo, couleurs ou sous-domaine personnalisés) pour les organisations, mais ne transfèrent pas la propriété du logiciel sous-jacent ni de la Plateforme."
            },

            marketingRights: {
                title: "1.11 Droits de marketing et de publicité",
                p1: "En utilisant la Plateforme, les organisations et les utilisateurs accordent à AngeonX Sports (AngeonX Inc.) une licence non exclusive, mondiale et libre de redevances pour utiliser les informations suivantes à des fins marketing et promotionnelles :",
                bullets1: {
                    item1: "Les noms des organisations, ligues et équipes.",
                    item2: "Les logos et éléments de marque affichés publiquement.",
                    item3: "Les témoignages soumis volontairement par les utilisateurs ou organisations.",
                    item4: "Les statistiques d’utilisation non sensibles (par ex. nombre de matchs, ligues ou équipes gérés).",
                    item5: "Les captures d’écran publiques de classements, calendriers ou vues de la Plateforme sans exposition de données personnelles."
                },
                p2: "Cette licence est utilisée uniquement pour :",
                bullets2: {
                    item1: "Les campagnes marketing et supports promotionnels.",
                    item2: "Les présentations sur le site web et études de cas.",
                    item3: "Les publications sur les réseaux sociaux.",
                    item4: "Les présentations commerciales ou destinées aux investisseurs."
                },
                p3: "Nous n’utiliserons pas :",
                bullets3: {
                    item1: "Des données personnelles privées telles que les adresses e-mail ou numéros de téléphone à des fins de marketing public.",
                    item2: "Des informations financières ou des détails de paiement.",
                    item3: "Des données personnelles sensibles.",
                    item4: "Des images identifiables ou des informations personnelles concernant des mineurs à des fins marketing sans consentement approprié (par ex. consentement parental ou organisationnel lorsque requis)."
                },
                p4: "Si une organisation ou un utilisateur souhaite se retirer de l’utilisation marketing, il peut nous contacter par écrit à",
                email: "kbolasports@angeonx.com"
            },

            advertising: {
                title: "1.12 Publicité et sponsoring",
                p1: "La Plateforme peut afficher des publicités, bannières de sponsors ou contenus promotionnels. Nous ne cautionnons ni ne garantissons aucun produit ou service tiers présenté dans ces publicités.",
                p2: "Les utilisateurs interagissent avec les annonceurs ou sponsors à leurs propres risques, et tout litige ou réclamation relève uniquement de la relation entre l’utilisateur et le tiers."
            },

            serviceAvailability: {
                title: "1.13 Disponibilité du service et exclusion de garanties",
                p1: "La Plateforme est fournie « telle quelle » et « selon disponibilité », sans garantie d’aucune sorte, expresse ou implicite, y compris notamment les garanties implicites de qualité marchande, d’adéquation à un usage particulier ou d’absence de contrefaçon.",
                p2: "Nous ne garantissons pas que :",
                bullets: {
                    item1: "La Plateforme sera ininterrompue, ponctuelle, sécurisée ou exempte d’erreurs.",
                    item2: "Les données (y compris scores, classements ou calendriers) seront toujours exactes ou à jour.",
                    item3: "Les défauts seront corrigés immédiatement."
                }
            },

            limitation: {
                title: "1.14 Limitation de responsabilité",
                p1: "Dans toute la mesure permise par la loi, AngeonX Sports et AngeonX Inc. (y compris ses administrateurs, dirigeants, employés et affiliés) ne pourront être tenus responsables de dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, ni de toute perte de profits ou de revenus, qu’elle soit subie directement ou indirectement, ni de toute perte de données, de clientèle ou d’autres pertes immatérielles résultant de :",
                bullets: {
                    item1: "Votre accès à la Plateforme ou son utilisation, ou l’impossibilité d’y accéder ou de l’utiliser.",
                    item2: "Tout comportement ou contenu d’autres utilisateurs ou de tiers sur la Plateforme.",
                    item3: "Des erreurs ou inexactitudes dans les calendriers, résultats, classements ou statistiques.",
                    item4: "Des interruptions, retards ou défaillances de l’infrastructure ou de services tiers.",
                    item5: "Des problèmes de traitement des paiements, litiges ou rétrofacturations gérés par Stripe ou les banques."
                }
            },

            indemnification: {
                title: "1.15 Indemnisation",
                p1: "Vous acceptez d’indemniser et de dégager de toute responsabilité AngeonX Inc., AngeonX Sports ainsi que leurs dirigeants, administrateurs, employés et agents contre toute réclamation, responsabilité, dommage, perte ou dépense (y compris les honoraires juridiques raisonnables) découlant de ou liés de quelque manière que ce soit à :",
                bullets: {
                    item1: "Votre accès ou utilisation de la Plateforme.",
                    item2: "Votre violation des présentes Conditions.",
                    item3: "Votre Contenu utilisateur.",
                    item4: "Tout litige entre vous et un autre utilisateur ou organisation."
                }
            },

            governingLaw: {
                title: "1.16 Droit applicable",
                p1: "Les présentes Conditions sont régies et interprétées conformément aux lois de la province du Manitoba et aux lois fédérales du Canada qui y sont applicables. Tout litige découlant des présentes Conditions ou de votre utilisation de la Plateforme sera soumis à la compétence exclusive des tribunaux situés au Manitoba, Canada."
            }
        },

        privacyPolicy: {
            title: "2. Politique de confidentialité",

            collect: {
                title: "2.1 Informations que nous collectons",
                p1: "Lorsque vous utilisez AngeonX Sports, nous collectons les types d’informations suivants :",
                bullets: {
                    item1: "Informations personnelles : prénom, nom, adresse e-mail, numéro de téléphone mobile, date de naissance et autres informations de profil que vous fournissez.",
                    item2: "Informations d’utilisation : journaux d’activité, informations sur l’appareil, adresse IP, interactions avec les fonctionnalités de la Plateforme et analyses de performance utilisées pour améliorer nos services.",
                    item3: "Informations d’abonnement : type de forfait, statut de facturation, devise et données de paiement associées hors carte."
                }
            },

            payments: {
                title: "Paiements et informations de carte de crédit",
                p1: "Nous ne collectons, ne stockons ni ne traitons directement vos informations de carte de crédit ou de paiement. Toutes les transactions sont gérées de manière sécurisée par notre prestataire de paiement tiers de confiance, Stripe. Lorsque vous effectuez un achat ou souscrivez à un forfait, vos informations de paiement sont transmises directement à Stripe et sont soumises à sa Politique de confidentialité et à ses Conditions d’utilisation. En utilisant nos services et en effectuant tout paiement via la Plateforme, vous acceptez également d’être lié par les politiques et conditions de Stripe."
            },

            useData: {
                title: "2.2 Comment nous utilisons vos données",
                p1: "Nous utilisons les informations collectées pour :",
                bullets: {
                    item1: "Créer et gérer votre compte.",
                    item2: "Permettre la communication et la collaboration entre utilisateurs via le chat et les notifications.",
                    item3: "Exploiter et gérer les ligues, équipes, calendriers et événements.",
                    item4: "Fournir une assistance client et répondre aux demandes.",
                    item5: "Améliorer et optimiser les fonctionnalités et les performances de la Plateforme.",
                    item6: "Faire respecter les présentes Conditions et protéger l’intégrité de la Plateforme."
                }
            },

            contactSharing: {
                title: "2.3 Partage des informations de contact",
                p1: "Par défaut, vos informations de contact (nom, e-mail, numéro mobile) ne sont pas partagées avec des tiers en dehors de la Plateforme. Au sein de la Plateforme :",
                bullets: {
                    item1: "Vous pouvez choisir dans vos préférences de partager vos coordonnées (e-mail et mobile) avec des gestionnaires d’organisation ou d’équipe dans le module Connect de l’application afin de coordonner des opportunités ou des invitations.",
                    item2: "Si vous n’activez pas ce partage, toute communication sera gérée via la messagerie et le chat intégrés."
                }
            },

            dataSharing: {
                title: "2.4 Politique de partage des données",
                p1: "Nous ne vendons pas vos informations personnelles. Nous partageons des informations personnelles uniquement lorsque cela est nécessaire pour exploiter la Plateforme, fournir les services ou avantages sportifs demandés, ou respecter des obligations légales. Nous pouvons partager des données avec :",
                bullets: {
                    item1: "Avec des prestataires de services (par ex. Stripe, hébergement, notifications) qui nous aident à exploiter la Plateforme.",
                    item2: "Avec des organisations partenaires autorisées impliquées dans les opérations sportives ou les avantages utilisateurs (par exemple, ligues, fédérations ou compagnies d’assurance), uniquement à des fins légitimes de service comme la vérification d’éligibilité, l’inscription, la planification, la gestion de réclamations ou l’activation d’avantages.",
                    item3: "Uniquement les données minimales requises pour la finalité concernée, pouvant inclure prénom, nom, e-mail, numéro mobile et date de naissance lorsque le service partenaire l’exige.",
                    item4: "Lorsque la loi, une réglementation ou une procédure légale l’exige.",
                    item5: "Pour protéger les droits, les biens ou la sécurité de AngeonX Sports, de nos utilisateurs ou du public."
                },
                p2: "AngeonX Sports et AngeonX Inc. ne sont pas responsables de l’utilisation abusive indépendante des données personnelles par des organisations tierces après un partage licite effectué conformément à la présente Politique. Toutefois, nous exigeons que les tiers autorisés traitent les données uniquement pour des finalités de service approuvées et sous des garanties contractuelles et juridiques appropriées."
            },

            retention: {
                title: "2.5 Conservation des données",
                p1: "Nous conservons les données personnelles tant que votre compte reste actif ou aussi longtemps que nécessaire pour fournir la Plateforme et respecter nos obligations légales. Après la suppression du compte :",
                bullets: {
                    item1: "Nous supprimons ou anonymisons les données personnelles du profil lorsque cela est possible.",
                    item2: "Certaines données (par ex. journaux, sauvegardes) peuvent être conservées pendant une période limitée à des fins de sécurité, de prévention de la fraude ou de conformité légale."
                }
            },

            security: {
                title: "2.6 Sécurité des données",
                p1: "Nous mettons en œuvre des mesures techniques et organisationnelles conformes aux standards du secteur pour protéger vos informations contre tout accès non autorisé, perte, usage abusif ou altération. Toutefois, aucune plateforme en ligne ne peut garantir une sécurité à 100 %, et vous êtes responsable de la protection de vos identifiants de connexion."
            },

            children: {
                title: "2.7 Confidentialité des enfants",
                p1: "Nous ne collectons pas sciemment d’informations personnelles auprès d’enfants de moins de 13 ans sans consentement parental. Si nous apprenons que nous avons collecté des informations personnelles d’un enfant de moins de 13 ans sans consentement approprié, nous prendrons les mesures nécessaires pour supprimer ces informations.",
                p2: "Les parents ou tuteurs qui pensent que leur enfant a fourni des informations personnelles peuvent nous contacter à",
                email: "kbolasports@angeonx.com",
                p3: "pour demander la suppression."
            },

            international: {
                title: "2.8 Utilisateurs internationaux",
                p1: "Si vous accédez à la Plateforme depuis l’extérieur du Canada, vous comprenez et acceptez que vos informations puissent être transférées, stockées et traitées au Canada et dans d’autres pays où opèrent nos prestataires de services. Les lois sur la protection des données peuvent différer de celles de votre juridiction."
            },

            rights: {
                title: "2.9 Vos droits",
                p1: "Selon votre juridiction, vous pouvez disposer de droits concernant vos données personnelles, y compris le droit de :",
                bullets: {
                    item1: "Demander l’accès aux données personnelles que nous détenons à votre sujet.",
                    item2: "Demander la correction de données inexactes ou incomplètes.",
                    item3: "Demander la suppression de vos données personnelles, sous réserve des exigences légales.",
                    item4: "Contrôler la manière dont vos informations de contact sont partagées au sein de la Plateforme."
                },
                p2: "Les demandes liées à vos données peuvent être envoyées à",
                email: "kbolasports@angeonx.com"
            },

            updates: {
                title: "2.10 Mises à jour de la politique",
                p1: "Nous pouvons mettre à jour périodiquement les présentes Conditions et la présente Politique de confidentialité afin de refléter des changements dans nos pratiques, nos obligations légales ou les fonctionnalités de la Plateforme. Lorsque nous apportons des modifications substantielles, nous vous en informerons via la Plateforme ou par tout autre moyen raisonnable. Votre utilisation continue de la Plateforme après ces modifications constitue votre acceptation des Conditions mises à jour."
            }
        },

        contact: {
            title: "3. Nous contacter",
            p1: "Si vous avez des questions concernant les présentes Conditions d’utilisation ou cette Politique de confidentialité, ou si vous souhaitez exercer l’un de vos droits, veuillez nous contacter à :",
            company: "AngeonX Inc.",
            city: "Winnipeg, Manitoba, Canada",
            emailLabel: "E-mail",
            email: "kbolasports@angeonx.com",
            p2: "En créant un compte, en accédant à AngeonX Sports ou en continuant à l’utiliser, vous reconnaissez avoir lu, compris et accepté les présentes Conditions d’utilisation et cette Politique de confidentialité, y compris le partage limité de données personnelles avec des ligues autorisées et des fournisseurs d’avantages (comme des compagnies d’assurance), strictement pour fournir les services et avantages demandés."
        }
    },
    header: {
        quickActions: {
            title: "Actions rapides",
            subtitle: "Créez et naviguez plus rapidement",
            newOrg: "Nouvelle organisation",
            addVenue: "Ajouter un lieu",
            subscriptions: "Abonnements",
            newSponsor: "Nouveau sponsor",
            newCampaign: "Nouvelle campagne"
        },
        notifications: {
            title: "Notifications",
            unread: "non lues",
            subtitle: "Vous êtes à jour",
            noUnread: "Aucune notification non lue",
            info: "Vous verrez les mises à jour ici au fur et à mesure de l’activité.",
            viewMore: "Voir plus"
        },
        switchProfile: {
            title: "Changer de profil",
            profile: "profil",
            active: "Profil actif",
            switchProfile: "Passer à ce profil",
            activeBadge: "Actif",
            switch: "Passer",
            plans: "Forfaits",
            invoices: "Factures",
            subscriptions: "Abonnements",
            logout: "Se déconnecter"
        }
    },
    sidebar: {
        core: "Principal",
        people: "Personnes",
        management: "Gestion",
        officials: "Officiels",
        referees: "Arbitres / Umpires",
        assignments: "Affectations",
        organizations: "Organisations",
        players: "Joueurs",
        financialDashboard: "Finances",
        settings: "Paramètres",
        venue: "Installations",
        waivers: "Décharges",
        sanctions: "Règles & sanctions",
        payoutAccounts: "Comptes de paiement",
        staff: "Equipe",
        subscriptions: "Abonnements",
        plans: "Forfaits",
        invoices: "Factures",
        admin: "Admin",
        advertising: "Publicité",
        adsDashboard: "Tableau publicitaire",
        dashboard: "Tableau de bord",
        audience: "Audience",
        managementData: "Données de gestion",
        sponsors: "Sponsors",
        campaigns: "Campagnes",
        commerce: "Commerce",
        marketplace: "Marketplace",
        streamingProviders: "Diffusion en direct"
    },
    streamProvidersPage: {
        title: "Fournisseurs de diffusion", editBadge: "MODIFIER", newBadge: "NOUVEAU", editTitle: "Modifier le fournisseur de diffusion", addTitle: "Ajouter un fournisseur de diffusion", close: "Fermer",
        providerDetails: "Détails du fournisseur", provider: "Fournisseur", angeonxProvider: "Fournisseur YouTube AngeonX", ownProvider: "Mon propre fournisseur",
        accountName: "Nom du compte", oauthClientId: "ID client OAuth", oauthClientSecret: "Secret client OAuth", oauthRefreshToken: "Jeton d’actualisation OAuth",
        replaceCredentialsHint: "Saisissez à nouveau tous les identifiants pour remplacer les identifiants chiffrés.", angeonxProviderHint: "Les diffusions utiliseront le compte YouTube AngeonX configuré dans le service de diffusion. Aucun identifiant n’est requis ici.",
        cancel: "Annuler", saving: "Enregistrement…", saveProvider: "Enregistrer le fournisseur", useAngeonxProvider: "Utiliser le fournisseur AngeonX", saved: "Fournisseur de diffusion enregistré.", deleted: "Fournisseur de diffusion supprimé.", confirmDelete: "Supprimer {name} ?",
        checkAvailable: "La diffusion en direct sur YouTube est disponible.", checkFailed: "Impossible de vérifier la disponibilité du direct YouTube.", platformAccount: "Compte de la plateforme",
        available: "Disponible", unavailable: "Diffusion en direct indisponible", checkFailedStatus: "Échec de la vérification", notChecked: "Non vérifié", checked: "Vérifié le {date}", checking: "Vérification…", checkLive: "Vérifier la diffusion en direct",
        nameHeader: "Nom", providerHeader: "Fournisseur", accountHeader: "Compte de diffusion", availabilityHeader: "Disponibilité", actionsHeader: "Actions",
        upgradeSubtitle: "Connectez un compte YouTube d’organisation pour gérer les diffusions en direct.", viewPlans: "Voir les forfaits", upgradeMessage: "La gestion des fournisseurs de diffusion est réservée aux organisations disposant d’un forfait Enterprise.", upgradeLink: "Passez votre organisation à un forfait supérieur", upgradeSuffix: "pour connecter sa chaîne YouTube.",
        quotaNotice: "Le test crée puis supprime brièvement une diffusion YouTube privée afin de vérifier que la chaîne peut diffuser en direct. Il utilise le quota de l’API YouTube."
    },
    refereesPage: {
        title: "Arbitres / Umpires", officialsTitle: "Officiels", officialsEmpty: "Aucun officiel actif trouvé.", addOfficial: "Ajouter un officiel", addExistingOfficial: "Ajouter un officiel existant", createOfficial: "Créer un nouvel officiel", officialRole: "Officiel", findOfficials: "Rechercher des officiels", filterOfficials: "Recherchez et filtrez les officiels de vos organisations.",
        settings: "Paramètres",
        subtitle: "Gérez les officiels actifs de votre organisation.",
        empty: "Aucun arbitre ou umpire actif trouvé.",
        add: "Ajouter un arbitre", addExisting: "Ajouter un arbitre existant", create: "Créer un nouvel arbitre",
        official: "Officiel",
        organization: "Organisation",
        contact: "Contact",
        location: "Lieu",
        status: "Statut", activate: "Activer", deactivate: "Désactiver", statuses: {accepted: "Actif", inactive: "Inactif"},
        roleLabel: "Arbitre",
        detailsEyebrow: "Profil de l’officiel", viewDetails: "Voir les détails", rating: "Évaluation",
        filtersBadge: "Filtres", filtersTitle: "Rechercher des arbitres", filtersSubtitle: "Recherchez et filtrez les officiels de vos organisations.", search: "Rechercher", searchPlaceholder: "Rechercher par nom ou e-mail", allOrganizations: "Toutes les organisations", sport: "Sport", allSports: "Tous les sports", allStatuses: "Tous les statuts",
    },
assignmentsPage: {
        upgradePlanLabel: "PREMIUM", upgradeTitle: "Affectations des matchs indisponibles", upgradeSubtitle: "Cette fonctionnalité est disponible avec les plans d’organisation Enterprise.", upgradeCta: "Mettre à niveau", upgradeTextPrefix: "Pour gérer les affectations des matchs de vos organisations, veuillez", upgradeTextLink: "mettre à niveau votre abonnement",
        cancelOfficial: "Annuler l’invitation", assignmentCancelled: "Affectation de l’officiel annulée.",
        manageOfficials: "Gérer les officiels",
        matchDay: "Journée",
        detailsBadge: "Détails de l’affectation", historyTitle: "Historique des invitations", historySubtitle: "Consultez chaque invitation et réponse des officiels pour ce match.", unknownOfficial: "Officiel inconnu", assignedBy: "Affecté par", systemAssignment: "Affectation système", noAssignmentHistory: "Aucun historique d’invitation", noAssignmentHistoryHint: "Aucune invitation d’officiel n’a encore été créée pour ce match.",
        facilityTerm: "Installations", assignFacilities: "Affecter des installations", facility: "Installation", selectFacility: "Sélectionner une installation", facilityHint: "L’installation sélectionnée sera appliquée à tous les matchs sélectionnés.", facilitiesTableTitle: "Affectations d’installations", facilitiesTableSubtitle: "Consultez et affectez des installations entre les divisions depuis un seul espace.",
        summary: {scheduled: "Programmés", accepted: "Couverts", pending: "En attente", unassigned: "Non assignés"},
        filters: "Filtres", scheduledOnly: "Matchs programmés uniquement", clearFilters: "Effacer les filtres",
        allOfficials: "Tous les officiels",
        assignmentModeAll: "Tous les matchs", assignmentModePerGame: "Par match", coordinatorAssignmentModeHint: "Les coordinateurs sélectionnés seront affectés à tous les matchs sélectionnés.",
        applyToAllGames: "Appliquer à tous les matchs", saveAssignment: "Enregistrer les affectations",
        fieldConflict: "Le terrain est déjà réservé à cette date et heure.", refereeConflict: "L’arbitre est déjà affecté à cette date et heure.", coordinatorConflict: "Le coordinateur est déjà affecté à cette date et heure.", conflictingEvent: "Match en conflit :", conflictingSelection: "Sélection en conflit :",
        assigned: "Assigné", unassigned: "Non assigné", officialsTerm: "Officiels", officialsWorkspaceTitle: "Affectations des officiels", officialsWorkspaceBadge: "Officiels", officialsWorkspaceSubtitle: "Coordonnez la couverture des officiels dans toutes les divisions de votre organisation.", officialsTableTitle: "Affectations des officiels", officialsTableSubtitle: "Sélectionnez des matchs programmés pour inviter les officiels de leur phase.", officialsColumn: "Officiels", officialsToInvite: "Officiels à inviter", noOfficialsAssigned: "Aucun officiel affecté", assignOfficials: "Affecter des officiels",
        badge: "Opérations des officiels", title: "Affectations des arbitres", subtitle: "Coordonnez la couverture arbitrale de toutes les divisions de votre organisation.", tableSubtitle: "Sélectionnez les matchs programmés pour inviter les arbitres de leurs groupes de phase.", organization: "Organisation", selectOrganization: "Sélectionner une organisation", division: "Division", allDivisions: "Toutes les divisions", season: "Saison", allSeasons: "Toutes les saisons", status: "Statut de l’affectation", allStatuses: "Tous les statuts", dateFrom: "Date de début", dateTo: "Date de fin", allFields: "Tous les terrains", allCoordinators: "Tous les coordinateurs", games: "matchs", game: "Match", divisionStage: "Division / étape", dateLocation: "Date / lieu", referees: "Arbitres / umpires", noReferee: "Aucun arbitre affecté", selectAll: "Sélectionner tous les matchs programmés de cette page", assignSelected: "Affecter des arbitres", assignCoordinator: "Affecter un coordinateur", assignField: "Affecter un terrain", coordinators: "Coordinateurs", field: "Terrain", selectField: "Sélectionner un terrain", fieldHint: "Le terrain sélectionné sera appliqué à tous les matchs sélectionnés.", coordinatorHint: "Sélectionnez un ou plusieurs coordinateurs pour tous les matchs sélectionnés.", selectedGames: "{{count}} match(s) sélectionné(s)", noCoordinators: "Aucun coordinateur disponible.", selectGameFirst: "Sélectionnez au moins un match programmé.", updated: "Affectations mises à jour.", updateFailed: "Impossible de mettre à jour les affectations.", tabs: {officials: "Officiels", coordinators: "Coordinateurs", fields: "Terrains"}, tables: {officials: {title: "Affectations d’arbitres", subtitle: "Sélectionnez les matchs programmés pour inviter les arbitres de leurs groupes de phase.", assignees: "Arbitres", empty: "Aucun arbitre affecté"}, coordinators: {title: "Affectations de coordinateurs", subtitle: "Affectez des coordinateurs entre les divisions depuis un seul espace.", assignees: "Coordinateurs", empty: "Aucun coordinateur affecté"}, fields: {title: "Affectations de terrains", subtitle: "Consultez et affectez des terrains entre les divisions depuis un seul espace.", assignees: "Terrain", empty: "Aucun terrain affecté"}}, noOrganizationTitle: "Aucune organisation disponible", noOrganizationSubtitle: "Vous devez avoir accès à une organisation pour gérer les affectations des arbitres.",
    },
    managementData: {
        title: "Données de gestion",
        subtitle: "Tableau de bord staff pour l’adoption, l’activation client et l’usage opérationnel.",
        admin: "Admin",
        staffOnly: "Ce tableau de bord est réservé aux utilisateurs staff.",
        loading: "Chargement des données de gestion...",
        loadError: "Impossible de charger les données de gestion.",
        healthLoadError: "Impossible de charger les données de santé des organisations.",
        noData: "Aucune donnée disponible",
        periodFilter: "Période de rapport",
        periods: {
            lastWeek: "Semaine dernière",
            last30Days: "30 derniers jours",
            last3Months: "3 derniers mois",
            last6Months: "6 derniers mois",
            last1Year: "Dernière année"
        },
        cards: {
            clients: "Organisations clientes",
            activeClients: "{count} clients actifs",
            activeUsers: "Utilisateurs actifs",
            totalUsers: "{count} utilisateurs au total",
            periodRegistrations: "Inscriptions de la période",
            selectedPeriod: "Équipes plus joueurs dans la période",
            completedGames: "Matchs terminés",
            totalGames: "{count} matchs au total"
        },
        periodCards: {
            organizations: "Nouvelles organisations",
            orgBreakdown: "{leagues} ligues · {academies} académies · {teams} équipes",
            structure: "Nouvelles divisions/saisons",
            structureHint: "{stages} étapes · {groups} groupes",
            gamesCreated: "Matchs créés",
            results: "{count} résultats terminés",
            newUsers: "Nouveaux utilisateurs",
            activeUsers: "{count} actifs dans la période"
        },
        charts: {
            growthTitle: "Tendance d’adoption",
            growthSubtitle: "Nouvelles organisations, utilisateurs et matchs par période glissante.",
            activationTitle: "Entonnoir d’activation client",
            activationSubtitle: "Nombre d’organisations clientes ayant atteint chaque étape.",
            organizationSubscriptionsTitle: "Abonnements des organisations",
            organizationSubscriptionsSubtitle: "Abonnements web actifs par forfait.",
            userSubscriptionsTitle: "Abonnements des utilisateurs",
            userSubscriptionsSubtitle: "Abonnements app actifs et utilisateurs actifs récents par forfait.",
            organizationTypesTitle: "Répartition par type d’organisation",
            organizationTypesSubtitle: "Inventaire actuel et croissance récente par type."
        },
        chartLabels: {
            organizations: "Organisations",
            users: "Utilisateurs",
            games: "Matchs",
            clients: "Organisations clientes",
            active30Days: "Actifs 30 jours"
        },
        funnel: {
            clients: "Clients",
            divisions: "Divisions",
            seasons: "Saisons",
            teams: "Équipes",
            players: "Joueurs",
            results: "Résultats"
        },
        tables: {
            topOrganizations: "Clients les plus activés",
            atRiskOrganizations: "Clients à surveiller",
            atRiskOrganizationsLoading: "Clients à surveiller · chargement...",
            organizationSubscriptions: "Comptes par forfait organisation",
            organizationSubscriptionsSubtitle: "Nombre d’organisations actuellement sur chaque forfait web.",
            userSubscriptions: "Comptes par forfait utilisateur",
            userSubscriptionsSubtitle: "Nombre d’utilisateurs actuellement sur chaque forfait app, avec activité récente."
        },
        table: {
            organization: "Organisation",
            organizations: "Organisations",
            score: "Score",
            plan: "Forfait",
            divisions: "Divisions",
            teams: "Équipes",
            players: "Joueurs",
            users: "Utilisateurs",
            active7Days: "Actifs 7j",
            active30Days: "Actifs 30j",
            active90Days: "Actifs 90j",
            completed: "Terminés",
            type: "Type",
            total: "Total",
            active: "Actif",
            createdLast30Days: "Créés sur 30 jours"
        }
    },
    financial: {
        noticeTitle: "Attention :",
        noticeText1: "Les paiements traités via AngeonX Sports utilisent Stripe Connect.",
        noticeText2: "Stripe facture généralement",
        noticeText3: "par transaction, et AngeonX Sports applique des",
        noticeText4: "frais de plateforme (les abonnements ELITE ont des frais de 2.5%). Ces frais sont déduits avant le versement à la organisation.",
        example: "Exemple avec un paiement de {amount} → La organisation recevrait environ {net}.",

        filtersBadge: "Filtres",
        paymentsTitle: "Paiements",
        filtersSubtitle: "Choisissez l’organisation, la division, la saison et le statut.",
        resetFilters: "Réinitialiser les filtres",
        reset: "Réinitialiser",

        organization: "Organisation",
        selectLeague: "Sélectionner une ligue",
        division: "Division",
        selectDivision: "Sélectionner une division",
        season: "Saison",
        selectSeason: "Sélectionner une saison",
        status: "Statut",
        all: "Tous",
        pending: "En attente",
        paid: "Payé",

        autoRefreshHint: "Les changements actualisent automatiquement le tableau.",

        total: "Total",
        overall: "Global",
        outstanding: "En attente",

        tableTitle: "Paiements",
        tableHeaders: {
            status: "Statut",
            amount: "Montant",
            description: "Description",
            organization: "Organisation",
            season: "Saison",
            game: "Match",
            relatedObject: "Objet lié",
            profile: "Profil",
            createdAt: "Créé le",
            dueDate: "Date d’échéance",
            sanction: "Sanction"
        },

        noValue: "—"
    },
    feeCalculator: {
        badge: "Calc",
        subtitle: "Estimez les frais de la plateforme et de Stripe Connect.",
        currencyInUse: "Devise utilisée",

        currency: "Devise",
        amountPaid: "Montant payé",
        appFeePct: "Frais de l’app %",
        stripePct: "Stripe %",
        stripeFixed: "Frais fixes Stripe",

        breakdownTitle: "Détail",
        breakdownSubtitle: "Ces valeurs sont des estimations et peuvent varier selon le pays et le mode de paiement.",

        userPays: "L’utilisateur paie",
        kbolaFee: "Frais AngeonX Sports ({pct}%)",
        amountBeforeStripe: "Montant avant les frais Stripe",
        stripeFee: "Frais Stripe ({pct}% + {fixed})",
        organizationReceives: "L’organisation reçoit",

        stripeAccountNote: "Les frais Stripe sont facturés au compte connecté.",

        defaultTitle: "Calculateur de frais"
    },
    venuesPage: {
        pageTitle: "Installations",
        settings: "Paramètres",

        tableTitle: "Installations",
        headers: {
            name: "Nom",
            description: "Description",
            fields: "Terrains",
            createdBy: "Créé par",
            actions: "Actions"
        },

        noValue: "—",
        fieldTitle: "Terrain",

        editVenue: "Modifier l’installation",
        deleteVenue: "Supprimer l’installation",

        deleteConfirmTitle: "Supprimer l’installation ?",
        deleteConfirmMessage: "Vous êtes sur le point de supprimer \"{name}\".\n\nL’installation et ses terrains seront supprimés. Cela peut affecter les matchs programmés utilisant ces terrains.\n\nÊtes-vous sûr de vouloir continuer ?",
        deleteConfirmButton: "Supprimer l’installation",
        cancel: "Annuler",

        deleteSuccess: "Installation supprimée avec succès !",
        deleteFailed: "Échec de la suppression de l’installation.",
        loadFailed: "Échec du chargement des installations."
    },
    staffPage: {
        pageTitle: "Equipe",
        settings: "Paramètres",
        subtitle: "Managers et coordinateurs de vos ligues",
        searchPlaceholder: "Rechercher des managers ou coordinateurs...",
        noOrganizations: "Aucune ligue liée",
        noOrganizationName: "Ligue inconnue",
        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Gestion du personnel indisponible",
        upgradeSubtitle: "Cette fonctionnalité est disponible avec les plans Organization Enterprise.",
        upgradeCta: "Passer au plan supérieur",
        upgradeTextPrefix: "Pour gérer les managers et coordinateurs de vos organisations, veuillez",
        upgradeTextLink: "mettre à niveau votre abonnement",
        roles: {
            manager: "Manager",
            coordinator: "Coordinateur"
        }
    },
    playersPage: {
        pageTitle: "Joueurs",
        settings: "Paramètres",
        subtitle: "Joueurs et coachs de vos ligues",
        filtersBadge: "Filtres",
        filtersTitle: "Joueurs",
        filtersSubtitle: "Filtrez par organisation et rôle de profil.",
        search: "Rechercher",
        searchPlaceholder: "Rechercher par nom, courriel, téléphone, équipe ou organisation...",
        organization: "Organisation",
        allOrganizations: "Toutes les organisations",
        profile: "Profil",
        allProfiles: "Tous les profils",
        resetFilters: "Réinitialiser les filtres",
        reset: "Réinitialiser",
        download: "Télécharger",
        downloading: "Téléchargement...",
        downloadExcel: "Télécharger la liste filtrée en Excel",
        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Liste des joueurs indisponible",
        upgradeSubtitle: "Cette fonctionnalité est disponible avec les plans Organization Enterprise.",
        upgradeCta: "Passer au plan supérieur",
        upgradeTextPrefix: "Pour voir et exporter les joueurs et coachs de vos organisations, veuillez",
        upgradeTextLink: "mettre à niveau votre abonnement",
        autoRefreshHint: "Les changements actualisent automatiquement la liste.",
        noValue: "—",
        roles: {
            coach: "Coach",
            player: "Joueur"
        },
        gender: {
            male: "Masculin",
            female: "Féminin"
        },
        fields: {
            fullName: "Nom complet",
            email: "Courriel",
            phone: "Téléphone",
            gender: "Genre",
            dob: "Date de naissance",
            organization: "Organisation",
            activeTeam: "Équipe active",
            role: "Rôle",
            league: "Ligue"
        }
    },
    staffPicker: {
        title: "Ajouter un manager a l’organisation",
        organization: "Organisation",
        noOrganizations: "Aucune organisation disponible",
        profile: "Profil utilisateur",
        searchPlaceholder: "Rechercher des profils utilisateur...",
        add: "Ajouter",
        alreadyAdded: "Ajoute",
        loadError: "Impossible de charger les profils utilisateur.",
        noProfiles: "Aucun profil utilisateur disponible.",
        noSearchResults: "Aucun profil trouve pour cette recherche.",
        addSuccess: "Manager ajoute avec succes.",
        addError: "Impossible d’ajouter ce manager."
    },
    refereePicker: {
        title: "Ajouter un arbitre / umpire à l’organisation",
        organization: "Organisation", noOrganizations: "Aucune organisation disponible", profile: "Profil utilisateur",
        searchPlaceholder: "Rechercher des arbitres et umpires...", add: "Ajouter", alreadyAdded: "Ajouté",
        loadError: "Impossible de charger les arbitres.", noProfiles: "Aucun arbitre disponible.", noSearchResults: "Aucun arbitre trouvé.",
        addSuccess: "Arbitre ajouté avec succès.", addError: "Impossible d’ajouter cet arbitre."
    },
    table: {
        subtitle: "Gérez les éléments de cette liste",
        add: "Ajouter",
        loading: "Chargement…",
        noRecords: "Aucun enregistrement trouvé",
        prev: "Précédent",
        next: "Suivant",
        page: "Page",
        of: "sur",
        previousPage: "Page précédente",
        nextPage: "Page suivante",
        pagination: "Pagination",
        total: "Total",
        toggleDropdown: "Afficher les options",
        addItemTitle: "Ajouter {title}",
        goToPage: "Aller à la page {page}"
    },
    venueCreateModal: {
        "venueNameRequired": "Le nom du site est obligatoire.",
        "addressRequired": "Veuillez sélectionner une adresse valide.",
        "fieldLabel": "Terrain {{number}}",
        "removeField": "Supprimer",
        badge: "NOUVEAU",
        title: "Créer une installation",
        subtitle: "Ajoutez une installation et ses terrains.",

        close: "Fermer",

        venueName: "Nom de l’installation",
        venueNamePlaceholder: "ex. : Maple Sports Complex",

        description: "Description (optionnelle)",
        descriptionPlaceholder: "Toute note concernant cette installation…",

        address: "Adresse",
        addressPlaceholder: "Rechercher des installations sportives",

        fieldsTitle: "Terrains",
        itemsCount: "{count} élément(s)",

        fieldName: "Nom du terrain",
        fieldNamePlaceholder: "ex. : Terrain A",

        fieldDescription: "Description",
        fieldDescriptionPlaceholder: "ex. : Gazon, éclairage, taille…",

        addAnotherField: "Ajouter un autre terrain",
        addAnotherFieldTitle: "Ajouter un autre terrain",

        cancel: "Annuler",
        creating: "Création…",
        createVenue: "Créer une installation",

        validationAtLeastOneField: "Veuillez saisir au moins un terrain.",
        createSuccess: "Installation créée avec succès !",
        createFailed: "Échec de la création de l’installation."
    },
    venueEditModal: {
        "addressRequired": "Veuillez sélectionner une adresse valide.",
        "fieldLabel": "Terrain {{number}}",
        "existingField": "Existant",
        "newField": "Nouveau",
        "removeField": "Supprimer",
        badge: "MODIFIER",
        title: "Modifier l’installation",
        subtitle: "Mettez à jour les détails de l’installation et ses terrains.",

        close: "Fermer",

        venueName: "Nom de l’installation",
        venueNameRequired: "Le nom de l’installation est requis.",

        description: "Description (optionnelle)",

        address: "Adresse",
        addressPlaceholder: "Rechercher des installations sportives",

        fieldsTitle: "Terrains",
        itemsCount: "{count} élément(s)",

        fieldName: "Nom du terrain",
        fieldNamePlaceholder: "ex. : Terrain A",

        fieldDescription: "Description",
        fieldDescriptionPlaceholder: "ex. : Gazon, éclairage, taille…",

        addAnotherField: "Ajouter un autre terrain",

        cancel: "Annuler",
        saving: "Enregistrement…",
        updateVenue: "Mettre à jour l’installation",

        updateSuccess: "Installation mise à jour avec succès !",
        updateFailed: "Échec de la mise à jour de l’installation."
    },
    waiversPage: {
        pageTitle: "Décharges",
        settings: "Paramètres",

        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Gestion des décharges indisponible",
        upgradeSubtitle: "Cette fonctionnalité est disponible avec les plans Organization Pro/Elite.",
        upgradeCta: "Mettre à niveau",
        upgradeTextPrefix: "Pour créer et gérer des décharges pour vos organisations, veuillez",
        upgradeTextLink: "mettre à niveau votre abonnement",

        tableTitle: "Décharges",
        tableHeaders: {
            title: "Titre",
            type: "Type",
            language: "Langue",
            createdBy: "Créé par",
            actions: ""
        },

        noValue: "—",
        waiverTypeLabel: "Type de décharge",
        document: "Document",
        text: "Texte",
        view: "Voir",

        editWaiver: "Modifier la décharge",
        deleteWaiver: "Supprimer la décharge",

        createBadge: "NOUVEAU",
        createTitle: "Créer une décharge",
        createSubtitle: "Ajoutez une décharge (Texte ou Document) à votre organisation.",

        deleteConfirmTitle: "Supprimer la décharge",
        deleteConfirmMessage: "La décharge \"{title}\" sera supprimée définitivement. Les joueurs ne pourront plus la signer et toute demande de signature en attente deviendra invalide.\n\nÊtes-vous sûr de vouloir continuer ?",
        deleteConfirmButton: "Oui, supprimer",
        deleteCancelButton: "Non",

        createSuccess: "Décharge créée avec succès !",
        updateSuccess: "Décharge mise à jour avec succès !",
        deleteSuccess: "Décharge supprimée avec succès !",
        updateFailed: "Échec de la mise à jour de la décharge.",
        deleteFailed: "Échec de la suppression de la décharge.",
        loadFailed: "Échec du chargement des décharges."
    },

    createWaiverForm: {
        title: "Titre",
        titlePlaceholder: "ex. : Décharge de participation au tournoi",

        language: "Langue",
        waiverType: "Type de décharge",
        text: "Texte",
        documentPdf: "Document (PDF)",

        content: "Contenu",
        contentPlaceholder: "Rédigez ici le texte de la décharge…",
        contentHelper: "Conseil : restez clair et concis ; incluez la reconnaissance des risques et le consentement.",

        pdfDocument: "Document PDF",
        noFileSelected: "Aucun fichier sélectionné",
        pdfHelper: "Téléversez une décharge PDF que les participants pourront consulter et signer.",
        choosePdf: "Choisir un PDF",

        close: "Fermer",
        uploading: "Téléversement…",
        createWaiver: "Créer une décharge"
    },

    textWaiverModal: {
        title: "Contenu de la décharge",
        close: "Fermer"
    },

    waiverEditModal: {
        badge: "MODIFIER",
        title: "Modifier la décharge",
        subtitle: "Mettez à jour le titre, le type et le contenu.",

        close: "Fermer",
        titleLabel: "Titre",
        titlePlaceholder: "Titre de la décharge",
        titleHelper: "C’est le nom que les administrateurs verront dans les listes.",

        waiverType: "Type de décharge",
        text: "Texte",
        document: "Document",
        waiverTypeHelper: "Basculez entre texte et document. Téléversez un PDF pour le type Document.",
        language: "Langue",

        createdBy: "Créé par",
        readOnly: "Lecture seule.",

        content: "Contenu",
        contentPlaceholder: "Rédigez le texte de votre décharge...",
        contentHelper: "Gardez-le clair et juridiquement cohérent. Pensez à ajouter une section de reconnaissance de signature.",
        pdfDocument: "Document PDF",
        noFileSelected: "Aucun fichier sélectionné",
        pdfHelper: "Téléversez un nouveau PDF pour remplacer le document actuel (optionnel).",
        viewCurrentDocument: "Voir le document actuel",
        choosePdf: "Choisir un PDF",

        cancel: "Annuler",
        saving: "Enregistrement...",
        saveChanges: "Enregistrer les modifications"
    },
    sanctionRulesPage: {
        pageTitle: "Gestion des sanctions",
        settings: "Paramètres",
        rulesPageTitle: "Règles de sanction",

        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Gestion des règles de sanction indisponible",
        upgradeSubtitle: "Cette fonctionnalité est disponible avec les plans Organization Pro/Elite.",
        upgradeCta: "Mettre à niveau",
        upgradeTextPrefix: "Pour créer et gérer les sanctions et les règles pour vos organisations, veuillez",
        upgradeTextLink: "mettre à niveau votre abonnement",

        tableTitle: "Règles de sanction",
        tableSubtitle: "Créez et gérez les règles disciplinaires pour votre organisation.",
        tableHeaders: {
            name: "Nom",
            createdBy: "Créé par",
            actions: ""
        },

        noValue: "—",
        editRule: "Modifier la règle",
        deleteRule: "Supprimer la règle",

        createBadge: "NOUVEAU",
        createTitle: "Créer une règle de sanction",
        createSubtitle: "Définissez une règle disciplinaire pour votre organisation.",

        deleteConfirmTitle: "Supprimer la règle de sanction",
        deleteConfirmMessage: "La règle \"{name}\" sera supprimée définitivement.\n\nLes futures actions disciplinaires ne pourront plus faire référence à cette règle.\n\nÊtes-vous sûr de vouloir continuer ?",
        deleteConfirmButton: "Oui, supprimer",
        deleteCancelButton: "Non",

        createSuccess: "Règle de sanction créée avec succès !",
        updateSuccess: "Règle de sanction mise à jour avec succès !",
        deleteSuccess: "Règle de sanction supprimée avec succès !",
        updateFailed: "Échec de la mise à jour de la règle de sanction.",
        deleteFailed: "Échec de la suppression de la règle de sanction.",
        loadFailed: "Échec du chargement des règles de sanction."
    },
    createSanctionRuleForm: {
        sections: {
            basics: {
                title: "Informations de base",
                hint: "Identité de la règle et limite d’accumulation."
            },
            suspensions: {
                title: "Suspensions",
                hint: "Matchs appliqués selon le scénario de carton."
            },
            resets: {
                title: "Réinitialisations et exceptions",
                hint: "Contrôle la façon dont l’accumulation est réinitialisée."
            },
            fines: {
                title: "Amendes",
                hint: "Pénalités financières facultatives (laisser vide si aucune)."
            }
        },

        fields: {
            ruleName: "Nom de la règle",
            ruleNamePlaceholder: "ex. : Accumulation standard de cartons jaunes/rouges",

            maxAccumulatedYellowCards: "Maximum de cartons jaunes accumulés",
            accumulatedYellowSuspensionGames: "Suspension pour accumulation de cartons jaunes (matchs)",

            redCardSuspension: "Suspension pour carton rouge",
            doubleYellowSuspension: "Suspension pour double jaune",
            accumulatedYellowSuspension: "Suspension pour accumulation de cartons jaunes",

            yellowCardFine: "Amende pour carton jaune ($)",
            yellowCardFinePlaceholder: "ex. : 10.00",
            doubleYellowFine: "Amende pour double jaune ($)",
            doubleYellowFinePlaceholder: "ex. : 25.00",
            redCardFine: "Amende pour carton rouge ($)",
            redCardFinePlaceholder: "ex. : 50.00"
        },

        toggles: {
            resetOnRed: {
                title: "Réinitialiser les jaunes après un carton rouge",
                hint: "Utile lorsque le rouge est traité comme une remise à zéro complète."
            },
            resetOnDoubleYellow: {
                title: "Réinitialiser les jaunes après un double jaune",
                hint: "Efface l’accumulation lorsqu’un joueur est expulsé pour 2 jaunes."
            },
            overrideAccumulation: {
                title: "Le double jaune remplace la sanction d’accumulation",
                hint: "Évite d’empiler double jaune + sanction d’accumulation."
            },
            resetOnStageChange: {
                title: "Réinitialiser les jaunes au changement d’étape",
                hint: "Exemple : phase de groupes → séries éliminatoires."
            },
            resetSanctionsOnStageChange: {
                title: "Réinitialiser les sanctions au changement d’étape",
                hint: "Efface l’historique des suspensions/amendes au changement d’étape."
            }
        },

        close: "Fermer",
        creating: "Création...",
        create: "Créer une règle de sanction",

        success: "Règle de sanction créée.",
        error: "Échec de la création de la règle de sanction."
    },
    sanctionRuleEditModal: {
        badge: "MODIFIER",
        title: "Modifier la règle de sanction",
        subtitle: "Mettez à jour l’accumulation, les suspensions et les amendes facultatives.",

        close: "Fermer",
        saving: "Enregistrement...",
        saveChanges: "Enregistrer les modifications",

        sections: {
            core: {
                title: "Champs principaux",
                hint: "Configuration principale de la règle."
            },
            toggles: {
                title: "Réinitialisations et exceptions",
                hint: "Contrôle la façon dont l’accumulation est réinitialisée."
            },
            fines: {
                title: "Amendes",
                hint: "Pénalités financières facultatives (laisser vide si aucune)."
            }
        },

        fields: {
            ruleName: "Nom de la règle",
            ruleNamePlaceholder: "ex. : Discipline standard FIFA",
            maxAccumulatedYellowCards: "Maximum de cartons jaunes accumulés",
            maxAccumulatedYellowCardsHint: "Nombre maximal de cartons jaunes autorisés avant l’application de la suspension pour accumulation.",

            redCardSuspensionGames: "Suspension pour carton rouge (matchs)",
            accumulatedYellowSuspensionGames: "Suspension pour accumulation de cartons jaunes (matchs)",
            doubleYellowSuspensionGames: "Suspension pour double jaune (matchs)",

            yellowCardFine: "Amende pour carton jaune ($)",
            yellowCardFinePlaceholder: "ex. : 10.00",
            doubleYellowFine: "Amende pour double jaune ($)",
            doubleYellowFinePlaceholder: "ex. : 25.00",
            redCardFine: "Amende pour carton rouge ($)",
            redCardFinePlaceholder: "ex. : 50.00"
        },

        toggles: {
            resetOnRed: {
                title: "Réinitialiser les jaunes après un carton rouge",
                description: "Efface les cartons jaunes accumulés lorsqu’un carton rouge est donné."
            },
            resetOnDoubleYellow: {
                title: "Réinitialiser les jaunes après un double jaune",
                description: "Efface l’accumulation lorsqu’un joueur est expulsé pour 2 jaunes."
            },
            overrideAccumulation: {
                title: "Le double jaune remplace la sanction d’accumulation",
                description: "Évite d’empiler double jaune + sanction d’accumulation."
            },
            resetOnStageChange: {
                title: "Réinitialiser les jaunes au changement d’étape",
                description: "Exemple : phase de groupes → séries éliminatoires."
            },
            resetSanctionsOnStageChange: {
                title: "Réinitialiser les sanctions au changement d’étape",
                description: "Efface l’historique des suspensions/amendes au changement d’étape."
            }
        }
    },
    stripeAccountsPage: {
        pageTitle: "Comptes",
        payments: "Paiements",
        stripeAccounts: "Comptes Stripe",

        infoBadge: "INFO",
        infoTitle: "Frais Stripe Connect et frais de plateforme",
        infoSubtitle: "Estimez le versement net de la ligue pour un montant donné.",
        infoText1: "Les paiements traités via AngeonX Sports utilisent Stripe Connect. Stripe facture généralement",
        infoText2: "par transaction, et AngeonX Sports applique des",
        infoText3: "frais de plateforme. Ceux-ci sont déduits avant le versement à la ligue.",
        infoExample: "Exemple avec un paiement de {amount} → La ligue recevrait environ {net}.",

        tableTitle: "Comptes de paiement",
        tableSubtitle: "Gérez les comptes de paiement Stripe Connect pour votre organisation.",
        tableHeaders: {
            name: "Nom",
            email: "Courriel",
            country: "Pays",
            details: "Détails",
            last4: "4 derniers",
            status: "Statut",
            actions: ""
        },

        noValue: "—",
        detailsSubmittedYes: "✅",
        detailsSubmittedNo: "❌",

        verified: "Vérifié",
        needsVerification: "Vérification requise",
        completeVerification: "Compléter la vérification",
        completeVerificationTitle: "Complétez les exigences d’intégration dans Stripe",

        createTitle: "Créer un compte Stripe",
        close: "Fermer",

        onboardingLinkFailed: "Impossible d’obtenir le lien d’intégration.",
        onboardingLinkError: "Erreur lors de la génération du lien d’intégration Stripe"
    },
    createStripeAccountModal: {
        accountNickname: "Nom du compte",
        accountNicknamePlaceholder: "Compte Stripe de la ligue",
        accountNicknameHelper: "Une étiquette conviviale pour identifier ce compte de paiement dans AngeonX Sports.",

        country: "Pays",
        countryPlaceholder: "Choisissez un pays...",
        countryHelper: "Cela détermine le pays Stripe Connect pour les exigences d’intégration.",

        cancel: "Annuler",
        creating: "Création...",
        createAndOnboard: "Créer et intégrer",

        redirecting: "Redirection vers l’intégration Stripe...",
        onboardingLinkFailed: "Impossible de générer le lien d’intégration.",
        enterNameWarning: "Veuillez saisir un nom.",
        selectCountryWarning: "Veuillez sélectionner un pays.",
        somethingWentWrong: "Une erreur s’est produite"
    },
    stripeOnboardRetryPage: {
        brandAlt: "kBola Sports",
        title: "Configuration Stripe incomplète",
        message: "Vous n’avez pas terminé la configuration du compte. Veuillez réessayer.",
        retry: "Réessayer"
    },
    stripeOnboardSuccessPage: {
        brandAlt: "kBola Sports",
        title: "Configuration du compte Stripe terminée !",
        message: "Votre compte de paiement est prêt à recevoir des fonds."
    },
    subscriptionPage: {
        title: "Plans d’abonnement",
        subtitle: "Choisissez votre cycle de facturation et votre type d’abonnement. Les prix s’affichent dans la devise de votre profil ({currency}).",

        billing: {
            monthly: "Mensuel",
            yearly: "Annuel",
            yearlyOnly: "Annuel seulement",
            currency: "Devise"
        },

        audience: {
            individual: "Individuel",
            organization: "Organisation"
        },

        sections: {
            individualTitle: "Abonnements individuels (Application mobile)",
            individualHint: "Pour les joueurs, entraîneurs et parents utilisant l’application mobile AngeonX Sports. Débloquez des statistiques avancées, des outils d’alignement, le suivi des matchs et des expériences premium dans l’application.",
            organizationTitle: "Abonnements pour organisations (Gestion sur plateforme web)",
            organizationHint: "Pour les ligues, clubs et académies. Gérez saisons, calendriers, sanctions, paiements et outils administratifs depuis le tableau de bord web AngeonX Sports."
        },

        orgSelector: {
            badge: "Organisation",
            title: "Sélectionnez l’organisation qui recevra cet abonnement",
            hint: "Seules les organisations que vous pouvez gérer sont listées ici. L’abonnement sera appliqué aux outils de gestion web de l’organisation sélectionnée.",
            placeholder: "-- Choisir une organisation --"
        },

        plans: {
            current: "Actuel",
            bestValue: "Meilleur rapport qualité-prix",
            savePercent: "Économisez {percent}%",
            processing: "Traitement...",
            selectOrganization: "Choisir une organisation",
            subscribe: "S’abonner",
            cancelSubscription: "Annuler l’abonnement",
            noPriceAvailable: "Aucun prix disponible pour votre devise.",
            orgRequired: "Veuillez sélectionner une organisation pour cet abonnement.",
            checkoutFailed: "Impossible de créer la session de paiement.",
            cancelFailed: "Erreur lors de l’annulation de l’abonnement"
        },

        options: {
            "plans": {
                "free": "Gratuit",
                "pro": "Pro",
                "elite": "Élite",
                "trial": "Essai",
                "test": "Test",
                "enterprise": "Entreprise"
            },
            "features": {
                "elite_confirm_attendance": {
                    "label": "Confirmer la présence aux événements",
                    "description": "Accès pour confirmer la présence aux événements auxquels vous êtes invité."
                },
                "free_limited_events": {
                    "label": "Seulement 2 événements actifs",
                    "description": "Vous pouvez voir et interagir avec les événements auxquels vous êtes invité.\nVous pouvez créer jusqu’à 2 événements actifs.\nVous pouvez inviter des coéquipiers à vos événements.\nVous ne pouvez pas ajouter de participants externes par e-mail."
                },
                "free_in_app_notifications": {
                    "label": "Notifications basiques dans l’app",
                    "description": "Notifications basiques uniquement lorsque l’app est active.\nAucune notification push lorsque l’app est fermée ou en arrière-plan."
                },
                "free_limited_chat": {
                    "label": "Messagerie limitée",
                    "description": "Messagerie limitée.\nUniquement les salons d’équipe.\nStockage des 50 derniers messages par salon.\nPas de conversations privées."
                },
                "free_basic_preferences": {
                    "label": "Préférences basiques",
                    "description": "Préférences basiques.\nPas de préférences sportives ni de postes préférés sur le terrain.\nFaible visibilité dans Connect."
                },
                "free_single_profile": {
                    "label": "Un seul profil",
                    "description": "Vous ne pouvez créer et utiliser qu’un seul profil avec ce forfait."
                },
                "free_single_team": {
                    "label": "Gérer une seule équipe",
                    "description": "Créez et gérez une équipe en tant que manager avec ce forfait."
                },
                "free_marketplace_features": {
                    "label": "Connect basique",
                    "description": "Connect basique.\nPas de filtres avancés pour trouver joueurs, arbitres, équipes ou organisations.\nPas de Vue Carte exclusive pour la distance ou les filtres de localisation.\nPas de filtres selon les préférences sportives.\nFaible visibilité pour votre profil et votre équipe."
                },
                "free_push_notifications": {
                    "label": "Pas de notifications push",
                    "description": "Vous ne recevrez pas de notifications push pour les invitations d’équipe ou d’organisation.\nSeules des notifications limitées dans l’app sont disponibles."
                },
                "free_no_referee_reviews": {
                    "label": "Pas d’avis sur les arbitres",
                    "description": "Aucun accès pour évaluer les arbitres/umpires ni consulter leurs avis."
                },
                "free_no_ai": {
                    "label": "Pas de recommandations IA",
                    "description": "Aucune fonctionnalité d’IA.\nAucune suggestion d’organisation/équipe/tournoi basée sur les statistiques ou préférences.\nAucune prévision de probabilité de victoire par IA."
                },
                "free_no_performance_insights": {
                    "label": "Pas d’analyses de performance avec IA",
                    "description": "Aucune analyse de performance avec l’IA.\nAucun conseil pour améliorer ou faire progresser votre carrière."
                },
                "free_no_streams_highlights": {
                    "label": "Pas d’accès aux diffusions & faits saillants",
                    "description": "Vous ne pouvez pas regarder des matchs en direct ni des résumés pour les événements liés à vous (équipes, ligues, joueurs suivis)."
                },
                "free_no_custom_support": {
                    "label": "Pas d’assistance personnalisée",
                    "description": "Ce forfait n’inclut pas d’assistance personnalisée."
                },
                "pro_manage_events": {
                    "label": "Gérer ses propres événements",
                    "description": "Gérez entièrement vos événements.\nCréez un nombre illimité d’événements.\nInvitez des participants supplémentaires par e-mail."
                },
                "pro_receive_push_notifications": {
                    "label": "Recevoir des notifications push",
                    "description": "Recevez des notifications push pour certaines activités liées à vos événements, équipes, résultats et invitations."
                },
                "pro_full_chat": {
                    "label": "Messagerie complète",
                    "description": "Accès complet à la messagerie.\nSalons d’équipe.\nConversations privées."
                },
                "pro_referee_reviews": {
                    "label": "Avis sur les arbitres/umpires",
                    "description": "Évaluez la performance des arbitres/umpires.\nConsultez leurs avis."
                },
                "pro_advanced_preferences": {
                    "label": "Préférences avancées",
                    "description": "Préférences complètes sur vos profils.\nIndiquez aux managers et recruteurs vos sports et postes préférés.\nAidez-les à vous trouver plus facilement."
                },
                "pro_detailed_results": {
                    "label": "Résultats détaillés & en direct",
                    "description": "Résultats détaillés et en direct des matchs.\nSaisissez les statistiques individuelles des joueurs.\nGérez les sanctions dans vos organisations.\nMises à jour du gamecast en temps réel pendant le match."
                },
                "social_media_sharable": {
                    "label": "Partager sur les réseaux sociaux",
                    "description": "Partagez résultats, classements, calendriers et événements sur les réseaux sociaux."
                },
                "pro_multi_profiles_limited": {
                    "label": "Gérer jusqu’à 3 profils",
                    "description": "Créez et gérez jusqu’à 3 profils avec votre compte."
                },
                "pro_team_management_limited": {
                    "label": "Gérer jusqu’à 3 équipes",
                    "description": "Créez et gérez jusqu’à 3 équipes avec votre compte."
                },
                "pro_marketplace_features": {
                    "label": "Connect pour Pro",
                    "description": "Filtres complets de Connect.\nFiltres par sport.\nFiltres par localisation.\nVue Carte pour une recherche plus rapide.\nVisibilité moyenne dans Connect."
                },
                "pro_custom_support": {
                    "label": "Support personnalisé Pro",
                    "description": "Accès à un support personnalisé de base.\nSignalez des problèmes et faites-les résoudre.\nDemandez des tutoriels et des vidéos.\nPas de chat en direct."
                },
                "elite_marketplace_features": {
                    "label": "Connect pour joueurs Élite",
                    "description": "Accès complet à Connect.\nFiltres complets.\nHaute visibilité pour vos profils et équipes.\nLes managers et recruteurs vous trouveront plus vite."
                },
                "elite_ai_win_forecast": {
                    "label": "Prévision IA : probabilité de victoire",
                    "description": "Prédictions de résultats.\nProbabilité de victoire basée sur les stats passées, la fiche des équipes et l’adversaire."
                },
                "elite_profile_performance_insights": {
                    "label": "Performance avec analyses IA (joueurs)",
                    "description": "Recevez des conseils et analyses de performance alimentés par l’IA."
                },
                "elite_streams_highlights": {
                    "label": "Accès aux diffusions & faits saillants",
                    "description": "Accédez aux diffusions de matchs et aux résumés.\nProfitez de replays ou de matchs complets en direct."
                },
                "elite_chat_support": {
                    "label": "Support personnalisé",
                    "description": "Support entièrement personnalisé.\nSignalez des problèmes et obtenez une résolution rapide.\nDemandez des tutoriels et des vidéos.\nSupport par chat en direct."
                },
                "elite_multi_profiles_unlimited": {
                    "label": "Profils illimités",
                    "description": "Créez autant de profils que vous le souhaitez.\nAucune limite de profils."
                },
                "elite_team_management_unlimited": {
                    "label": "Gestion illimitée d’équipes",
                    "description": "Créez autant d’équipes que vous le souhaitez.\nAucune limite d’équipes."
                },
                "free_single_organization": {
                    "label": "Une seule organisation",
                    "description": "Gérez une seule organisation avec ce forfait."
                },
                "free_limited_divisions": {
                    "label": "Jusqu’à 3 divisions/catégories",
                    "description": "Créez et gérez jusqu’à 3 divisions ou catégories."
                },
                "free_limited_seasons": {
                    "label": "Une saison par division/catégorie",
                    "description": "Créez et gérez jusqu’à 1 saison par division ou catégorie."
                },
                "free_ai_scheduling": {
                    "label": "Planification assistée par IA",
                    "description": "Générez des calendriers optimisés en quelques secondes grâce à l’IA. Résolvez automatiquement les conflits, assignez les arbitres et équilibrez les terrains et horaires selon les disponibilités, lieux et règles de ligue."
                },
                "free_global_results": {
                    "label": "Résultats globaux des matchs",
                    "description": "Saisissez les résultats globaux des matchs.\nLes résultats sont saisis après le match.\nAucune statistique individuelle.\nAucun résultat détaillé par match."
                },
                "free_no_print_results": {
                    "label": "Calendrier basique partageable et imprimable",
                    "description": "Gérez les calendriers dans la plateforme.\nImprimez et partagez un calendrier et une feuille de match génériques."
                },
                "free_no_import_export_schedule": {
                    "label": "Aucun import ou export de calendrier",
                    "description": "Aucun accès pour importer ou exporter les calendriers."
                },
                "free_basic_notifications": {
                    "label": "Notifications basiques",
                    "description": "Notifications automatiques basiques pour les managers et arbitres/umpires.\nCalendrier créé.\nChangements de match."
                },
                "pro_limited_management": {
                    "label": "Gérer 5 divisions et des saisons illimitées",
                    "description": "Créez et gérez jusqu’à 5 divisions et un nombre illimité de saisons."
                },
                "pro_print_schedule": {
                    "label": "Calendrier personnalisé imprimable et partageable",
                    "description": "Calendriers professionnels imprimables et partageables par sport avec les formats AngeonX Sports."
                },
                "pro_automatic_notifications": {
                    "label": "Notifier tout le monde",
                    "description": "Envoyez des notifications à tous les participants concernés lorsqu’un calendrier est créé ou mis à jour."
                },
                "pro_push_notifications": {
                    "label": "Module de notifications",
                    "description": "Accédez au module de notifications.\nEnvoyez des notifications personnalisées aux managers et arbitres/umpires de vos organisations."
                },
                "elite_full_notifications": {
                    "label": "Module complet de notifications",
                    "description": "Accédez au module de notifications.\nEnvoyez des notifications personnalisées à vos organisations.\nInclut filtres et segmentation."
                },
                "elite_ai_result_forecast": {
                    "label": "Prévision IA : probabilité de victoire pour organisations",
                    "description": "Utilisez l’IA pour prévoir les probabilités de victoire des prochains matchs d’organisation selon les performances passées, les statistiques adverses et les tendances historiques."
                },
                "elite_stream_games": {
                    "label": "Diffusion de matchs et faits saillants",
                    "description": "Diffusez les matchs en direct et téléversez les faits saillants depuis le terrain. Permettez aux familles, fans et recruteurs de regarder les matchs en temps réel ou de revoir les moments clés dans l’app."
                },
                "elite_download_game_stats": {
                    "label": "Télécharger les statistiques de match",
                    "description": "Exportez des statistiques détaillées et résumés de match en PDF ou Excel pour consultation ou partage."
                },
                "elite_custom_branding": {
                    "label": "Image de marque personnalisée",
                    "description": "Ajoutez le logo, les couleurs et l’identité de votre organisation aux calendriers, résultats et pages de profil.\nInclut une page d’accueil dédiée pour votre organisation."
                },
                "elite_referee_management_dashboard": {
                    "label": "Outils de gestion des arbitres",
                    "description": "Gérez les assignations, suivez les disponibilités et collectez les évaluations de performance des arbitres et umpires."
                },
                "free_standing": {
                    "label": "Classements basiques",
                    "description": "Classements basiques pour les organisations.\nAucun point de sanction au classement.\nAucun point bonus au classement."
                },
                "pro_standing": {
                    "label": "Fonctionnalités Pro de classement",
                    "description": "Classements Pro pour les organisations.\nInclut les points de sanction et les points bonus."
                },
                "waiver_management": {
                    "label": "Gestion des décharges",
                    "description": "Gérez les décharges pour les organisations, divisions, saisons et équipes."
                },
                "sanction_management": {
                    "label": "Gestion des sanctions",
                    "description": "Gérez les règles de sanctions pour les organisations, divisions, saisons et équipes."
                },
                "venues_management": {
                    "label": "Gestion des sites et installations",
                    "description": "Gérez les sites et installations pour les organisations, divisions, saisons et équipes."
                },
                "entity_picture": {
                    "label": "Image d’entité",
                    "description": "Téléversez une image pour une organisation, division, saison ou équipe."
                },
                "elite_live_results": {
                    "label": "Résultats de match en direct",
                    "description": "Résultats détaillés et en direct des matchs.\nSaisissez les statistiques individuelles des joueurs.\nGérez les sanctions dans vos organisations.\nDiffusez les résultats de match en temps réel."
                },
                "elite_limited_organizations": {
                    "label": "Divisions et saisons illimitées",
                    "description": "Créez et gérez un nombre illimité de divisions et de saisons."
                },
                "enterprise_chat_support": {
                    "label": "Support complet prioritaire",
                    "description": "Accédez à un support complet, personnalisé et prioritaire.\nSignalez les problèmes et obtenez une résolution rapide.\nDemandez des documents et vidéos tutoriels.\nSupport par chat en direct."
                },
                "chat_media_messages": {
                    "label": "Messages multimédias dans le chat",
                    "description": "Envoyez et consultez des fichiers multimédias, y compris des images, dans les messages de chat."
                },
                "enterprise_organizations_unlimited": {
                    "label": "Divisions et saisons illimitées",
                    "description": "Créez et gérez un nombre illimité de divisions et de saisons."
                },
                "manage_player_picture": {
                    "label": "Gérer les images des joueurs",
                    "description": "Permet aux managers d’organisation de téléverser des images pour leurs joueurs."
                },
                "manage_team_players": {
                    "label": "Gérer les joueurs des équipes",
                    "description": "Permet aux managers d’organisation de gérer les joueurs des équipes."
                },
                "enterprise_user_management": {
                    "label": "Gestion des utilisateurs",
                    "description": "Créez des utilisateurs, attribuez des joueurs, entraîneurs et coordinateurs, envoyez des e-mails d’activation et importez des structures d’organisation."
                },
                "import_schedule_from_file": {
                    "label": "Importer un calendrier depuis un fichier .xlsx",
                    "description": "Permet aux managers d’organisation d’importer des calendriers depuis des fichiers .xlsx."
                },
                "in_app_advertising": {
                    "label": "Publicité dans l’app",
                    "description": "Permet aux organisations d’utiliser la publicité dans l’app pour promouvoir événements, activités et produits de commanditaires."
                },
                "event_sync_calendar": {
                    "label": "Synchroniser les événements avec le calendrier",
                    "description": "Synchronisez vos événements avec le calendrier de votre appareil."
                },
                "pro_event_photos": {
                    "label": "Photos d’événement",
                    "description": "Permet aux utilisateurs de télécharger jusqu’à 3 photos par événement."
                },
                "elite_event_photos": {
                    "label": "Photos d’événement",
                    "description": "Permet aux utilisateurs de télécharger jusqu’à 5 photos par événement"
                },
                "enterprise_event_photos": {
                    "label": "Photos d’événement",
                    "description": "Permet aux utilisateurs de télécharger jusqu’à 10 photos par événement."
                },
                "marketplace_manage_listing_free": {"label": "Gérer jusqu’à 3 annonces du marketplace", "description": "Créez et gérez jusqu’à 3 annonces sportives actives."},
                "marketplace_manage_listing_pro": {"label": "Gérer jusqu’à 10 annonces du marketplace", "description": "Créez et gérez jusqu’à 10 annonces sportives actives."},
                "marketplace_manage_listing_elite": {"label": "Annonces illimitées du marketplace", "description": "Créez et gérez un nombre illimité d’annonces sportives actives."},
                "enterprise_marketplace_buy_sell_listings": {"label": "Annonces illimitées du marketplace", "description": "Créez et gérez un nombre illimité d’annonces actives pour votre organisation."},
                "marketplace_manage_listing_trial": {"label": "Gérer jusqu’à 3 annonces du marketplace", "description": "Créez et gérez jusqu’à 3 annonces sportives actives pendant votre essai."}
            }
        },

        billingSuffix: {
            month: "/ mois",
            year: "/ an"
        },

        confirmCancel: {
            title: "Confirmer l’annulation",
            message: "Vous êtes sur le point d’annuler votre abonnement actuel. Êtes-vous sûr de vouloir le faire ?",
            yes: "Oui",
            no: "Non"
        },

        customPlan: {
            title: "Besoin d’un abonnement sur mesure ?",
            body1: "Que vous gériez une petite académie locale ou une organisation à plusieurs ligues, nous savons que chaque structure et chaque budget sont différents.",
            body2: "Si nos plans standards vous semblent trop grands, trop petits ou trop coûteux pour votre réalité, contactez-nous et nous travaillerons avec vous sur une solution adaptée à vos besoins.",
            body3: "Contactez-nous à",
            body4: "et nous vous aiderons à trouver la bonne configuration. Vous pouvez aussi demander un",
            freeTrial: "compte d’essai GRATUIT"
        },

        accessibility: {
            featureLevel: "Niveau de fonctionnalité {level} sur {total}"
        }
    },
    invoicesPage: {
        title: "Factures d’abonnement",
        subtitle: "Factures de votre abonnement mobile. Les dates sont affichées dans votre fuseau horaire local ({timezone}).",

        actions: {
            refresh: "Actualiser"
        },

        table: {
            title: "Factures",
            headers: {
                subscription: "Abonnement",
                type: "Type",
                status: "Statut",
                amountPaid: "Montant payé",
                amountDue: "Montant dû",
                period: "Période",
                view: "Voir"
            }
        },

        status: {
            paid: "PAYÉE",
            open: "OUVERTE"
        }
    },
    organizations: {
        "pageTitle": "Organisations",

        "removeSuccess": "L'organisation a été supprimée avec succès",
        "removeFailed": "Impossible de supprimer l'organisation",
        "removeError": "Erreur lors de la suppression de l'organisation",

        "confirmArchiveTitle": "Archiver l'organisation ?",
        "confirmArchiveMessage": "Cela archivera l'organisation et les données associées : divisions, saisons, équipes, joueurs, statistiques, etc. Êtes-vous sûr ?",
        "confirmArchive": "Archiver",
        "cancel": "Annuler",

        "locationFallback": "Gérez divisions, saisons, équipes et statistiques en un seul endroit.",

        "divisions": "Divisions",
        "seasons": "Saisons",
        "teams": "Équipes",

        "openDivisions": "Ouvrir les divisions",
        "downloadImportTemplate": "Télécharger le modèle d'importation",
        "downloadingImportTemplate": "Préparation du modèle...",
        "importTemplateDownloaded": "Modèle d'importation téléchargé",
        "importTemplateDownloadError": "Impossible de télécharger le modèle d'importation.",
        "importExistingData": "Importer les données existantes",
        "importDataBadge": "DONNÉES",
        "closeImport": "Fermer",
        "importMappingHint": "Téléversez un fichier Excel ou CSV. Nous lirons chaque feuille et proposerons des correspondances avant l'importation.",
        "sourceColumn": "Colonne source",
        "kbolaField": "Champ AngeonX Sports",
        "sampleValue": "Valeur exemple",
        "ignoreColumn": "Ignorer la colonne",
        "missingRequiredFields": "Champs obligatoires manquants",
        "requiredFieldsMapped": "Tous les champs obligatoires sont associés pour cette feuille.",
        "validateMapping": "Valider les correspondances",
        "importUnsupportedFile": "Sélectionnez un fichier Excel ou CSV.",
        "importNoSheets": "Aucune feuille importable trouvée.",
        "importFileParsed": "Fichier lu. Vérifiez les correspondances de colonnes.",
        "importParseError": "Impossible de lire le fichier d'importation.",
        "importMissingRequiredFields": "Associez tous les champs obligatoires avant de continuer.",
        "importMappingReady": "Les correspondances sont prêtes pour l'étape d'importation.",
        "validatingMapping": "Validation...",
        "importValidationError": "Impossible de valider les correspondances d'importation.",
        "importRowValidationError": "Vérifiez les lignes signalées avant de continuer.",
        "importRowErrors": "Lignes nécessitant une attention",
        "importRowErrorsShort": "erreurs",
        "importRowLabel": "Ligne {{row}} :",
        "importStructure": "Importer la structure",
        "importingStructure": "Importation de la structure...",
        "importStructureSuccess": "Toutes les données révisées de l’organisation ont été importées.",
        "importStructureError": "Impossible d'importer la structure de l'organisation.",
        "sendActivationEmails": "Envoyer les e-mails d’activation",
        "sendingActivationEmails": "Envoi des e-mails d’activation...",
        "activationEmailsSent": "E-mails d’activation envoyés.",
        "activationEmailsError": "Impossible d’envoyer les e-mails d’activation.",
        "manageActivations": "Gérer les activations",
        "activationPanelTitle": "Activation des utilisateurs importés",
        "activationPanelHint": "Nous enverrons un e-mail d’activation afin que chaque utilisateur puisse définir son mot de passe et accéder à la plateforme.",
        "pendingActivations": "activations en attente",
        "sendAllActivations": "Envoyer l’e-mail d’activation",
        "loadingActivations": "Chargement du statut d’activation...",
        "noPendingActivations": "Tous les comptes importés sont activés.",
        "activationAccount": "Compte", "activationType": "Rôle", "activationStatusLabel": "Statut", "activationAction": "Action", "activationAccountType": "Type de compte",
        "resendActivation": "Renvoyer", "sendActivationEmail": "Envoyer l’e-mail d’activation", "activationSent": "E-mail d’activation envoyé.", "activationPartial": "{{count}} e-mail(s) d’activation envoyé(s) ; certains comptes n’ont pas pu être contactés.", "activationSendError": "Impossible d’envoyer cet e-mail d’activation.", "activationLoadError": "Impossible de charger le statut d’activation.", "searchActivations": "Rechercher par nom ou e-mail", "clearSearch": "Effacer la recherche", "activationLastSent": "Dernier e-mail", "confirmSendActivations": "Envoyer les e-mails d’activation à tous les utilisateurs en attente ?", "confirmResendActivation": "Envoyer un e-mail d’activation à cet utilisateur ?", "refreshActivations": "Actualiser le statut d’activation", "createUserTitle": "Créer un utilisateur et envoyer l’activation", "createUserSubtitle": "L’utilisateur recevra un e-mail pour définir un mot de passe et accéder à la plateforme.", "createUserOrganization": "Organisation", "createUserChooseOrganization": "Choisir une organisation", "createUserRole": "Rôle", "createUserRoles": {"player": "Joueur", "coach": "Entraîneur", "coordinator": "Coordinateur", "referee": "Arbitre"}, "createUserFirstName": "Prénom", "createUserLastName": "Nom", "createUserEmail": "E-mail", "createUserMobile": "Mobile", "createUserDob": "Date de naissance", "createUserSaving": "Création de l’utilisateur...", "createUserSubmit": "Créer et envoyer l’activation", "createUserActivationSent": "Utilisateur créé et e-mail d’activation envoyé.", "createUserExistingAccount": "Utilisateur existant ajouté.", "createUserError": "Impossible de créer l’utilisateur.",
        "createUserOptional": "facultatif",
        "activationFilters": {"all": "Tous", "player": "Joueurs", "coach": "Entraîneurs", "referee": "Arbitres"},
        "activationStatus": {"pending": "En attente", "sent": "Envoyé", "activated": "Activé"},
        "chooseImportFile": "Choisir un fichier à importer",
        "importSupportedFiles": "Les classeurs Excel peuvent contenir plusieurs feuilles; les fichiers CSV en contiennent une.",
        "parsingImportFile": "Lecture du fichier...",
        "chooseFile": "Choisir un fichier",
        "noImportFile": "Aucun fichier sélectionné",
        "importFileHint": "Formats pris en charge : .xlsx, .xls, .csv",
        "clearImport": "Effacer le fichier sélectionné",
        "importSheets": "Feuilles d'importation",
        "importPreview": "Aperçu des données",
        "importPreviewLimit": "Affichage des 10 premières lignes",
        "importReviewSummary": "Résumé de la révision de l’importation",
        "importSummarySheets": "feuilles",
        "importSummaryRows": "lignes",
        "importSummaryErrors": "erreurs",
        "importFields": {
            "externalId": "ID externe", "divisionExternalId": "ID externe de division", "division": "Division", "name": "Nom", "description": "Description", "sport": "Sport", "mountDistance": "Distance du monticule", "pitchLimit": "Limite de lancers", "restingGames": "Matchs de repos", "gameDuration": "Durée du match", "registrationStartDate": "Début des inscriptions", "registrationEndDate": "Fin des inscriptions", "startDate": "Date de début", "endDate": "Date de fin", "lateRegistrationUntil": "Inscriptions tardives jusqu'au", "state": "État", "registrationFeeType": "Type de frais", "lateRegistrationFee": "Frais d'inscription tardive", "seasonExternalId": "ID externe de saison", "season": "Saison", "scheduleType": "Type de calendrier", "minGamesRequired": "Minimum de matchs", "gamesMode": "Format des matchs", "qtyTeamsQualified": "Équipes qualifiées", "qtyTeamsAdditional": "Équipes supplémentaires", "stageExternalId": "ID externe d'étape", "stage": "Étape", "teamExternalId": "ID externe d'équipe", "team": "Équipe", "teamAliasName": "Alias de l'équipe", "email": "Courriel", "mobile": "Mobile", "firstName": "Prénom", "lastName": "Nom de famille", "dob": "Date de naissance", "gender": "Genre", "shirtNumber": "Numéro", "position": "Position", "note": "Note", "isActive": "Actif", "status": "Statut", "contact": "Courriel ou mobile"
        },
        "upgrade": "Mettre à niveau",
        "coordinators": "Coordinateurs",

        "brandingTheme": "Marque et Thème",
        "editOrganization": "Modifier l'organisation",
        "archiveOrganization": "Archiver l'organisation",

        "planFree": "Gratuit",
        "planTrial": "Essai",
        "planPaid": "Payant"
    },
    addOrganization: {
        "title": "Nouvelle organisation",
        "newBadge": "NOUVELLE",
        "close": "Fermer",
        "save": "Enregistrer",

        "basics": "Informations de base",
        "logoLabel": "Logo de l'organisation (optionnel)",
        "logoHint": "Recommandé : format 1:1, PNG ou JPG",
        "name": "Nom",
        "namePlaceholder": "Nom de l'organisation",
        "organizationType": "Type d'organisation",
        "typeLeague": "Ligue / Tournoi",
        "typeAcademy": "Académie / École",
        "organizationTypeHint": "Cela aide AngeonX Sports à adapter les paramètres par défaut (divisions, saisons, règles) pour l'organisation.",

        "location": "Emplacement",
        "address": "Adresse",
        "addressPlaceholder": "Rechercher un lieu",
        "addressHint": "Utilisé pour les cartes, les distances de déplacement et la découverte locale. Vous pourrez le modifier plus tard.",

        "venues": "Sites",
        "availableFields": "Terrains disponibles",
        "selectedFields": "Terrains sélectionnés",

        "billing": "Facturation",
        "currency": "Devise",
        "selectCurrency": "— Sélectionnez une devise —",
        "currencyHint": "La devise s'appliquera aux frais, factures et paiements de cette organisation.",
        "stripeAccount": "Compte de paiement Stripe (optionnel, uniquement pour les paiements en ligne)",
        "noAccount": "— Aucun compte —",
        "stripeAccountHint": "Si vous prévoyez d'accepter des paiements en ligne, connectez un compte Stripe plus tard ou sélectionnez-en un maintenant.",
        "streamingProvider": "Fournisseur de diffusion",
        "useAngeonxDefault": "Utiliser le fournisseur AngeonX par défaut",
        "youtubeAccount": "Compte YouTube",
        "streamingProviderHint": "Choisissez le compte YouTube utilisé pour les directs de cette organisation.",

        "pleaseEnterText": "Veuillez saisir du texte",
        "noActiveProfile": "Aucun profil actif sélectionné.",
        "createError": "Erreur lors de la création de l'organisation.",
        "createdSuccess": "Organisation créée avec succès",
        "logoUploadFailedWithErrors": "L'organisation a été créée, mais l'envoi du logo a échoué : {{errors}}",
        "logoUploadFailedWithMessage": "L'organisation a été créée, mais l'envoi du logo a échoué : {{message}}",
        "selectActiveProfileFirst": "Sélectionnez d'abord un profil actif",
        "createOrganization": "Créer l'organisation"
    },
    editOrganization: {
        "title": "Modifier l'organisation",
        "editBadge": "MODIFIER",
        "close": "Fermer",
        "save": "Enregistrer",
        "saving": "Enregistrement...",
        "saveChanges": "Enregistrer les modifications",

        "basics": "Informations de base",
        "logoLabel": "Logo de l'organisation (optionnel)",
        "logoHint": "Recommandé : format 1:1, PNG ou JPG",
        "name": "Nom",
        "namePlaceholder": "Nom de l'organisation",
        "organizationType": "Type d'organisation",
        "typeLeague": "Ligue / Tournoi",
        "typeAcademy": "Académie / École",
        "organizationTypeHint": "Cela aide AngeonX Sports à adapter les paramètres par défaut (divisions, saisons, règles) pour l'organisation.",

        "location": "Emplacement",
        "address": "Adresse",
        "addressPlaceholder": "Rechercher un lieu",
        "addressHint": "Utilisé pour les cartes, les distances de déplacement et la découverte locale.",

        "venues": "Sites",
        "availableFields": "Terrains disponibles",
        "selectedFields": "Terrains sélectionnés",

        "policiesAndRules": "Politiques et règles",
        "waiverOptional": "Décharge (optionnelle)",
        "noWaiver": "— Aucune décharge —",
        "sanctionRuleOptional": "Règle de sanction (optionnelle pour le soccer)",
        "noRule": "— Aucune règle —",

        "billing": "Facturation",
        "currency": "Devise",
        "selectCurrency": "— Sélectionnez une devise —",
        "currencyHint": "La devise s'applique aux frais, factures et paiements de cette organisation.",
        "stripeAccount": "Compte de paiement Stripe (optionnel, uniquement pour les paiements en ligne)",
        "noAccount": "— Aucun compte —",
        "stripeAccountHint": "Si vous prévoyez d'accepter des paiements en ligne, connectez un compte Stripe plus tard ou sélectionnez-en un maintenant.",

        "updatedSuccess": "Organisation mise à jour avec succès",
        "logoUploadFailedWithErrors": "L'organisation a été mise à jour, mais l'envoi du logo a échoué : {{errors}}",
        "logoUploadFailedWithMessage": "L'organisation a été mise à jour, mais l'envoi du logo a échoué : {{message}}",
        "noDetailsForInput": "Aucun détail disponible pour la saisie : '{{name}}'"
    },
    filePicker: {
        "ariaLabel": "Sélecteur de fichier",
        "chooseFile": "Choisir un fichier",
        "existingImage": "Image existante",
        "noFileSelected": "Aucun fichier sélectionné",
        "dragDropHint": "Glissez-déposez ici un logo carré (PNG/JPG). Recommandé : 1:1.",
        "remove": "Supprimer",
        "logoPreview": "Aperçu du logo",
        "preview": "Aperçu"
    },
    editOrganizationBranding: {
        "badge": "MARQUE",
        "title": "Marque et thème – {{name}}",
        "close": "Fermer",
        "save": "Enregistrer",
        "saving": "Enregistrement...",
        "saveBranding": "Enregistrer la marque",
        "updateFailed": "Échec de la mise à jour de la marque",
        "updatedSuccess": "La marque a été mise à jour avec succès",

        "identity": "Identité",
        "logoLabel": "Logo de marque (optionnel)",
        "logoHint": "Ce logo est utilisé dans l’en-tête et la section hero du portail personnalisé. Recommandé : PNG avec fond transparent.",
        "subdomain": "Sous-domaine",
        "subdomainPlaceholder": "ma-ligue",
        "subdomainHint": "Cela devient l’URL personnalisée, par exemple : {{subdomain}}.kbolasport.com",
        "enablePortal": "Activer le portail personnalisé pour cette organisation",

        "brandColors": "Couleurs de marque",
        "primary": "Primaire",
        "secondary": "Secondaire",
        "accent": "Accent",
        "resetDefaults": "Réinitialiser aux valeurs par défaut de AngeonX Sports",
        "brandColorsHint": "Ces couleurs pilotent les boutons, les mises en avant et les accents clés dans le portail personnalisé.",

        "backgroundSurface": "Arrière-plan et surface",
        "background": "Arrière-plan",
        "surface": "Surface",
        "border": "Bordure",
        "backgroundSurfaceHint": "L’arrière-plan est la couleur principale de la page ; la surface est utilisée pour les cartes et panneaux.",

        "textColors": "Couleurs du texte",
        "textOnBackground": "Texte sur arrière-plan",
        "textOnSurface": "Texte sur surface",
        "textOnPrimary": "Texte sur primaire",
        "textOnSecondary": "Texte sur secondaire",

        "backgroundPreview": "Aperçu de l’arrière-plan",
        "backgroundPreviewTitle": "AngeonX Sports – Arrière-plan",
        "backgroundPreviewText": "Voici à quoi ressemblera le texte standard sur la couleur principale de votre page.",

        "primaryPreview": "Aperçu du bouton principal",
        "primaryPreviewTitle": "Appel à l’action / Primaire",
        "primaryPreviewText": "Assurez-vous que cela reste lisible pour les boutons et les mises en avant."
    },
    divisions: {
        "pageTitle": "Divisions",
        "organizationFallback": "Organisation",

        "archiveSuccess": "La division a été archivée avec succès",
        "archiveFailed": "Impossible d’archiver la division",
        "archiveError": "Erreur lors de l’archivage de la division",
        "loadError": "Échec du chargement des divisions",

        "confirmArchiveTitle": "Archiver cette division ?",
        "confirmArchiveMessage": "Cela archivera la division et TOUTES les données associées : saisons, équipes, joueurs, statistiques, etc. Êtes-vous sûr ?",
        "archive": "Archiver",
        "cancel": "Annuler",

        "sport": "Sport",
        "sportFallback": "Sport",
        "open": "Ouverte",
        "closed": "Fermée",
        "allStatuses": "Toutes",
        "filterByStatus": "Filtrer les divisions par statut",

        "organizationLabel": "Organisation",
        "seasonStart": "Début de saison",
        "seasonEnd": "Fin de saison",
        "season": "Saison",
        "noneActive": "Aucune active",
        "noActiveSeasonConfigured": "Aucune saison active configurée",

        "openDetails": "Ouvrir les détails de la division",
        "details": "Détails",
        "editDivision": "Modifier la division",
        "archiveDivision": "Archiver la division"
    },
    addDivision: {
        "newBadge": "NOUVELLE",
        "title": "Nouvelle division",
        "close": "Fermer",
        "save": "Enregistrer",

        "basics": "Informations de base",
        "name": "Nom",
        "namePlaceholder": "Nom de la division",
        "competitionLevel": "Niveau de compétition",
        "competitionLevelPlaceholder": "ex. récréatif, compétitif",
        "optionalSelection": "— Facultatif —",
        "competitionOptions": {"recreational": "Loisir", "competitive": "Compétitif", "select": "Select", "elite": "Élite"},
        "ageGroup": "Groupe d’âge",
        "ageGroupPlaceholder": "ex. U12, U14",
        "ageOptions": {"u8": "U8", "u10": "U10", "u12": "U12", "u14": "U14", "u16": "U16", "u18": "U18", "adult": "Adulte", "senior": "Senior"},
        "sport": "Sport",
        "chooseSport": "— Choisir un sport —",
        "sportHint": "Le sport influence les valeurs par défaut et les règles disponibles pour cette division.",

        "rules": "Règles",
        "mountDistance": "Distance du monticule (ft)",
        "mountDistancePlaceholder": "ex. 60.5",
        "mountDistanceHint": "Utilisé pour le suivi des lancers et la configuration du match.",
        "pitchLimit": "Limite de lancers",
        "pitchLimitPlaceholder": "ex. 75",
        "restingGames": "Matchs de repos",
        "restingGamesPlaceholder": "ex. 1",
        "restingGamesHint": "Nombre de matchs qu’un lanceur doit manquer après avoir atteint la limite de lancers.",
        "gameDuration": "Durée du match (minutes)",
        "gameDurationPlaceholder": "ex. 90",

        "policy": "Politique",
        "waiverOptional": "Décharge (optionnelle)",
        "noWaiver": "— Aucune décharge —",
        "waiverHint": "Associez une décharge aux participants de cette division (modifiable plus tard).",

        "createdSuccess": "Division créée avec succès",
        "error": "Erreur lors de la création de la division"
    },
    editDivision: {
        "editBadge": "MODIFIER",
        "title": "Modifier la division",
        "close": "Fermer",
        "save": "Enregistrer",
        "saving": "Enregistrement...",

        "basics": "Informations de base",
        "name": "Nom",
        "competitionLevel": "Niveau de compétition",
        "competitionLevelPlaceholder": "ex. récréatif, compétitif",
        "optionalSelection": "— Facultatif —",
        "competitionOptions": {"recreational": "Loisir", "competitive": "Compétitif", "select": "Select", "elite": "Élite"},
        "ageGroup": "Groupe d’âge",
        "ageGroupPlaceholder": "ex. U12, U14",
        "ageOptions": {"u8": "U8", "u10": "U10", "u12": "U12", "u14": "U14", "u16": "U16", "u18": "U18", "adult": "Adulte", "senior": "Senior"},
        "sport": "Sport",
        "chooseSport": "— Choisir un sport —",
        "sportHint": "Changer de sport peut affecter les règles et les paramètres par défaut.",

        "rules": "Règles",
        "mountDistance": "Distance du monticule (ft)",
        "mountDistancePlaceholder": "ex. 60.5",
        "pitchLimit": "Limite de lancers",
        "pitchLimitPlaceholder": "ex. 75",
        "restingGames": "Matchs de repos",
        "restingGamesPlaceholder": "ex. 1",
        "gameDuration": "Durée du match (minutes)",
        "gameDurationPlaceholder": "ex. 90",

        "policy": "Politique",
        "waiverOptional": "Décharge (optionnelle)",
        "noWaiver": "— Aucune décharge —",
        "waiverHint": "Utilisé pour l’accord des participants dans cette division.",

        "editedSuccess": "Division modifiée avec succès",
        "error": "Erreur lors de la modification de la division"
    },
    "divisionDetailPage": {
        "pageTitle": "Détails de la division",
        "breadcrumbOrganizations": "Organisations",
        "breadcrumbDivisions": "Divisions"
    },
    "divisionHeader": {
        "badge": "Division",
        "subtitle": "Aperçu rapide du sport et de la saison active.",
        "open": "Ouverte",
        "closed": "Fermée",
        "sport": "Sport",
        "season": "Saison",
        "divisionStatus": "Statut de la division",
        "active": "Active",
        "archived": "Archivée",
        "empty": "—"
    },
    "activeSeason": {
        "badge": "Saisons",
        "title": "Gestion des saisons",
        "subtitle": "Sélectionnez la saison active pour cette division.",
        "newSeason": "Nouvelle saison",
        "newSeasonTitle": "Créer une nouvelle saison",
        "lockedTitle": "Verrouillé pendant l’examen d’une ancienne saison",
        "activeSeasonLabel": "Saison active",
        "selectSeasonPlaceholder": "— Sélectionnez une saison —",
        "hint": "Changer la saison active met à jour les phases et les équipes pour la planification et les statistiques.",
        "itemLabel": "saisons"
    },
    "divisionSummary": {
        "stages": "Phases",
        "teams": "Équipes",
        "events": "Événements",
        "players": "Joueurs",
        "competitionPhases": "Phases de compétition",
        "registeredTeams": "Équipes inscrites",
        "scheduledGames": "Matchs programmés",
        "activeRosterSize": "Taille de l’effectif actif"
    },
    "divisionTags": {
        "title": "Espace de travail de la division",
        "premiumNotice": "Les onglets Statistiques et Ajustements sont uniquement disponibles pour les forfaits premium.",
        "pro": "PRO",
        "basic": "BASIC",
        "teams": "Équipes",
        "stages": "Phases",
        "seasons": "Saisons",
        "schedule": "Calendrier",
        "standings": "Classement",
        "sanctions": "Sanctions",
        "stats": "Statistiques",
        "pointAdjustments": "Ajustements de points",
        "divisionTabsAriaLabel": "Onglets de division",
        "loading": "Chargement…",
        "comingSoon": "Bientôt disponible"
    },
    "teamList": {
        "removeSuccess": "Équipe supprimée avec succès",
        "removeFailed": "Échec de la suppression de l’équipe",
        "removeTitle": "Supprimer cette équipe de la saison ?",
        "removeMessageLine1": "Cela dissociera \"{{teamName}}\" de cette saison.",
        "removeMessageLine2": "Les joueurs, les statistiques et le calendrier de cette équipe pour cette saison peuvent être affectés.",
        "removeMessageLine3": "Êtes-vous sûr ?",
        "removeConfirm": "Supprimer l’équipe",
        "cancel": "Annuler",
        "proOnlyFeature": "Cette fonctionnalité est réservée aux abonnés Pro/Elite.",
        "title": "Équipes de la saison",
        "subtitleSeasonFallback": "cette saison",
        "total": "Total",
        "createTeam": "Créer une équipe",
        "addExistingTeams": "Ajouter des équipes existantes",
        "headers": {
            "team": "Équipe",
            "players": "Joueurs",
            "actions": "Actions"
        },
        "seasonTeam": "Équipe de saison",
        "openTeamDetails": "Ouvrir les détails de l’équipe",
        "playersLinked": "Joueurs liés à l’équipe",
        "editTeamName": "Modifier le nom de l’équipe",
        "removeTeamFromSeason": "Retirer l’équipe de la saison",
        "allSelectedAlreadyAdded": "Toutes les équipes sélectionnées sont déjà dans cette saison.",
        "addExistingFailed": "Impossible d’ajouter les équipes existantes.",
        "teamsAndPlayersCopied": "Les équipes et les joueurs ont été copiés dans cette saison.",
        "teamsAdded": "Équipes ajoutées à cette saison."
    },
    "addTeamModal": {
        "teamAddedSuccess": "Équipe ajoutée avec succès",
        "teamNameRequired": "Veuillez saisir un nom d’équipe.",
        "teamCreatedLogoFailed": "L’équipe a été créée, mais le téléchargement du logo a échoué : {{errors}}",
        "badge": "Nouveau",
        "title": "Ajouter une équipe",
        "closeAria": "Fermer",
        "closeTitle": "Fermer",
        "sectionTitle": "Détails de l’équipe",
        "logoLabel": "Logo de l’équipe (optionnel)",
        "logoHint": "Recommandé : ratio 1:1, PNG ou JPG",
        "teamNameLabel": "Nom de l’équipe",
        "teamNamePlaceholder": "Saisir le nom de l’équipe...",
        "teamNameHint": "Cela créera une équipe et l’associera à la saison actuelle.",
        "close": "Fermer",
        "noActiveSeasonSelected": "Aucune saison active sélectionnée",
        "addTeamTitle": "Ajouter l’équipe",
        "saving": "Enregistrement...",
        "save": "Enregistrer"
    },
    "editTeamModal": {
        "missingTeamId": "ID de l’équipe manquant.",
        "teamUpdatedLogoFailed": "L’équipe a été mise à jour, mais le téléchargement du logo a échoué : {{errors}}",
        "teamEditedSuccess": "Équipe modifiée avec succès",
        "badge": "Modifier",
        "title": "Modifier l’équipe",
        "closeAria": "Fermer",
        "closeTitle": "Fermer",
        "sectionTitle": "Détails de l’équipe",
        "logoLabel": "Logo de l’équipe (optionnel)",
        "logoHint": "Recommandé : ratio 1:1, PNG ou JPG",
        "nameLabel": "Nom",
        "namePlaceholder": "Nom de l’équipe",
        "nameHint": "Cela met à jour le nom de l’équipe dans les vues d’administration web.",
        "close": "Fermer",
        "save": "Enregistrer"
    },
    "addExistingSeasonTeamsModal": {
        "allSports": "Tous les sports",
        "badge": "Copier",
        "title": "Ajouter des équipes existantes",
        "closeAria": "Fermer",
        "closeTitle": "Fermer",
        "sectionTitle": "Saison source et équipes",
        "includeArchivedDivisions": "Inclure les divisions archivées",
        "includeArchivedDivisionsTitle": "Afficher aussi les divisions archivées / inactives",
        "sport": "Sport",
        "sourceDivision": "Division source",
        "loadingDivisions": "Chargement des divisions...",
        "selectDivision": "Sélectionner une division",
        "noDivisionsAvailable": "Aucune division disponible",
        "couldNotLoadDivisions": "Impossible de charger les divisions. Veuillez réessayer plus tard.",
        "sourceSeason": "Saison source",
        "selectSeason": "Sélectionner une saison",
        "noSeasonsAvailable": "Aucune saison disponible",
        "sourceSeasonHint": "Choisissez la saison depuis laquelle vous voulez copier les équipes. Il s'agit généralement de la saison de l'année dernière.",
        "keepPlayersTitle": "Ajouter les joueurs de l’équipe à la saison",
        "keepPlayersHint": "Optionnel. Si activé, les joueurs seront également copiés dans la saison active pour les équipes sélectionnées.",
        "keepPlayersWarning": "NE COCHEZ PAS CECI SI VOUS VOULEZ QUE LES JOUEURS S’INSCRIVENT DANS LA NOUVELLE SAISON !",
        "keepPlayersRequiredForMove": "Requis lors du retrait de la saison source. Les joueurs et les managers seront copiés vers la saison cible.",
        "keepPlayersTitleAttr": "Copier les joueurs dans la saison active",
        "transferOptionsTitle": "Options de transfert",
        "targetStage": "Étape cible",
        "targetGroup": "Groupe cible",
        "sourceStage": "Étape source",
        "sourceGroup": "Groupe source",
        "selectStage": "Sélectionner une étape",
        "selectGroupOptional": "Aucun groupe / choisir plus tard",
        "noStagesAvailable": "Aucune étape disponible",
        "noGroupsAvailable": "Aucun groupe disponible",
        "carryPointsTitle": "Transférer les points du classement",
        "carryPointsHint": "Copie les points du classement source comme ajustement manuel dans l’étape/groupe cible.",
        "deactivateSourceTitle": "Retirer de la saison source après le transfert",
        "deactivateSourceHint": "Conserve les données historiques, mais désactive l’équipe dans la saison source. Le backend bloque l’action s’il existe des matchs ouverts.",
        "pleaseWaitTitle": "Veuillez attendre la fin de l’opération",
        "table": {
            "team": "Équipe",
            "players": "Joueurs",
            "status": "Statut"
        },
        "noTeamsForSeason": "Aucune équipe trouvée pour cette saison.",
        "selectSeasonToSeeTeams": "Sélectionnez une saison pour voir ses équipes.",
        "seasonTeam": "Équipe de saison",
        "alreadyInSeason": "Déjà dans {{seasonName}}",
        "selected": "Sélectionnée",
        "available": "Disponible",
        "teamsSelectedFooter": "{{count}} équipe(s) sélectionnée(s) à ajouter.",
        "selectTeamsFooter": "Sélectionnez une ou plusieurs équipes à ajouter à la saison active.",
        "close": "Fermer",
        "adding": "Ajout...",
        "addSelectedTeams": "Ajouter les équipes sélectionnées"
    },
    "inviteLinkBox": {
        "emailSubject": "Rejoignez notre ligue sur AngeonX Sports",
        "emailBody": "Bonjour, rejoignez notre ligue sur AngeonX Sports avec ce lien d’invitation :\n\n{{inviteURL}}\n\nSi vous devez créer un compte, utilisez d’abord ce même lien. Après la connexion, AngeonX Sports vous ramènera automatiquement à l’invitation.",
        "whatsAppMessage": "Rejoignez notre ligue sur AngeonX Sports. Ouvrez ce lien pour vous connecter ou créer un compte; après la connexion, l’app continuera automatiquement vers l’invitation : {{inviteURL}}",
        "title": "Lien d’invitation de la saison !",
        "description": "Partagez ce lien avec les gestionnaires d’équipes afin qu’ils puissent inscrire leurs équipes dans votre ligue. S’ils doivent créer un compte, AngeonX Sports les ramènera à cette invitation après la connexion. Seuls les <b>Managers/Capitaines</b> avec une équipe active, <b>Arbitres/Umpires</b> ou les <b>Coordinateur de la ligue</b> pourront rejoindre via ce lien d’invitation :",
        "copyLink": "📋 Copier le lien",
        "sendEmail": "📧 Envoyer un email",
        "whatsApp": "💬 WhatsApp",
        "important": "Important : Une fois que toutes les équipes sont inscrites, vous pouvez créer les <b>Phases</b> et le <b>Calendrier</b>."
    },
    "teamDetailPage": {
        "pageTitle": "Détails de l’équipe",
        "breadcrumbOrganizations": "Organisations",
        "breadcrumbDivisions": "Divisions"
    },
    "teamHeader": {
        "division": "Division",
        "players": "Joueurs",
        "season": "Saison"
    },
    "inviteTeamLink": {
        "emailSubject": "Rejoignez notre équipe sur AngeonX Sports",
        "emailBody": "Bonjour, rejoignez notre équipe sur AngeonX Sports avec ce lien d’invitation :\n\n{{inviteURL}}\n\nSi vous devez créer un compte, utilisez d’abord ce même lien. Après la connexion, AngeonX Sports vous ramènera automatiquement à l’invitation de l’équipe.",
        "whatsAppMessage": "Rejoignez notre équipe sur AngeonX Sports. Ouvrez ce lien pour vous connecter ou créer un compte; après la connexion, l’app continuera automatiquement vers l’invitation de l’équipe : {{inviteURL}}",
        "title": "Lien d’invitation du manager !",
        "description": "Partagez ce lien avec le manager de l’équipe pour qu’il rejoigne l’équipe. S’il doit créer un compte, AngeonX Sports le ramènera à cette invitation après la connexion. Ensuite, le manager invitera les joueurs via l’application mobile.",
        "copyLink": "📋 Copier le lien",
        "sendEmail": "📧 Envoyer un email",
        "whatsApp": "💬 WhatsApp"
    },
    "teamMemberPicker": {
        "title": "Ajouter {{role}} a l’equipe",
        "addCoach": "Ajouter coach",
        "addPlayer": "Ajouter joueur",
        "roles": {
            "coach": "coach",
            "player": "joueur"
        },
        "profile": "Profil utilisateur",
        "searchPlaceholder": "Rechercher des profils utilisateur...",
        "add": "Ajouter",
        "alreadyAdded": "Ajoute",
        "loadError": "Impossible de charger les profils utilisateur.",
        "noProfiles": "Aucun profil utilisateur disponible.",
        "noSearchResults": "Aucun profil trouve pour cette recherche.",
        "pageInfo": "Page {{page}} sur {{pages}}",
        "addSuccess": "{{role}} ajoute avec succes.",
        "addError": "Impossible d’ajouter ce membre a l’equipe."
    },
    "coordinatorPicker": {
        "title": "Ajouter un coordinateur a {{name}}",
        "profile": "Profil utilisateur",
        "searchPlaceholder": "Rechercher des profils utilisateur...",
        "add": "Ajouter",
        "alreadyAdded": "Ajoute",
        "loadError": "Impossible de charger les profils utilisateur.",
        "noProfiles": "Aucun profil utilisateur disponible.",
        "noSearchResults": "Aucun profil trouve pour cette recherche.",
        "addSuccess": "Coordinateur invite avec succes.",
        "addError": "Impossible d’inviter ce coordinateur."
    },
    "playersList": {
        "player": "Joueur",
        "jerseyNumber": "Numéro",
        "position": "Position",
        "actions": "Actions",
        "choosePosition": "Choisir un poste",
        "missingProfile": "Aucun profil actif sélectionné.",
        "invalidShirtNumber": "Le numéro de maillot doit être un nombre entier de 0 ou plus.",
        "saveSuccess": "Joueur mis à jour avec succès.",
        "saveError": "Échec de la mise à jour du joueur.",
        "deleteTitle": "Supprimer le joueur",
        "deleteMessage": "Voulez-vous vraiment retirer {{name}} de cette equipe ?",
        "deleteConfirm": "Supprimer",
        "deleteSuccess": "Joueur retiré avec succès.",
        "deleteError": "Échec de la suppression du joueur."
    },
    "teamCoaches": {
        "deleteTitle": "Supprimer le coach",
        "deleteMessage": "Voulez-vous vraiment retirer {{name}} de cette equipe ?",
        "deleteConfirm": "Supprimer",
        "deleteSuccess": "Coach retiré avec succès.",
        "deleteError": "Échec de la suppression du coach."
    },
    "positions": {
        "soccer": {
            "goalkeeper": "Gardien de but",
            "defender": "Défenseur",
            "left-back": "Latéral gauche",
            "right-back": "Latéral droit",
            "center-back": "Défenseur central",
            "midfielder": "Milieu de terrain",
            "attacking-midfielder": "Milieu offensif",
            "defensive-midfielder": "Milieu défensif",
            "winger": "Ailier",
            "forward": "Attaquant",
            "striker": "Avant-centre"
        },
        "baseball": {
            "spare": "Remplaçant",
            "pitcher": "Lanceur",
            "catcher": "Receveur",
            "first-base": "Premier but",
            "second-base": "Deuxième but",
            "third-base": "Troisième but",
            "short-stop": "Arrêt-court",
            "left-fielder": "Champ gauche",
            "centre-fielder": "Champ centre",
            "right-fielder": "Champ droit"
        },
        "softball": {
            "spare": "Remplaçant",
            "pitcher": "Lanceur",
            "catcher": "Receveur",
            "first-base": "Premier but",
            "second-base": "Deuxième but",
            "third-base": "Troisième but",
            "short-stop": "Arrêt-court",
            "left-fielder": "Champ gauche",
            "short-fielder": "Champ intérieur court (Rover)",
            "centre-fielder": "Champ centre",
            "right-fielder": "Champ droit"
        },
        "basketball": {
            "point-guard": "Meneur",
            "shooting-guard": "Arrière",
            "small-forward": "Ailier",
            "power-forward": "Ailier fort",
            "center": "Pivot"
        },
        "american-football": {
            "quarterback": "Quarterback",
            "running-back": "Running back",
            "fullback": "Fullback",
            "wide-receiver": "Receveur éloigné",
            "tight-end": "Ailier rapproché (Tight end)",
            "offensive-lineman": "Lineman offensif",
            "defensive-lineman": "Lineman défensif",
            "linebacker": "Linebacker",
            "cornerback": "Demi de coin",
            "safety": "Safety",
            "kicker": "Botteur",
            "punter": "Botteur de dégagement (Punter)"
        },
        "hockey": {
            "goalie": "Gardien de but",
            "defenseman": "Défenseur",
            "left-wing": "Ailier gauche",
            "right-wing": "Ailier droit",
            "center": "Centre"
        },
        "rugby": {
            "loosehead-prop": "Pilier gauche",
            "hooker": "Talonneur",
            "tighthead-prop": "Pilier droit",
            "lock": "Deuxième ligne",
            "flanker": "Troisième ligne aile",
            "number-eight": "Troisième ligne centre (n°8)",
            "scrum-half": "Demi de mêlée",
            "fly-half": "Demi d’ouverture",
            "inside-centre": "Centre intérieur",
            "outside-centre": "Centre extérieur",
            "wing": "Ailier",
            "fullback": "Arrière"
        },
        "volleyball": {
            "outside-hitter": "Réceptionneur-attaquant",
            "opposite-hitter": "Opposé",
            "middle-blocker": "Central",
            "setter": "Passeur",
            "libero": "Libero",
            "defensive-specialist": "Spécialiste défensif",
            "serving-specialist": "Spécialiste du service"
        }
    },
    addStageModal: {
        badge: "Nouveau",
        title: "Nouvelle phase",
        createFor: "Créer une phase pour",
        thisSeason: "cette saison",
        close: "Fermer",
        save: "Enregistrer",

        fields: {
            stageName: "Nom de la phase",
            stageType: "Type de phase",
            minGamesRequired: "Nombre minimum de matchs requis",
            gameMode: "Mode de jeu",
            qualifiedTeamsPerGroup: "Équipes qualifiées par groupe pour la phase suivante",
            additionalTeams: "Équipes supplémentaires pour la phase suivante"
        },

        placeholders: {
            stageName: "Entrez un nom pour la phase...",
            minGamesRequired: "Saisissez le minimum de matchs requis",
            chooseStageType: "Sélectionnez le type de phase",
            chooseGameMode: "Sélectionnez le mode de jeu"
        },

        helpers: {
            stageName: "Exemple : Saison régulière, Playoffs, Groupe A",
            minGamesRequired: "Les joueurs doivent avoir disputé au moins ce nombre de matchs pour participer à cette phase. Laissez 0 par défaut si aucun match n'est requis.",
            stageType: "Les phases d'entraînement ne nécessitent pas de mode de jeu ni de règles de qualification."
        },

        stageTypes: {
            league: "Ligue",
            roundRobin: "Toutes rondes (round-robin)",
            brackets: "Playoffs (tableau)",
            training: "Séance d'entraînement"
        },

        gameModes: {
            singleGame: "Match unique",
            doubleGame: "Double match (même jour)",
            doubleHeader: "Double confrontation (le 2e tour commence après la fin du 1er tour)",
            series3: "Série de 3 (2 victoires nécessaires)",
            series5: "Série de 5 (3 victoires nécessaires)",
            series7: "Série de 7 (4 victoires nécessaires)"
        },

        toasts: {
            createdSuccess: "Phase créée avec succès",
            minGamesInvalid: "Le minimum de matchs requis doit être un nombre entier supérieur ou égal à 0"
        }
    },
    stageList: {
        title: "Phases de la saison",
        subtitleManage: "Gérez les phases de",
        thisSeason: "cette saison",
        total: "Total",

        headers: {
            stage: "Phase",
            type: "Type",
            actions: "Actions",
        },

        status: {
            completed: "Terminée",
            inProgress: "En cours",
            nextStageEnabled: "Phase suivante activée",
        },

        labels: {
            scheduleType: "Type de calendrier",
        },

        actions: {
            openSchedule: "Ouvrir le calendrier",
            advanceTeams: "Faire avancer les équipes vers la phase suivante",
            deleteStage: "Supprimer la phase",
        },

        badges: {
            stageDoneCreateNext: "Phase terminée · Créer la phase suivante",
        },

        toasts: {
            removeSuccess: "Phase supprimée avec succès",
            removeFailed: "Échec de la suppression de la phase",
        },

        deleteDialog: {
            title: "Supprimer cette phase ?",
            message:
                'Vous êtes sur le point de supprimer "{name}".\n\nCela supprimera également ses matchs/calendrier de cette saison. Cette action est irréversible.\n\nÊtes-vous sûr ?',
            confirm: "Supprimer la phase",
            cancel: "Annuler",
        },
    },
    confirmDelete: {
        badge: {
            danger: "DANGER",
            confirm: "CONFIRMER",
        },
        aria: {
            close: "Fermer",
        },
        hints: {
            danger: "Cette action est destructive et peut affecter des données liées.",
            confirm: "Veuillez confirmer pour continuer.",
        },
        buttons: {
            working: "Traitement...",
            delete: "Supprimer",
            cancel: "Annuler",
            confirm: "Confirmer",
        },
        defaults: {
            title: "Êtes-vous sûr ?",
            message: "Cette action est irréversible.",
        },
    },
    seasonList: {
        title: "Saisons",
        subtitleManage: "Gérez les saisons de",
        thisDivision: "cette division",

        headers: {
            season: "Saison",
            start: "Début",
            end: "Fin",
            registrationStart: "Date de début d'inscription",
            registrationEnd: "Date de fin d'inscription",
            actions: "Actions",
        },

        labels: {
            seasons: "saisons",
            teamsInSeason: "Équipes dans cette saison",
            stagesInSeason: "Phases dans cette saison",
        },

        actions: {
            editSeason: "Modifier la saison",
            deleteSeason: "Supprimer la saison",
        },

        toasts: {
            removeSuccess: "Saison supprimée avec succès",
            removeFailed: "Échec de la suppression de la saison",
        },

        deleteDialog: {
            title: "Supprimer cette saison ?",
            message:
                'Vous êtes sur le point de supprimer "{name}".\n\nCela supprimera la saison de cette division. Cette action est irréversible.\n\nÊtes-vous sûr ?',
            confirm: "Supprimer la saison",
            cancel: "Annuler",
        },
    },
    addSeasonModal: {
        badge: "NOUVEAU",
        title: "Nouvelle saison",

        sections: {
            season: "Saison",
            pointSystem: "Système de points",
            policies: "Politiques",
            registrationFee: "Frais d’inscription par équipe",
        },

        fields: {
            name: "Nom",
            registrationStartDate: "Date d'ouverture des inscriptions",
            registrationEndDate: "Date de clôture des inscriptions",
            lateRegistrationUntil: "Inscriptions tardives jusqu'au",
            startDate: "Date de début",
            endDate: "Date de fin",
            winPoints: "Points de victoire",
            drawPoints: "Points de match nul",
            losePoints: "Points de défaite",
            forfeitWinPoints: "Points de victoire par forfait",
            forfeitLossPoints: "Points de défaite par forfait",
            forfeitWinScore: "Score gagnant par forfait",
            forfeitLossScore: "Score perdant par forfait",
            doubleForfeitPoints: "Points de double forfait",
            overtimeWinPoints: "Points de victoire en prolongation",
            overtimeLosePoints: "Points de défaite en prolongation",
            waiverOptional: "Décharge (optionnelle)",
            feeType: "Type de frais",
            lateRegistrationFee: "Frais d'inscription tardive par joueur",
            amount: "Montant",
            dueDate: "Date d’échéance",
        },

        placeholders: {
            seasonName: "Nom de la saison",
            winPoints: "Points en cas de victoire",
            drawPoints: "Points en cas de match nul",
            losePoints: "Points en cas de défaite",
            forfeitWinPoints: "Points attribués à l’équipe non forfait",
            forfeitLossPoints: "Points attribués à l’équipe forfait",
            forfeitWinScore: "Score attribué à l’équipe non forfait",
            forfeitLossScore: "Score attribué à l’équipe forfait",
            doubleForfeitPoints: "Points attribués à chaque équipe",
            overtimeWinPoints: "Points en cas de victoire en prolongation",
            overtimeLosePoints: "Points en cas de défaite en prolongation",
            amountExample: "ex. 100.00",
            installmentAmountExample: "ex. 50.00",
        },

        options: {
            noWaiver: "— Aucune décharge —",
            mandatoryOnRegistration: "Généré à l’inscription",
            payLater: "Payer plus tard",
            installments: "Versements",
        },

        toggles: {
            useOvertime: "Utiliser la prolongation",
            enableRegistrationFee: "Activer les frais d’inscription",
        },

        hints: {
            overtime:
                "Si activé, les points de victoire/défaite en prolongation peuvent différer de ceux du temps réglementaire.",
            forfeit:
                "Configurez les points du classement et les scores par défaut utilisés par les règles de forfait.",
            waiver:
                "Décharge optionnelle que les participants doivent accepter lors de l’inscription.",
            installments:
                "Ajoutez un ou plusieurs versements avec leurs dates d’échéance.",
        },

        buttons: {
            close: "Fermer",
            save: "Enregistrer",
            remove: "Supprimer",
            addInstallment: "+ Ajouter un versement",
        },

        installment: {
            amountNumber: "Montant #{{number}}",
            dueDateNumber: "Date d’échéance #{{number}}",
            removeTitle: "Supprimer le versement",
        },

        toast: {
            success: "Saison créée avec succès",
        },
    },
    editSeasonModal: {
        badge: "MODIFIER",
        title: "Modifier la saison",
        updateSettingsFor: "Mettre à jour les paramètres de {{season}}",

        sections: {
            season: "Saison",
            pointSystem: "Système de points",
            registrationFee: "Frais d’inscription par équipe",
        },

        sectionHints: {
            season: "Nom et dates",
            pointSystem: "Points du classement",
            registrationFee: "Configuration facultative des frais",
            overtime: "Points optionnels en prolongation",
            forfeit: "Règles de forfait et double forfait",
            installments: "Ajoutez un ou plusieurs versements",
        },

        fields: {
            name: "Nom",
            registrationStartDate: "Date d'ouverture des inscriptions",
            registrationEndDate: "Date de clôture des inscriptions",
            lateRegistrationUntil: "Inscriptions tardives jusqu'au",
            startDate: "Date de début",
            endDate: "Date de fin",
            waiverOptional: "Décharge (optionnelle)",
            winPoints: "Points de victoire",
            drawPoints: "Points de match nul",
            losePoints: "Points de défaite",
            forfeitWinPoints: "Points de victoire par forfait",
            forfeitLossPoints: "Points de défaite par forfait",
            forfeitWinScore: "Score gagnant par forfait",
            forfeitLossScore: "Score perdant par forfait",
            doubleForfeitPoints: "Points de double forfait",
            otWinPoints: "Points de victoire en prolongation",
            otLossPoints: "Points de défaite en prolongation",
            feeType: "Type de frais",
            lateRegistrationFee: "Frais d'inscription tardive par joueur",
            amount: "Montant",
            dueDate: "Date d’échéance",
        },

        placeholders: {
            seasonName: "Nom de la saison",
            otWinPoints: "Points pour une victoire en prolongation",
            otLossPoints: "Points pour une défaite en prolongation",
            amountExample: "ex. 100.00",
            installmentAmount: "Montant du versement #{{number}}",
        },

        options: {
            noWaiver: "— Aucune décharge —",
            none: "Aucun",
            mandatoryOnRegistration: "Généré à l’inscription",
            payLater: "Payer plus tard",
            installments: "Versements",
        },

        toggles: {
            useOvertime: "Utiliser la prolongation",
            enableRegistrationFee: "Activer les frais d’inscription",
        },

        installmentChip: "Versements",

        buttons: {
            close: "Fermer",
            saveChanges: "Enregistrer les modifications",
            addInstallment: "Ajouter un versement",
        },

        titles: {
            removeInstallment: "Supprimer le versement",
        },

        fallback: {
            season: "saison",
        },

        validation: {
            atLeastOneInstallment: "Au moins un versement est requis.",
            installmentPositiveAmount: "Le versement #{{number}} doit avoir un montant positif.",
            installmentDueDate: "Le versement #{{number}} doit avoir une date d’échéance.",
            registrationFeeRequired: "Le montant et la date d’échéance des frais d’inscription sont requis.",
        },

        toast: {
            updated: "Saison mise à jour",
        },
    },
    standings: {
        title: "Classement",
        seasonStandings: "Classement de la saison",
        seasonStandingsFor: "Classement de la saison pour {{division}}",
        loading: "Chargement du classement…",
        loadingAria: "Chargement du classement...",
        empty: "Aucun classement disponible pour cette saison.",
    },
    baseballStandings: {
        pill: "CLASSEMENT",
        collapse: "Réduire",
        columns: {
            played: "MJ",
            rank: "#",
            team: "Équipe",
            win: "V",
            lose: "D",
            pct: "PCT",
            gb: "RET",
            rs: "PP",
            ra: "PC",
            diff: "DIFF",
        },
    },
    soccerStandings: {
        pill: "CLASSEMENT",
        collapse: "Réduire",
        columns: {
            played: "MJ",
            rank: "#",
            team: "Équipe",
            win: "V",
            draw: "N",
            lose: "D",
            goalsFor: "BP",
            goalsAgainst: "BC",
            goalDifference: "Diff",
            points: "Pts",
        },
    },
    rugbyStandings: {
        pill: "CLASSEMENT",
        collapse: "Réduire",
        columns: {
            played: "MJ",
            rank: "#",
            team: "Équipe",
            win: "V",
            draw: "N",
            lose: "D",
            pointsFor: "PP",
            pointsAgainst: "PC",
            difference: "DIFF",
            points: "Pts",
        },
    },
    hockeyStandings: {
        pill: "CLASSEMENT",
        collapse: "Réduire",
        columns: {
            rank: "#",
            team: "Équipe",
            played: "MJ",
            win: "V",
            lose: "D",
            overtimeLosses: "DP",
            points: "Pts",
            goalsFor: "BP",
            goalsAgainst: "BC",
            goalDifference: "Diff",
        },
    },
    sanctions: {
        title: "Sanctions",
        headers: {
            player: "Joueur",
            game: "Match",
            type: "Type",
            missedGames: "Matchs manqués",
            date: "Date",
            actions: "",
        },

        actions: {
            edit: "Modifier",
            delete: "Supprimer",
            close: "Fermer",
            cancel: "Annuler",
            update: "Mettre à jour",
            add: "Ajouter",
            saving: "Enregistrement…",
        },

        badge: {
            edit: "MODIFIER",
            new: "NOUVEAU",
        },

        modal: {
            editTitle: "Modifier la sanction",
            addTitle: "Ajouter une sanction",
            editSubtitle: "Mettez à jour ce dossier pour le joueur sélectionné.",
            addSubtitle: "Créer une sanction pour {{season}}.",
        },

        fields: {
            game: "Match",
            team: "Équipe",
            player: "Joueur",
            type: "Type",
            gamesSuspended: "Matchs de suspension",
            reason: "Raison",
            notes: "Notes",
        },

        options: {
            selectGame: "Sélectionner un match",
            selectTeam: "Sélectionner une équipe",
            selectPlayer: "Sélectionner un joueur",
            selectType: "Sélectionner un type",
        },

        placeholders: {
            gamesSuspended: "0",
            reason: "ex., Carton rouge, conduite antisportive…",
            notes: "Détails optionnels…",
            empty: "—",
        },

        toasts: {
            loadError: "Impossible de charger les sanctions",
            updateSuccess: "Sanction mise à jour",
            createSuccess: "Sanction créée",
            genericError: "Une erreur s’est produite",
            deleted: "Supprimé",
            deleteError: "Échec de la suppression",
        },

        deleteConfirm: {
            title: "Supprimer la sanction",
            message:
                "Cette sanction sera supprimée définitivement. Elle n’apparaîtra plus dans le dossier de ce joueur.\n\nVoulez-vous vraiment continuer ?",
            confirmLabel: "Oui, supprimer",
            cancelLabel: "Non",
        },

        values: {
            thisSeason: "cette saison",
        },
        sanctionTypes: {
            fine: "Amende",
            suspension: "Suspension",
        },
    },
    statsDashboard: {
        title: "Statistiques",
        subtitle: "Leaders et cartons pour cette saison{{stageSuffix}}.",
        stageSuffix: " (filtré par phase)",

        plan: {
            pro: "PRO",
            basic: "BASIQUE",
        },

        sections: {
            leaders: "Leaders",
            cards: "Cartons",
            gamesPlayed: "Plus de Matchs Joués"
        },

        tabsAria: "Sections des statistiques",

        actions: {
            refresh: "Actualiser",
        },

        upgrade: {
            title: "Mise à niveau requise.",
            description: "Les statistiques sont disponibles avec les forfaits Pro ou Elite.",
        },

        cards: {
            top10: "Top 10",
            stageFiltered: "Filtré par phase",
            seasonTotal: "Total de la saison",
            accumulatedYellowCards: "Cartons jaunes accumulés",
            accumulatedYellowCardsSubtitle: "Cartons jaunes par joueur (totaux de la saison)",
            failedToLoad: "Impossible de charger les cartons jaunes accumulés. Réessayez.",
            yellowsTitle: "{{count}} cartons jaunes accumulés",
        },

        leaderCards: {
            topScorers: "Meilleurs buteurs",
            topAssists: "Meilleurs passeurs",
            topRedCards: "Plus de cartons rouges",
            topGoalContributions: "Contributions aux buts",
            topOwnGoals: "Buts contre son camp",
            hockey_goals: "Meilleurs buteurs",
            hockey_assists: "Plus de mentions d’aide",
            hockey_shots: "Plus de tirs",
            hockey_penalty_minutes: "Minutes de pénalité",
            hockey_saves: "Plus d’arrêts",
            hockey_hits: "Plus de mises en échec",
            hockey_blocked_shots: "Plus de tirs bloqués",
            hockey_takeaways: "Plus de rondelles récupérées",
            hockey_giveaways: "Plus de rondelles perdues",
            hockey_faceoff_wins: "Plus de mises au jeu gagnées",
            hockey_faceoff_losses: "Plus de mises au jeu perdues",
            hockey_shots_against: "Plus de tirs reçus",
            hockey_goals_against: "Plus de buts accordés",
            hockey_shutouts: "Plus de blanchissages",
            batting_avg: "Meilleures moyennes au bâton",
            hits: "Meilleurs frappeurs",
            home_runs: "Meilleurs circuits",
            rbi: "Meilleurs points produits",
            runs_scored: "Meilleurs points marqués",
            strikeouts: "Meilleurs retraits sur des prises",
            stolen_bases: "Meilleurs buts volés",
            doubles: "Meilleurs doubles",
            triples: "Meilleurs triples",
            walks: "Meilleurs buts sur balles",
            hit_by_pitch: "Meilleurs frappeurs atteints",
            sacrifice_hits: "Meilleurs coups sacrifiés",
            caught_stealing: "Meilleurs retraits en tentative de vol",
            plate_appearances: "Meilleures présences au bâton",
            innings_played: "Meilleures manches jouées",
        },

        metrics: {
            goals: "Buts",
            assists: "Passes",
            reds: "Rouges",
            goalContributions: "Buts + mentions d’aide",
            ownGoals: "Buts contre son camp",
            yellows: "Jaunes",
            value: "Valeur",
            hockey_goals: "Buts",
            hockey_assists: "Mentions d’aide",
            hockey_shots: "Tirs",
            hockey_penalty_minutes: "Minutes de pénalité",
            hockey_saves: "Arrêts",
            hockey_hits: "Mises en échec",
            hockey_blocked_shots: "Tirs bloqués",
            hockey_takeaways: "Rondelles récupérées",
            hockey_giveaways: "Rondelles perdues",
            hockey_faceoff_wins: "Mises au jeu gagnées",
            hockey_faceoff_losses: "Mises au jeu perdues",
            hockey_shots_against: "Tirs reçus",
            hockey_goals_against: "Buts accordés",
            hockey_shutouts: "Blanchissages",
            batting_avg: "MOY",
            hits: "Coups sûrs",
            home_runs: "Circuits",
            rbi: "PP",
            runs_scored: "Points",
            strikeouts: "Retraits sur des prises",
            stolen_bases: "Buts volés",
            doubles: "Doubles",
            triples: "Triples",
            walks: "Buts sur balles",
            hit_by_pitch: "Fois atteint par un lancer",
            sacrifice_hits: "Coups sacrifiés",
            caught_stealing: "Retraits en tentative de vol",
            plate_appearances: "Présences au bâton",
            innings_played: "Manches jouées",
        },

        states: {
            loading: "Chargement…",
            failedToLoad: "Échec du chargement. Réessayez.",
            noData: "Aucune donnée pour le moment.",
            unavailable: "Indisponible",
            empty: "—",
        },

        table: {
            player: "Joueur",
            team: "Équipe",
            yellows: "Jaunes",
            gamesPlayed: "Matchs Joués"
        },
        "gamesPlayed": {
            "title": "Plus de Matchs Joués",
            "subtitle": "Joueurs ayant disputé le plus grand nombre de matchs",
            "failedToLoad": "Impossible de charger les joueurs ayant disputé le plus de matchs.",
            "stageFiltered": "Filtré par phase",
            "seasonTotal": "Total de la saison",
            "gamesTitle": "{{count}} matchs joués"
        }
    },
    adjustment: {
        title: "Ajustements de points",
        subtitle: "Gérer les ajustements pour {{season}}",

        headers: {
            createdAt: "Créé le",
            stage: "Phase",
            team: "Équipe",
            points: "Points",
            reason: "Raison",
            comment: "Commentaire",
            actions: "Actions",
        },

        badge: {
            edit: "MODIFIER",
            new: "NOUVEAU",
        },

        modal: {
            editTitle: "Modifier l’ajustement",
            addTitle: "Ajouter un ajustement",
            subtitle: "Mettez à jour les points qui affectent le classement.",
        },

        fields: {
            team: "Équipe",
            stage: "Phase",
            points: "Points",
            reason: "Raison",
            commentOptional: "Commentaire (optionnel)",
        },

        options: {
            selectTeam: "Sélectionner une équipe",
            selectStage: "Sélectionner une phase",
            selectReason: "Sélectionner une raison",
        },

        reasons: {
            fairPlayBonus: "Bonus fair-play",
            disciplinePenalty: "Pénalité disciplinaire",
            manualAdjustment: "Ajustement manuel",
        },

        actions: {
            edit: "Modifier l’ajustement",
            delete: "Supprimer l’ajustement",
            close: "Fermer",
            cancel: "Annuler",
            saving: "Enregistrement…",
            update: "Mettre à jour",
            add: "Ajouter",
        },

        deleteConfirm: {
            title: "Supprimer cet ajustement ?",
            message:
                "Cet ajustement sera supprimé et les points n’affecteront plus le classement.\n\nVoulez-vous vraiment continuer ?",
            confirmLabel: "Supprimer",
            cancelLabel: "Annuler",
        },

        toasts: {
            loadError: "Impossible de charger les ajustements",
            createdSuccess: "Ajustement créé avec succès",
            editedSuccess: "Ajustement modifié avec succès",
            deletedSuccess: "Ajustement supprimé avec succès",
            genericError: "Une erreur s’est produite",
            deleteError: "Échec de la suppression",
        },

        values: {
            thisSeason: "cette saison",
            empty: "—",
            noComment: "-",
        },
    },
    "fixtures": {
        "title": "Événements",
        "headers": {
            "matchweek": "Journée",
            "stageGroup": "Étape/Groupe",
            "away": "Visiteur",
            "home": "Domicile",
            "score": "Score",
            "details": "Détails",
            "actions": "Actions"
        },
        "buttons": {
            "actions": "Actions",
            "addGames": "Ajouter des matchs",
            "addTrainings": "Ajouter des entraînements",
            "bulkEdit": "Modifier en lot",
            "assignReferee": "Affecter des officiels",
            "printSchedule": "Imprimer le calendrier",
            "printGameSheet": "Imprimer la feuille de match",
            "downloadGamesTemplate": "Telecharger le modele d'import",
            "importGamesExcel": "Importer des matchs (Excel)"
        },
        "tooltips": {
            "openPublicSchedule": "Ouvrir le calendrier public et copier le lien",
            "printOfficialGameSheets": "Sélectionnez des matchs et imprimez les feuilles officielles",
            "downloadGamesTemplate": "Selectionnez une phase et telechargez le modele d'import des matchs",
            "importGamesExcel": "Telechargez un fichier Excel, verifiez les lignes et importez les matchs"
        },
        "messages": {
            "failedToLoadEvents": "Échec du chargement des événements",
            "publicScheduleCopied": "Lien du calendrier public copié dans le presse-papiers.",
            "noGamesToPrint": "Il n’y a aucun match à imprimer sur cette page.",
            "noStagesAvailable": "Aucune phase n'est disponible pour cette saison.",
            "failedToDownloadTemplate": "Impossible de telecharger le modele d'import des matchs.",
            "templateDownloaded": "Modele d'import des matchs telecharge.",
            "excelToolsPlanRequired": "Cette fonctionnalite est disponible uniquement pour les plans Elite, Enterprise ou Trial.",
            "refereeManagementFeatureRequired": "L’affectation des arbitres nécessite la fonctionnalité de gestion des arbitres."
        },
        "pageSize": {
            "label": "Lignes",
            "option": "{{size}} / page"
        },
        "assignmentFilter": {
            "label": "Affectations des arbitres",
            "all": "Tous les matchs",
            "unassigned": "Non affecté",
            "manual": "Manuel",
            "proposed": "Proposée",
            "invited": "Invitation en attente",
            "accepted": "Acceptée",
            "declined": "Refusée",
            "completed": "Terminée"
        },
        "templateModal": {
            "title": "Telecharger le modele d'import des matchs",
            "stageLabel": "Phase",
            "maxRowsLabel": "Nombre max de lignes",
            "maxRowsHint": "Nombre de lignes a generer dans le modele.",
            "selectStage": "Selectionnez une phase",
            "download": "Telecharger le modele",
            "generating": "Generation...",
            "templateTypeLabel": "Type de modèle",
            "dropdownTemplate": "Modèle prérempli avec listes déroulantes",
            "dropdownTemplateHint": "Utilisez ce modèle si vous voulez des listes déroulantes Excel préremplies, des données de référence et des IDs masqués.",
            "blankTemplate": "Modèle vierge en texte libre",
            "blankTemplateHint": "Utilisez ce modèle si vous préférez saisir les noms manuellement et les valider lors de l’importation."
        },
        "importModal": {
            "rowNumber": "Ligne",
            "badge": "IMPORT",
            "title": "Importer des matchs depuis Excel",
            "close": "Fermer",
            "uploadTitle": "Telecharger le modele complete",
            "uploadHint": "Formats acceptes: .xlsx, .xls",
            "clear": "Effacer",
            "previewHint": "Apercu de {count} ligne(s). Corrigez si necessaire avant l'import.",
            "rowLabel": "Ligne {row}:",
            "supportedTemplatesHint": "Compatible avec le modèle prérempli et le modèle vierge en texte libre.",
            "detectedTemplateType": "Détecté : {type}",
            "dropdownImportType": "Modèle prérempli avec listes déroulantes",
            "blankImportType": "Modèle vierge en texte libre",
            "buttons": {
                "importGames": "Importer les matchs",
                "importing": "Import en cours..."
            },
            "messages": {
                "fileParsed": "Fichier analyse: {count} ligne(s) pretes a verifier.",
                "importSuccess": "Matchs importes avec succes.",
                "fileParsedWithErrors": "{count} lignes chargées avec {errors} problèmes. Veuillez vérifier les lignes signalées."
            },
            "errors": {
                "fixRows": "Veuillez corriger les lignes suivantes:",
                "completeAllRequired": "Completez tous les champs obligatoires.",
                "teamsMustBeDifferent": "Les equipes domicile et exterieur doivent etre differentes.",
                "onlyExcelFiles": "Seuls les fichiers Excel sont autorises (.xlsx, .xls).",
                "emptyWorkbook": "Le classeur est vide.",
                "noRowsDetected": "Aucune ligne de match detectee dans le fichier.",
                "missingColumns": "Colonnes obligatoires manquantes: {columns}",
                "parseFailed": "Impossible d'analyser ce fichier Excel.",
                "importFailed": "Impossible d'importer les matchs. {message}",
                "invalidMatchDay": "La journée doit être un nombre valide.",
                "stageNotFound": "Étape introuvable : {value}",
                "groupNotFound": "Groupe introuvable dans cette étape : {value}",
                "awayTeamNotFound": "Équipe visiteuse introuvable dans cette étape/saison : {value}",
                "homeTeamNotFound": "Équipe locale introuvable dans cette étape/saison : {value}",
                "fieldNotFound": "Site/terrain introuvable dans cette étape : {value}",
                "refereeNotFound": "Arbitre/umpire introuvable : {value}",
                "managerNotFound": "Coordinateur introuvable : {value}",
                "invalidDateTime": "Format de date et heure invalide. Utilisez yyyy-mm-dd HH:mm."
            }
        }
    },
    "officialAssignmentModal": {
        "badge": "OFFICIELS",
        "title": "Affecter des officiels",
        "subtitle": "Invitez des officiels du groupe de la phase pour confirmer la couverture du match.",
        "close": "Fermer",
        "send": "Envoyer les invitations",
        "sending": "Envoi...",
        "labels": {"stagePool": "Groupe de la phase", "stagePoolHint": "Seuls les arbitres inclus dans les groupes des phases sélectionnées sont affichés.", "games": "matchs", "available": "disponibles", "current": "actuellement affecté", "selectOfficials": "Arbitres à inviter", "selected": "sélectionnés", "noOfficials": "Aucun arbitre disponible dans ce groupe de phase.", "resend": "Renvoyer", "replace": "Remplacer", "cancelReplacement": "Annuler le remplacement", "confirmReplacement": "Confirmer le remplacement", "replacing": "Remplacement...", "assignmentHistory": "Historique des affectations", "referee": "Officiel", "coordinator": "Coordinateur", "multipleHint": "Sélectionnez un ou plusieurs arbitres à inviter pour ce match.", "bulkOfficials": "Officiels pour ce lot", "bulkOfficialsHint": "Sélectionnez les officiels une fois et ajoutez-les aux matchs sélectionnés. Les invitations sont envoyées uniquement lorsque vous cliquez sur Envoyer les invitations.", "addBulkOfficials": "Ajouter aux matchs sélectionnés", "undoBulkOfficials": "Annuler le dernier ajout", "searchOfficials": "Rechercher des officiels", "selectVisible": "Sélectionner les visibles", "clearSelected": "Effacer", "removeOfficial": "Retirer l’officiel", "noBulkOfficialsSelected": "Aucun officiel sélectionné", "noBulkOfficialsFound": "Aucun officiel trouvé", "plannedInvitations": "invitations à envoyer", "notInStagePool": "hors des groupes de phase", "conflicts": "conflits", "resolveConflicts": "Résolvez les conflits d’horaire avant l’envoi.", "conflict": "Conflit d’horaire", "conflictHint": "Cet arbitre est sélectionné pour un autre match à la même heure.", "home": "Équipe locale", "away": "Équipe visiteuse", "homeLogo": "Logo de l’équipe locale", "awayLogo": "Logo de l’équipe visiteuse", "gameNumber": "Match {{id}}"},
        "statuses": {"proposed": "Proposé", "invited": "Invité", "accepted": "Accepté", "declined": "Refusé", "cancelled": "Annulé", "completed": "Terminé"},
        "messages": {"selectGame": "Sélectionnez au moins un match programmé.", "selectReferee": "Sélectionnez au moins un arbitre à inviter.", "selectBulkOfficial": "Sélectionnez au moins un officiel pour le lot.", "bulkApplied": "Officiels appliqués aux matchs sélectionnés.", "selectReplacement": "Sélectionnez un arbitre remplaçant admissible.", "sent": "Les invitations aux arbitres ont été envoyées.", "partialSent": "Certaines invitations ont été envoyées, mais {{count}} n’ont pas pu l’être. Vérifiez les sélections restantes.", "resent": "L’invitation à l’arbitre a été renvoyée.", "replaced": "L’invitation à l’arbitre remplaçant a été envoyée.", "failed": "Impossible d’envoyer les invitations aux arbitres."}
    },
    "bulkEditGamesModal": {
        "title": "Modifier des événements en lot",
        "selectedCount": "{{count}} événement(s) sélectionné(s).",
        "field": "Terrain",
        "referees": "Officiels",
        "managers": "Coordinateur",
        "description": "Description",
        "descriptionPlaceholder": "Saisissez une description...",
        "noChange": "Aucun changement",
        "save": "Enregistrer les modifications",
        "noEventsSelected": "Sélectionnez au moins un événement planifié.",
        "failed": "Échec de la mise à jour des événements sélectionnés.",
        "failedToResolveMatching": "Échec du chargement des événements correspondants pour la mise à jour en lot.",
        "success": "{{count}} événement(s) mis à jour avec succès.",
        "applyToAllMatching": "Appliquer à tous les événements planifiés de cette saison",
        "applyToAllMatchingHint": "Cela applique les modifications aux événements planifiés correspondants sur toutes les pages.",
        "validation": {
            "selectAtLeastOneChange": "Sélectionnez au moins une modification avant d'enregistrer."
        }
    },
    "event": {
        "new": {
            "form": {
                "responsible": "Arbitre(s)",
                "managers": "Coordinateur(s)"
            }
        }
    },
    "gameElement": {
        "matchweekLabel": "MATCH · JOURNÉE {{matchDay}}",
        "emptyValue": "—",
        "noGame": "Pas de match",
        "scheduled": "Planifié",
        "locationLabel": "Lieu : {{value}}",
        "coachLabel": "Entraîneur : {{value}}",
        "managerLabel": "Coordinateur: {{value}}",
        "refereeUmpireLabel": "Officiels : {{value}}",
        "actions": "Actions",
        "more": "Plus",
        "toggleDropdown": "Basculer le menu",
        "enterResult": "Saisir le résultat",
        "enterDetails": "Détails du match",
        "enterInnings": "Saisir les manches",
        "editGame": "Modifier le match",
        "deleteGame": "Supprimer le match",
        "addSanction": "Ajouter une sanction",
        "visitorLogoAlt": "Logo visiteur",
        "homeLogoAlt": "Logo domicile",
        "penaltiesShort": "t.a.b.",
        "messages": {
            "gameRemovedSuccessfully": "Match supprimé avec succès",
            "failedToRemoveGame": "Échec de la suppression du match"
        },
        "confirmDelete": {
            "title": "Supprimer ce match ?",
            "message": "Vous êtes sur le point de supprimer :\n{{visitorName}} @ {{homeName}}\n\nCe match sera définitivement supprimé de cette étape.\n\nÊtes-vous sûr ?",
            "confirmLabel": "Supprimer le match",
            "cancelLabel": "Annuler"
        },
        "soccerGameSheet": {
            "title": "Détails du Match",
            "visitorShort": "VISITEUR",
            "homeShort": "DOMICILE",
            "teamLabel": "Équipe",
            "select": "Sélectionner",
            "noEvents": "Aucun événement pour le moment",
            "loading": "Chargement...",
            "form": {
                "addEvent": "Ajouter un événement",
                "save": "Enregistrer",
                "saving": "Enregistrement..."
            },
            "fields": {
                "team": "Équipe",
                "eventType": "Type d'événement",
                "player": "Joueur",
                "relatedPlayer": "Joueur associé (optionnel)",
                "minute": "Minute",
                "period": "Période",
                "notes": "Notes (optionnel)"
            },
            "validation": {
                "required": "Veuillez remplir tous les champs obligatoires"
            },
            "toasts": {
                "saveSuccess": "Événement enregistré avec succès",
                "saveFailed": "Échec de l'enregistrement de l'événement",
                "deleteSuccess": "Événement supprimé avec succès"
            },
            "eventTypes": {
                "goal": "But",
                "assist": "Passe décisive",
                "substitutionIn": "Entré",
                "substitution_out": "Substitution",
                "yellow_card": "Carton jaune",
                "red_card": "Carton rouge",
                "own_goal": "But contre son camp"
            },
            "proDetailedResultsRequired": "Cette fonctionnalité nécessite un abonnement Pro ou supérieur.",
            "timeline": "Fil des événements"
        },
        "hockeyGameSheet": {
            "title": "Détails du match de hockey",
            "visitor": "Visiteur",
            "home": "Domicile",
            "visitorShort": "VISITEUR",
            "homeShort": "DOMICILE",
            "gameFeed": "FIL DU MATCH",
            "eventEntry": "SAISIE D’ÉVÉNEMENT",
            "timeline": "Chronologie",
            "allPeriods": "Tous",
            "periodLabel": "Période {{period}}",
            "periodShort": "P{{period}}",
            "overtimeShort": "PR{{period}}",
            "overtimeLabel": "Prolongation",
            "shootoutLabel": "Tirs de barrage",
            "noEventsInPeriod": "Aucun événement dans cette période.",
            "penaltyMinutesSummary": "{{minutes}} minutes de pénalité",
            "relatedPlayerSummary": "Associé : {{player}}",
            "closeAria": "Fermer les détails du match de hockey",
            "addEvent": "Ajouter un événement",
            "noEvents": "Aucun événement pour le moment.",
            "loading": "Chargement des événements de hockey...",
            "loadFailed": "Impossible de charger les événements de hockey.",
            "team": "Équipe",
            "action": "Action",
            "player": "Joueur",
            "relatedPlayer": "Joueur associé",
            "optional": "optionnel",
            "period": "Période",
            "minute": "Minute",
            "second": "Seconde",
            "penaltyType": "Type de pénalité",
            "penaltyMinutes": "Minutes de pénalité",
            "notes": "Notes",
            "select": "Sélectionner",
            "optionalSelect": "Optionnel",
            "saveEvent": "Enregistrer l’événement",
            "saving": "Enregistrement...",
            "close": "Fermer",
            "delete": "Supprimer l’événement",
            "confirmDeleteTitle": "Supprimer l’événement de hockey ?",
            "confirmDeleteMessage": "Supprimer l’événement {{action}} de la période {{period}} à {{time}} ? Cette action est irréversible.",
            "confirmDeleteConfirm": "Supprimer l’événement",
            "confirmDeleteCancel": "Conserver l’événement",
            "required": "Veuillez remplir l’équipe, le joueur, l’action, la période et la minute.",
            "invalidPeriod": "La période doit être un nombre entier supérieur à zéro.",
            "invalidMinute": "Chaque période dure 20 minutes. Saisissez un temps entre 0:00 et 20:00.",
            "invalidSecond": "Les secondes doivent être un nombre entier entre 0 et 59.",
            "saveSuccess": "Événement de hockey enregistré avec succès.",
            "eventTypes": {
                "goal": "But",
                "assist": "Passe décisive",
                "shot": "Tir",
                "penalty": "Pénalité",
                "faceoff_win": "Mise au jeu gagnée",
                "faceoff_loss": "Mise au jeu perdue",
                "hit": "Mise en échec",
                "blocked_shot": "Tir bloqué",
                "takeaway": "Interception",
                "giveaway": "Perte de rondelle",
                "save": "Arrêt",
                "goal_against": "But encaissé",
                "substitution_in": "Entrée",
                "substitution_out": "Sortie"
            },
            "penaltyTypes": {
                "minor": "Mineure",
                "major": "Majeure",
                "misconduct": "Mauvaise conduite",
                "game_misconduct": "Mauvaise conduite de match",
                "match": "Pénalité de match"
            }
        }
    },
    "trainingElement": {
        "type": "ENTRAÎNEMENT",
        "scheduled": "Planifié",
        "trainingSession": "Séance d'entraînement",
        "noTeams": "Aucune équipe",
        "noParticipants": "Aucun participant",
        "emptyValue": "—",
        "teamsCount": "Équipes : ({{count}})",
        "participantsCount": "Participants : ({{count}})",
        "locationLabel": "Lieu : {{value}}",
        "coachLabel": "Entraîneur : {{value}}",
        "actions": "Actions",
        "more": "Plus",
        "toggleDropdown": "Basculer le menu",
        "deleteSession": "Supprimer la séance",
        "showParticipants": "Afficher les participants",
        "hideParticipants": "Masquer les participants",
        "messages": {
            "removedSuccessfully": "Séance d'entraînement supprimée avec succès",
            "failedToDelete": "Échec de la suppression de la séance d'entraînement"
        },
        "confirmDelete": {
            "title": "Supprimer cette séance ?",
            "message": "Vous êtes sur le point de supprimer cette séance d'entraînement.\n\nCette action est irréversible.\n\nÊtes-vous sûr ?",
            "confirmLabel": "Supprimer la séance",
            "cancelLabel": "Annuler"
        }
    },
    "bulkAddGamesModal": {
        "bulk": "LOT",
        "title": "Ajouter des matchs en lot",
        "close": "Fermer",
        "choose": "Choisir",
        "notAvailable": "N/D",
        "teamFallback": "Équipe",
        "headers": {
            "stage": "Étape",
            "group": "Groupe",
            "description": "Description",
            "datetime": "Date et heure",
            "away": "Visiteur",
            "home": "Domicile",
            "venue": "Lieu",
            "responsible": "Arbitre",
            "manager": "Coordinateur",
            "matchday": "Journée"
        },
        "placeholders": {
            "description": "Description"
        },
        "alerts": {
            "fixFollowing": "Veuillez corriger les éléments suivants :",
            "rowLabel": "Ligne {{row}} :"
        },
        "validation": {
            "completeAllFields": "Veuillez remplir tous les champs.",
            "teamsMustBeDifferent": "Les équipes domicile et visiteur doivent être différentes."
        },
        "messages": {
            "gamesCreatedSuccessfully": "Matchs créés avec succès !",
            "errorCreatingGames": "Erreur lors de la création des matchs : {{message}}"
        },
        "buttons": {
            "addAnotherGame": "Ajouter un autre match",
            "saveAll": "Tout enregistrer",
            "saving": "Enregistrement..."
        },
        "hint": "Astuce : utilisez des journées cohérentes pour garder une planification propre.",
        "matchdayOption": "Journée {{matchDay}}",
        "matchdayNewOption": "Journée {{matchDay}} (nouvelle)",
        "removeRow": "Supprimer la ligne"
    },
    "bulkAddTrainingsModal": {
        "bulk": "LOT",
        "title": "Ajouter des entraînements en lot",
        "close": "Fermer",
        "choose": "Choisir",
        "notAvailable": "N/D",
        "headers": {
            "stage": "Étape",
            "group": "Groupe",
            "datetime": "Date et heure",
            "teams": "Équipes",
            "venue": "Lieu",
            "responsibleCoach": "Responsable/Entraîneur"
        },
        "alerts": {
            "fixFollowing": "Veuillez corriger les éléments suivants :",
            "rowLabel": "Ligne {{row}} :"
        },
        "validation": {
            "completeAllFields": "Veuillez remplir tous les champs.",
            "selectAtLeastOneTeam": "Sélectionnez au moins une équipe."
        },
        "messages": {
            "trainingsCreatedSuccessfully": "Séances d'entraînement créées avec succès !",
            "errorCreatingTrainings": "Erreur lors de la création des entraînements : {{message}}"
        },
        "buttons": {
            "addAnotherTraining": "Ajouter un autre entraînement",
            "saveAll": "Tout enregistrer",
            "saving": "Enregistrement..."
        },
        "helpText": "Maintenez Ctrl/Cmd pour sélectionner plusieurs équipes.",
        "hint": "Astuce : vous pouvez sélectionner plusieurs équipes par séance.",
        "removeRow": "Supprimer la ligne"
    },
    "printGameSheetsModal": {
        "title": "Sélectionnez les matchs à imprimer",
        "noGamesAvailable": "Aucun match disponible à imprimer.",
        "selectAll": "Tout sélectionner",
        "unselectAll": "Tout désélectionner",
        "selectedCount": "Sélectionnés : {{selected}} / {{total}}",
        "headers": {
            "dateTime": "Date / Heure",
            "field": "Terrain",
            "match": "Match"
        },
        "fallbacks": {
            "home": "Domicile",
            "away": "Visiteur",
            "emptyValue": "—"
        },
        "vs": "vs",
        "close": "Fermer",
        "printGames": "Imprimer {{count}} match",
        "printGames_plural": "Imprimer {{count}} matchs"
    },
    "gameSheet": {
        "fallbacks": {
            "organization": "Organisation",
            "homeTeam": "Équipe à domicile",
            "awayTeam": "Équipe visiteuse",
            "emptyValue": "—",
            "match": "Match"
        },
        "matchweekLabel": "Journée {{matchDay}}",
        "header": {
            "division": "Division",
            "season": "Saison",
            "stageGroup": "Étape/Groupe",
            "date": "Date",
            "time": "Heure",
            "field": "Terrain",
            "location": "Lieu"
        },
        "teams": {
            "away": "Visiteur",
            "home": "Domicile"
        },
        "score": {
            "finalScore": "Score final"
        },
        "notes": {
            "weather": "Météo",
            "category": "Catégorie",
            "pageHint": "* Utilisez la deuxième page pour noter les incidents, buts, actions et sanctions."
        },
        "rosters": {
            "awayRoster": "Effectif visiteur",
            "homeRoster": "Effectif domicile",
            "number": "#",
            "player": "Joueur",
            "position": "Pos",
            "starter": "Titulaire",
            "notes": "Notes"
        },
        "officials": {
            "title": "Officiels",
            "refereeCrewChief": "Arbitre / Chef d'équipe",
            "assistantUmpire1": "Assistant / Umpire 1",
            "assistantUmpire2": "Assistant / Umpire 2",
            "fourthOfficialUmpire3": "4e officiel / Umpire 3",
            "scorerTableOfficial": "Marqueur / Officiel de table",
            "timekeeper": "Chronométreur",
            "otherOfficials": "Autres officiels"
        },
        "incidents": {
            "title": "Incidents / buts / actions",
            "timeSegment": "Temps / Manche / Set / Quart",
            "team": "Équipe",
            "player": "# / Joueur",
            "eventDescription": "Événement / Description"
        },
        "signatures": {
            "title": "Signatures",
            "awayRepresentative": "Représentant visiteur",
            "homeRepresentative": "Représentant domicile",
            "refereeCrewChief": "Arbitre / Chef d'équipe",
            "leagueRepresentativeOptional": "Représentant de la ligue (optionnel)",
            "commentsProtests": "Commentaires / réclamations"
        }
    },
    "publicSchedulePage": {
        "meta": {
            "schedule": "Calendrier",
            "seasonSchedule": "Calendrier de la saison",
            "pageTitleSuffix": "AngeonX Sports",
            "descriptionWithTitle": "Calendrier officiel pour {{title}}. Consultez les matchs, entraînements et événements mis à jour en temps réel.",
            "defaultDescription": "Calendrier officiel de saison propulsé par AngeonX Sports. Consultez les matchs en direct, entraînements et compétitions."
        },
        "header": {
            "lastUpdated": "Dernière mise à jour : {{value}}",
            "share": "Partager",
            "printSchedule": "Imprimer le calendrier"
        },
        "sections": {
            "seasonSchedule": "Calendrier de la saison",
            "liveScheduleDescription": "Voici le calendrier en direct de cette saison. Toute modification effectuée par le personnel de l’organisation apparaîtra automatiquement ici. Vous pouvez imprimer cette vue ou partager le lien avec les équipes et les familles.",
            "readOnlyNote": "Ce calendrier est en lecture seule. La version officielle, toujours à jour, se trouve dans AngeonX Sports. Si vous l’imprimez, consultez cette page pour les changements de dernière minute."
        },
        "loading": {
            "title": "Chargement du calendrier de la saison..."
        },
        "error": {
            "title": "Calendrier non disponible"
        },
        "shareMessages": {
            "copied": "Lien copié dans le presse-papiers.",
            "copyFailed": "La copie a échoué. Vous pouvez copier l’URL depuis la barre d’adresse.",
            "copyPrompt": "Copiez ce lien :"
        },
        "table": {
            "headers": {
                "dateTime": "Date et heure",
                "type": "Type",
                "matchSession": "Match / Séance",
                "stageGroup": "Étape / Groupe",
                "field": "Terrain",
                "responsible": "Responsable",
                "scoreStatus": "Score / Statut"
            },
            "empty": "Aucun événement programmé pour le moment."
        },
        "eventTypes": {
            "game": "Match",
            "training": "Entraînement",
            "competition": "Compétition",
            "event": "Événement"
        },
        "eventLabels": {
            "teams": "Équipes : {{teams}}",
            "trainingSession": "Séance d'entraînement",
            "competition": "Compétition",
            "event": "Événement",
            "visitor": "Visiteur",
            "home": "Domicile",
            "scheduled": "Planifié",
            "emptyValue": "—"
        },
        "print": {
            "footer": "Calendrier officiel • Généré depuis AngeonX Sports • {{url}}",
            "watermark": "Calendrier AngeonX Sports"
        }
    },
    "editGameModal": {
        "edit": "MODIFIER",
        "title": "Modifier le match",
        "close": "Fermer",
        "save": "Enregistrer",
        "labels": {
            "stage": "Étape",
            "datetime": "Date et heure",
            "description": "Description",
            "visitorTeam": "Équipe visiteuse",
            "homeTeam": "Équipe à domicile",
            "facilityField": "Installation/Terrain",
            "coach": "Entraîneur",
            "refereeUmpire": "Officiels",
            "notInStagePool": "hors de la liste de l’étape",
            "manager": "Coordinateur",
        },
        "placeholders": {
            "chooseStage": "Choisir l'étape",
            "enterDatetime": "Saisir la date et l'heure ...",
            "enterDescription": "Saisir une description ...",
            "chooseVisitorTeam": "Choisir l'équipe visiteuse",
            "chooseHomeTeam": "Choisir l'équipe à domicile",
            "chooseField": "Choisir le terrain",
            "chooseRefereeUmpire": "Choisir l'arbitre/l'umpire",
            "chooseManager": "Choisir le coordinateur",
        },
        "helpText": {
            "stageLocked": "L'étape est verrouillée pour modification."
        },
        "messages": {
            "gameModifiedSuccessfully": "Match modifié avec succès"
        },
        "validation": {
            "conflictOn": "{{name}} le {{date}} à {{field}}"
        }
    },
    "gameResultModal": {
        "result": "RÉSULTAT",
        "title": "Résultat du match",
        "close": "Fermer",
        "save": "Enregistrer",
        "headers": {
            "team": "Équipe",
            "score": "Score"
        },
        "labels": {
            "status": "Statut de l'événement",
            "forfeitTeam": "Équipe forfait",
            "resetIndividualStats": "Réinitialiser les statistiques individuelles",
            "penaltyShootout": "Tirs au but"
        },
        "hockey": {
            "resultType": "Type de résultat",
            "regulation": "Réglementaire",
            "overtime": "Prolongation",
            "shootout": "Tirs de barrage",
            "resultTypeHint": "Utilisez la prolongation ou les tirs de barrage seulement si le match a été décidé après le temps réglementaire.",
            "sections": {
                "teamStats": "Statistiques d’équipe",
                "scoring": "Buts et tirs",
                "goalkeeping": "Gardien de but",
                "discipline": "Discipline et jeu physique",
                "home": "Domicile",
                "visitor": "Visiteur"
            },
            "stats": {
                "shotsOnGoal": "Tirs cadrés", "powerPlayGoals": "Buts en avantage", "powerPlayOpportunities": "Avantages numériques",
                "saves": "Arrêts", "penaltyMinutes": "Minutes de pénalité", "hits": "Mises en échec", "blockedShots": "Tirs bloqués",
                "homeShotsOnGoal": "Tirs cadrés domicile", "awayShotsOnGoal": "Tirs cadrés visiteur",
                "homePenaltyMinutes": "Minutes de pénalité domicile", "awayPenaltyMinutes": "Minutes de pénalité visiteur",
                "homeSaves": "Arrêts domicile", "awaySaves": "Arrêts visiteur",
                "homePowerPlayGoals": "Buts en avantage domicile", "awayPowerPlayGoals": "Buts en avantage visiteur",
                "homePowerPlayOpportunities": "Avantages numériques domicile", "awayPowerPlayOpportunities": "Avantages numériques visiteur",
                "homeHits": "Mises en échec domicile", "awayHits": "Mises en échec visiteur",
                "homeBlockedShots": "Tirs bloqués domicile", "awayBlockedShots": "Tirs bloqués visiteur"
            }
        },
        "teams": {
            "visitor": "Visiteur",
            "home": "Domicile"
        },
        "aria": {
            "visitorScore": "Score visiteur",
            "homeScore": "Score domicile",
            "eventStatus": "Statut de l'événement",
            "forfeitTeam": "Équipe forfait",
            "visitorPenalties": "Tirs au but visiteur",
            "homePenalties": "Tirs au but domicile"
        },
        "options": {
            "selectForfeitTeam": "Sélectionner l’équipe"
        },
        "validation": {
            "selectForfeitTeam": "Sélectionnez l’équipe qui a déclaré forfait.",
            "penaltyScoresRequired": "Saisissez les deux scores des tirs au but.",
            "penaltyWinnerRequired": "Les tirs au but doivent produire un vainqueur."
        },
        "scheduledStatusWarningWithIndividualStats": "Avertissement : si le match est enregistré comme planifié, les statistiques globales et individuelles seront réinitialisées.",
        "scheduledStatusWarningWithoutIndividualStats": "Avertissement : si le match est enregistré comme planifié, les statistiques globales seront réinitialisées. Les statistiques individuelles ne seront pas réinitialisées sauf si cette option est sélectionnée.",
        "hint": "Astuce : saisissez uniquement les scores finaux. Vous pourrez modifier plus tard tant que le match reste planifié/en cours.",
        "messages": {
            "gameResultAddedSuccessfully": "Résultat du match ajouté avec succès"
        }
    },
    "baseballScore": {
        "badge": "MANCHES",
        "title": "Feuille de score par manche",
        "subtitle": "Enregistrez les points manche par manche",
        "visitor": "Visiteur",
        "home": "Domicile",
        "final": "Score final",
        "extended": "Score détaillé",
        "scorecard": "Feuille de score",
        "runsShort": "Points",
        "team": "Équipe",
        "hint": "Saisissez les points des manches jouées. Laissez les manches futures à zéro.",
        "inning": "Manche",
        "total": "R",
        "addInning": "Ajouter une manche",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "close": "Fermer",
        "saving": "Enregistrement...",
        "messages": {"saved": "Score enregistré", "saveFailed": "Échec de l'enregistrement du score"}
    },
    "gameSanctionModal": {
        "new": "NOUVELLE",
        "title": "Ajouter une sanction",
        "subtitle": "Créer une sanction pour {{season}}.",
        "fallbacks": {
            "season": "cette saison",
            "visitor": "Visiteur",
            "home": "Domicile"
        },
        "labels": {
            "team": "Équipe",
            "player": "Joueur",
            "type": "Type",
            "gamesSuspended": "Matchs suspendus",
            "reason": "Motif",
            "notes": "Notes",
            "matchweek": "Journée {{value}}"
        },
        "placeholders": {
            "selectTeam": "Sélectionner l'équipe",
            "selectPlayer": "Sélectionner le joueur",
            "selectType": "Sélectionner le type",
            "gamesSuspended": "0",
            "reason": "ex. carton rouge, conduite antisportive…",
            "notes": "Détails optionnels…"
        },
        "types": {
            "suspension": "Suspension"
        },
        "buttons": {
            "close": "Fermer",
            "cancel": "Annuler",
            "add": "Ajouter",
            "saving": "Enregistrement…"
        },
        "messages": {
            "requiredFields": "Veuillez remplir les champs requis.",
            "created": "Sanction créée",
            "failed": "Échec de la création de la sanction"
        }
    },
    stageDetail: {
        nav: {
            schedule: "Calendrier",
            organizations: "Organisations",
            divisions: "Divisions",
            divisionShort: "Div",
        },

        labels: {
            coaches: "Entraîneurs",
            refereesOrUmpires: "Officiels",
            groups: "Groupes",
            date: "Date",
            venues: "Sites",
            availableFields: "Terrains disponibles",
            selectedFields: "Terrains sélectionnés",
        },

        dualList: {
            venuesTitle: "Sites",
            venuesDescription: "Choisissez les sites pour cette étape",
        },

        buttons: {
            createSchedule: "Créer le calendrier",
            cancel: "Annuler",
            processing: "Traitement...",
        },

        confirm: {
            title: "Confirmer la génération du calendrier",
            message:
                "Vous êtes sur le point de générer tout le calendrier en utilisant les Groupes/Équipes, Sites, Dates et Arbitres configurés.\n\nVoulez-vous continuer ?",
        },

        alerts: {
            somethingWentWrong: "Une erreur s'est produite",
            scheduleCreated: "Calendrier créé avec succès",
            failedToCreateSchedule: "Échec de la création du calendrier",

            tabGroupsErrorTitle: "Erreur dans l’onglet Groupes.",
            tabGroupsErrorMessage: "Veuillez d’abord créer les groupes.",

            tabDateErrorTitle: "Erreur dans l’onglet Date.",
            tabDateErrorMessage: "Veuillez sélectionner au moins un jour.",

            tabVenuesErrorTitle: "Erreur dans l’onglet Sites.",
            tabVenuesErrorMessage: "Veuillez sélectionner au moins un terrain.",

            scheduleErrorTitle: "Erreur de calendrier.",
            scheduleErrorMessage:
                "Vous ne pouvez pas créer un calendrier pour des étapes avec des matchs ayant déjà des résultats saisis.",
        },
    },
    groupsList: {
        header: {
            title: "Groupes et Équipes",
            subtitle: "Répartissez les équipes en groupes pour {{seasonName}}",
            fallbackSeason: "cette saison",
        },

        info: {
            teamsInStage: "Équipes dans cette étape",
            teamsCount: "{{count}} équipes",
            scheduleType: "Type de calendrier",
            emptyValue: "—",
        },

        sections: {
            draftTools: "Outils de répartition",
            draftToolsDescription:
                "Attribuez aléatoirement les équipes marquées comme todo aux groupes existants, ou redémarrez la répartition.",
            groups: "Groupes",
            groupsDescription: "Créez et gérez les groupes pour cette étape.",
        },

        buttons: {
            randomDraft: "Répartition aléatoire",
            restartDraft: "Recommencer la répartition",
        },

        tooltips: {
            randomDraft: "Répartir aléatoirement les équipes dans les groupes",
            restartDraft: "Recommencer la répartition (retirer les équipes des groupes)",
        },

        alerts: {
            createGroupsFirst: "Veuillez d’abord créer des groupes",
            addTeamGroupError: "Impossible d’ajouter les équipes aux groupes",
            cleanGroupsError: "Impossible de réinitialiser les groupes",
        },

        emptyState: {
            createGroupsFirst: "Créez d’abord des groupes",
            createGroupsFirstDescription:
                "Utilisez le panneau Groupes pour créer votre structure de groupes avant de répartir les équipes.",
        },
    },
    listTeams: {
        section: {
            title: "Groupes et Équipes",
            subtitle:
                "Faites glisser les équipes dans les groupes. Utilisez les cases à cocher pour retirer plusieurs équipes d’un groupe.",
        },

        containers: {
            teams: "Équipes",
            noUnassignedTeams: "Aucune équipe non assignée",
            dropTeamsHere: "Déposez les équipes ici",
            teamsListAria: "Liste des équipes",
            groupDropZoneAria: "Zone de dépôt du groupe",
        },

        buttons: {
            removeSelected: "Retirer la sélection",
            deleteGroup: "Supprimer le groupe",
        },

        confirm: {
            deleteGroupTitle: "Supprimer ce groupe ?",
            deleteGroupMessage:
                "Les équipes de ce groupe seront déplacées vers la liste des Équipes.\n\nVoulez-vous vraiment continuer ?",
            deleteGroupConfirmLabel: "Supprimer le groupe",
            cancel: "Annuler",
        },

        status: {
            unassigned: "Non assignée",
            assignedToGroup: "Assignée à un groupe",
        },

        toasts: {
            addingTeamToGroup: "Ajout de l’équipe au groupe…",
            failedToRemoveTeamFromGroup: "Impossible de retirer l’équipe du groupe",
            failedToAddTeamToGroup: "Impossible d’ajouter l’équipe au groupe",
            failedToRemoveTeams: "Impossible de retirer les équipes",
            failedToDeleteGroup: "Impossible de supprimer le groupe",
        },

        misc: {
            drag: "Glisser",
        },
    },
    createGroup: {
        labels: {
            groupName: "Nom du groupe",
            poolName: "Nom du groupe",
            gameName: "Nom du match",
        },

        placeholders: {
            groupName: "Nom du groupe",
            poolName: "Nom du groupe",
            gameName: "Nom du match",
        },

        buttons: {
            createGroup: "Créer un groupe",
            createPool: "Créer un groupe",
            createGame: "Créer un match",
        },

        nouns: {
            group: "Groupe",
            pool: "Groupe",
            game: "Match",
        },

        hints: {
            tip: "Astuce : créez d’abord tous les {{itemName}}, puis utilisez {{randomDraft}} pour répartir les équipes. Si votre phase est une structure de ligue, créez un seul groupe avec tous les équipes.",
            randomDraft: "Répartition aléatoire",
        },

        toasts: {
            createdSuccessfully: "{{noun}} créé avec succès",
            onlyOnePoolAllowed: "Un seul groupe est autorisé",
            failedToCreate: "Impossible de créer {{noun}}",
        },
    },
    stagePlayDaysList: {
        header: {
            title: "Jours et heures disponibles",
            subtitle: "Créneaux horaires pour les matchs de cette étape",
            addDay: "Ajouter un jour",
            addDayTitle: "Ajouter un créneau jour/heure",
        },

        table: {
            day: "Jour",
            time: "Heure",
            actions: "Actions",
            weeklySlot: "Créneau hebdomadaire",
            fromTime: "Heure de début",
            deleteDayTime: "Supprimer le jour/créneau",
        },

        confirm: {
            deleteTitle: "Supprimer ce jour/créneau ?",
            deleteMessage:
                "Vous êtes sur le point de supprimer :\n\n{{dayName}} à {{fromTime}}\n\nCela affectera la génération du calendrier pour cette étape. Cette action est irréversible.",
            delete: "Supprimer",
            cancel: "Annuler",
        },

        days: {
            monday: "Lundi",
            tuesday: "Mardi",
            wednesday: "Mercredi",
            thursday: "Jeudi",
            friday: "Vendredi",
            saturday: "Samedi",
            sunday: "Dimanche",
            selectedDay: "Jour sélectionné",
        },
    },
    addStagePlayDayModal: {
        header: {
            title: "Ajouter un jour et une heure",
            subtitle: "Définissez un créneau jour/heure jouable pour cette étape",
            close: "Fermer",
        },

        fields: {
            day: "Jour",
            time: "Heure",
            chooseDay: "Choisissez un jour",
            enterTime: "Saisir l'heure...",
        },

        buttons: {
            close: "Fermer",
            save: "Enregistrer",
            saving: "Enregistrement...",
        },

        helper: {
            tip: "Astuce : choisissez des créneaux horaires cohérents (par exemple 18:00) pour simplifier la planification et réduire les conflits.",
        },

        toasts: {
            addedSuccessfully: "Jour et heure ajoutés avec succès",
            somethingWentWrong: "Une erreur s'est produite",
            stageRequired: "Étape introuvable. Veuillez actualiser puis réessayer.",
            dayRequired: "Veuillez choisir un jour",
            timeRequired: "Veuillez choisir une heure",
            invalidDay: "Jour sélectionné invalide",
        },

        days: {
            monday: "Lundi",
            tuesday: "Mardi",
            wednesday: "Mercredi",
            thursday: "Jeudi",
            friday: "Vendredi",
            saturday: "Samedi",
            sunday: "Dimanche",
        },
    },
    dualListSelector: {
        defaults: {
            title: "Sélectionner des éléments",
            description: "Choisissez des éléments dans la liste",
            leftTitle: "Disponibles",
            rightTitle: "Sélectionnés",
        },

        search: {
            placeholder: "Rechercher...",
        },

        labels: {
            available: "Disponible",
            selected: "Sélectionné",
        },

        buttons: {
            add: "Ajouter",
            remove: "Retirer",
        },

        empty: {
            noItemsFound: "Aucun élément trouvé.",
            noItemsSelected: "Aucun élément sélectionné.",
        },

        hints: {
            searchByVenueOrField:
                "Astuce : recherchez par nom du site ou du terrain.",
            selectedItemsUsedForStage:
                "Les éléments sélectionnés seront utilisés pour cette étape.",
        },

        titles: {
            add: "Ajouter",
            remove: "Retirer",
        },
    },
    refereeList: {
        roles: {
            coaches: "Entraîneurs",
            refereesOrUmpires: "Officiels",
        },

        header: {
            chooseForStage: "Choisissez les {{role}} pour cette étape",
        },

        sections: {
            available: "{{role}} disponibles",
            selected: "{{role}} sélectionnés",
        },

        search: {
            placeholder: "Rechercher {{role}}...",
        },

        labels: {
            rating: "Évaluation",
        },

        buttons: {
            add: "Ajouter",
            remove: "Retirer",
        },

        empty: {
            noRoleFound: "Aucun {{role}} trouvé.",
            noRoleSelected: "Aucun {{role}} sélectionné.",
        },

        helper: {
            availableTip:
                "Astuce : ajoutez des {{role}} à gauche ; ils apparaîtront dans “Sélectionnés”.",
            selectedTip:
                "Les {{role}} sélectionnés seront utilisés pour la planification et l’affectation dans cette étape.",
        },

        actions: {
            remove: "retirer",
        },
    },
    errorPage: {
        meta: {
            title: "AngeonX Sports – Page introuvable",
        },

        brand: {
            platform: "Plateforme AngeonX Sports",
            pageNotFound: "Page introuvable",
        },

        content: {
            title404: "404",
            description:
                "La page que vous recherchez n'existe pas ou le lien n'est plus valide.",
        },

        reasons: {
            typo: "L’URL peut contenir une erreur.",
            movedOrRemoved: "La page a peut-être été déplacée ou supprimée.",
            outdatedLink:
                "Un ancien lien peut pointer vers un emplacement obsolète.",
        },

        buttons: {
            backToHome: "Retour à l’accueil",
            goBack: "Retourner",
        },

        help: {
            internalAppIssue:
                "Si cela continue à se produire dans l’application, veuillez en informer l’administrateur de votre ligue ou organisation afin qu’il puisse vérifier le lien.",
            quickTips: "Conseils rapides",
            navTip:
                "Utilisez la navigation principale pour accéder à vos ligues, calendriers et matchs.",
            inviteTip:
                "Si vous avez ouvert une invitation ou un lien partagé, assurez-vous qu’il n’a pas expiré ou été modifié.",
            needHelp: "Besoin d’aide ou trouvé un lien cassé ?",
            supportText:
                "Pour le support de AngeonX Sports et d’autres produits AngeonX, vous pouvez nous joindre à :",
            productLine: "AngeonX Sports™ est un produit de AngeonX Inc.",
        },
    },
    verifyEmail: {
        meta: {
            title: "AngeonX Sports – Vérification de l’e-mail",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Vérification de l’e-mail",
            readyForSignIn: "Votre compte est prêt pour la connexion !",
        },

        status: {
            verifying: "Vérification...",
            verifiedSuccess:
                "✅ Votre e-mail a été vérifié ! Vous pouvez maintenant vous connecter à AngeonX Sports.",
            unknownError: "Une erreur inconnue s’est produite.",
            genericError: "⚠️ Une erreur s’est produite. Veuillez réessayer.",
            accountAlreadyVerified: "Le compte est déjà vérifié.",
        },

        actions: {
            openApp: "Ouvrir l’app AngeonX Sports",
            continueWeb: "Continuer vers la connexion web",
        },
    },
    deleteAccount: {
        meta: {
            title: "AngeonX Sports – Supprimer le compte",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Supprimer votre compte",
            intro:
                "Vous pouvez supprimer votre compte AngeonX Sports à tout moment directement depuis l'application mobile :",
        },

        steps: {
            openApp: "Ouvrez l'application",
            goSettings: "Allez dans Plus → Paramètres",
            tapDelete: 'Appuyez sur "Supprimer le compte"',
        },

        help: {
            emailIntro:
                "Si vous ne pouvez pas accéder à l’application, envoyez-nous un e-mail à",
            emailInstruction:
                "depuis votre adresse e-mail enregistrée avec votre demande de suppression.",
            processingTime: "Nous traiterons votre demande sous 7 jours.",
        },

        actions: {
            backToLogin: "Retour à la connexion",
        },
    },
    marketplaceRedirect: {title: "Ouvrir cette annonce dans AngeonX Sports", description: "Continuez dans l’application mobile AngeonX Sports pour voir cette annonce du marketplace.", openApp: "Ouvrir dans l’application", invalid: "Le lien de cette annonce n’est pas valide.", noApp: "Si l’application ne s’est pas ouverte, installez-la ici :", ios: "iPhone / iPad", android: "Android"},
    inviteRedirect: {
        meta: {
            title: "AngeonX Sports – Ouverture de l’application",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Ouverture de l’application...",
            description:
                "Si rien ne se passe, vous serez bientôt redirigé pour installer l’application.",
        },
    },
    successPage: {
        meta: {
            title: "AngeonX Sports – Abonnement réussi",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Abonnement créé avec succès !",
            description: "Votre nouveau plan d’abonnement est prêt à être utilisé !",
        },
    },
    cancelPage: {
        meta: {
            title: "AngeonX Sports – Abonnement annulé",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Abonnement annulé avec succès !",
        },
    },
    passwordReset: {
        meta: {
            title: "AngeonX Sports – Réinitialiser le mot de passe",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Réinitialiser le mot de passe",
        },

        fields: {
            newPassword: "Nouveau mot de passe",
            confirmNewPassword: "Confirmer le nouveau mot de passe",
        },

        buttons: {
            resetPassword: "Réinitialiser le mot de passe",
            resetting: "Réinitialisation...",
            close: "Fermer",
        },

        status: {
            success: "✅ Votre mot de passe a été réinitialisé ! Vous pouvez maintenant vous connecter.",
        },

        errors: {
            title: "Erreurs",
            enterAndConfirmPassword: "Veuillez saisir et confirmer votre nouveau mot de passe.",
            passwordsDoNotMatch: "Les mots de passe ne correspondent pas.",
            unknownError: "Une erreur inconnue s'est produite.",
            somethingWentWrong: "⚠️ Une erreur s'est produite. Veuillez réessayer.",
        },
    },
    publicEventPage: {
        meta: {
            siteName: "AngeonX Sports",
            defaultDescription: "Détails officiels de l’événement fournis par AngeonX Sports.",
            locale: "fr_CA",
            eventFallback: "Événement",
            loadingTitle: "Chargement de l’événement...",
            notFoundTitle: "Événement introuvable",
        },

        loading: {
            details: "Chargement des détails de l’événement...",
        },

        error: {
            title: "Événement introuvable",
            description: "Cet événement a peut-être été supprimé ou n’est plus disponible.",
        },

        breadcrumb: {
            events: "Événements",
        },

        status: {
            final: "Final",
            live: "En direct",
            cancelled: "Annulé",
            upcoming: "À venir",
            scheduled: "Planifié",
            completed: "Terminé",
            inProgress: "En cours",
        },

        sections: {
            event: "Événement",
            eventOverview: "Aperçu de l’événement",
            photos: "Photos",
        },

        labels: {
            home: "Domicile",
            away: "Extérieur",
            timeline: "Chronologie",
            lineups: "Alignements",
            stats: "Statistiques",
            dateTime: "Date et heure",
            venue: "Lieu",
            competition: "Compétition",
            eventType: "Type d’événement",
            locationMap: "Carte de localisation",
            googleMaps: "Google Maps",
            rating: "Évaluation",
            gameSummary: "Résumé du match",
            eventTypeFallback: "ÉVÉNEMENT",
            teamFallback: "Équipe",
        },

        timeline: {
            emptyTitle: "Aucun événement de chronologie publié pour le moment.",
            emptyDescription: "Revenez plus près de l’heure du match ou consultez l’application AngeonX Sports.",
        },

        lineups: {
            title: "Les alignements sont gérés dans AngeonX Sports.",
            description: "Téléchargez l’application pour voir les alignements officiels et les changements en temps réel.",
        },

        stats: {
            title: "Les statistiques de cet événement apparaîtront ici.",
            description: "Suivez l’événement dans AngeonX Sports pour débloquer les statistiques complètes des joueurs et des équipes.",
        },

        photos: {
            open: "Ouvrir la photo",
            close: "Fermer la photo",
            previous: "Photo précédente",
            next: "Photo suivante",
            photoAlt: "Photo de l’événement",
        },
    },
    advertisePage: {
        meta: {
            title: "AngeonX Sports – Faire de la publicité",
        },

        hero: {
            title: "Placez votre marque devant les joueurs, parents et équipes",
            description1:
                "AngeonX Sports est l’endroit où les ligues, tournois et académies gèrent leurs matchs, calendriers, effectifs, statistiques et communications.",
            description2:
                "Votre entreprise peut apparaître exactement là où ils passent leur temps — dans l’application.",
            bullet1:
                "Affichez votre marque dans l’application AngeonX Sports — comme une carte vedette.",
            bullet2:
                'Bouton à ouvrir au toucher (« Voir plus ») qui redirige les gens vers votre promotion ou site.',
            bullet3:
                "Vue développée en option avec votre message complet et votre visuel.",
            bullet4:
                "Ciblez par sport (soccer, baseball, softball, etc.).",
            pricing:
                "Les espaces publicitaires commencent à 99 $/semaine. Aucun contrat à long terme.",
            createSponsorAccount: "Créer un compte sponsor",
            alreadyHaveAccount: "Vous avez déjà un compte ?",
            signIn: "Se connecter",
        },

        preview: {
            logoPlaceholder: "Votre Logo",
            cardTitle: "Votre entreprise — obtenez plus de joueurs, clients ou acheteurs",
            cardText:
                "« Entraînez-vous avec les meilleurs coachs de la ville. Places limitées ce mois-ci… »",
            viewMore: "Voir plus",
            seeMore: "Voir plus",
            sponsoredPlacement: "Placement sponsorisé dans AngeonX Sports",
            expandedTitle: "Mise en avant plein écran",
            expandedSubtitle: "(Votre mise en avant de marque)",
            expandedHeadline: "Votre titre — démarquez-vous auprès du bon public",
            expandedText:
                "C’est ici que vous racontez toute votre histoire : votre camp, votre clinique, votre service, votre boutique. Les utilisateurs peuvent appuyer pour en savoir plus, s’inscrire ou vous contacter.",
            expandedFooter: "Exemple de vue sponsor développée dans l’application",
        },

        howItWorks: {
            title: "Comment ça marche",
            step1Title: "1. Créez votre compte sponsor",
            step1Text:
                "Dites-nous qui vous êtes et ce que vous proposez. Cela vous donne accès à votre tableau de bord sponsor.",
            step2Title: "2. Lancez votre campagne",
            step2Text:
                "Téléversez votre bannière, choisissez le sport (soccer, baseball, etc.), sélectionnez vos dates et payez par carte.",
            step3Title: "3. Soyez vu dans l’application",
            step3Text:
                "Votre publicité s’affiche dans AngeonX Sports pour les joueurs, parents et coachs. Vous pourrez voir les vues et clics.",
        },

        faq: {
            whoIsThisForTitle: "À qui s’adresse cela ?",
            whoIsThisForText:
                "Académies d’entraînement, entreprises locales, cliniques sportives, physiothérapie, produits de récupération, tournois, produits dérivés, camps, coachs privés — toute personne qui souhaite être visible dans le sport jeunesse et amateur.",
            longContractTitle: "Ai-je besoin d’un long contrat ?",
            longContractText:
                "Non. Vous pouvez lancer une courte campagne d’une semaine. Parfait pour les camps à dates limitées ou les promotions avec échéance.",
        },

        finalCta: {
            createSponsorAccount: "Créer un compte sponsor",
            alreadySponsor: "Déjà sponsor ?",
            signIn: "Se connecter",
        },
    },
    notificationsPage: {
        page: {
            title: "Notifications",
            inbox: "Boîte de réception",
            subtitle: "{{count}} notification{{suffix}} pour {{name}}",
        },

        tabs: {
            label: "Vues des notifications",
            received: "Reçues",
            sent: "Envoyées",
        },

        table: {
            headers: {
                sender: "Expéditeur",
                title: "Titre",
                message: "Message",
                type: "Type",
                created: "Créé",
                actions: "Actions",
            },
            notificationFallback: "Notification",
            systemSender: "Système",
            emptyType: "—",
            read: "Lue",
            unread: "Non lue",
            rating: "Évaluation",
        },

        actions: {
            markAsRead: "Marquer comme lue",
            alreadyRead: "Déjà lue",
            read: "Lue",
            delete: "Supprimer",
            deleteAll: "Tout supprimer",
            markAllAsRead: "Tout marquer comme lu",
            refresh: "Actualiser",
            noActions: "Aucune action",
        },

        bulk: {
            markAllAsReadTitle: "Marquer toutes les notifications comme lues",
            deleteAllTitle: "Supprimer toutes les notifications",
            refreshTitle: "Actualiser",
        },

        confirmations: {
            markAllTitle: "Tout marquer comme lu",
            markAllMessage:
                "Cela marquera toutes les notifications comme lues pour votre profil actif. Continuer ?",
            markAllConfirm: "Tout marquer comme lu",
            deleteAllTitle: "Supprimer toutes les notifications",
            deleteAllMessage:
                "Cela supprimera définitivement toutes les notifications de votre profil actif. Continuer ?",
            deleteAllConfirm: "Tout supprimer",
        },

        toasts: {
            missingActiveProfile: "Profil actif manquant.",
            missingNotificationId: "ID de notification manquant.",
            failedMarkRead: "Échec du marquage comme lue.",
            failedDelete: "Échec de la suppression de la notification.",
            failedMarkAllRead: "Échec du marquage global comme lu.",
            failedDeleteAll: "Échec de la suppression de toutes les notifications.",
            markedRead: "Marquée comme lue.",
            couldNotMarkRead: "Impossible de marquer comme lue.",
            deleted: "Supprimée.",
            couldNotDelete: "Impossible de supprimer la notification.",
            allMarkedRead: "Toutes les notifications ont été marquées comme lues.",
            couldNotMarkAllRead: "Impossible de tout marquer comme lu.",
            allDeleted: "Toutes les notifications ont été supprimées.",
            couldNotDeleteAll: "Impossible de supprimer toutes les notifications.",
            failedSend: "Échec de l’envoi de la notification.",
            sentCreated: "Envoyé. {{count}} notifications créées.",
            sendFailed: "L’envoi a échoué.",
            titleRequired: "Le titre est requis.",
            messageRequired: "Le message est requis.",
            selectOrganization: "Veuillez sélectionner une organisation.",
        },

        compose: {
            allDivisions: "Toutes les divisions",
            allSeasons: "Toutes les saisons",
            allTeams: "Toutes les équipes",
            selectedCount: "{{count}} sélectionnés",
            audienceManagersOnly: "Managers uniquement",
            audienceRefereesOnly: "Arbitres uniquement",
            audienceEveryone: "Tout le monde (Managers, Arbitres, Joueurs)",
            orgFallback: "Organisation",
            divisionFallback: "Division",
        },

        row: {
            unreadTitle: "Non lue",
            readTitle: "Lue",
            sentTitle: "Envoyée",
        },
    },
    notificationFiltersBar: {
        header: {
            title: "Filtres",
            subtitle: "Affinez les résultats par statut et type, puis cliquez sur Appliquer",
        },

        actions: {
            compose: "Rédiger",
            reset: "Réinitialiser",
            apply: "Appliquer",
        },

        tooltips: {
            compose: "Rédiger une nouvelle notification",
            reset: "Réinitialiser les filtres",
            apply: "Appliquer les filtres",
        },

        fields: {
            status: "Statut",
            typeSingleSelect: "Types (sélection unique : cliquez pour choisir, cliquez à nouveau pour effacer)",
            filterByStatus: "Filtrer par statut",
            filterByType: "Filtrer par type",
        },

        statusOptions: {
            all: "Tous",
            unread: "Non lues",
            read: "Lues",
        },

        empty: {
            noTypesAvailable: "Aucun type de notification disponible.",
        },
    },
    notificationTypes: {
        chat: "Chat",
        event: "Événement",
        gamification: "Gamification",
        notification: "Notification",
        invite: "Invitation",
        payment: "Paiement",
        rate: "Évaluations",
        result: "Résultat",
        team: "Équipe",
        organization: "Organisation",
        link: "Lien",
    },
    notificationComposeDrawer: {
        header: {
            title: "Rédiger",
            subtitle: "Rédigez une nouvelle notification et segmentez les destinataires",
            close: "Fermer",
        },

        recipientBar: {
            previewTitle: "Aperçu de la segmentation des destinataires",
            org: "Org :",
            division: "Division :",
            season: "Saison :",
            teams: "Équipes :",
            recipients: "Destinataires :",
        },

        fields: {
            title: "Titre",
            titlePlaceholder: "ex. Mise à jour du calendrier",
            message: "Message",
            messagePlaceholder: "Rédigez votre message…",
            recipients: "Destinataires",
            organization: "Organisation",
            division: "Division",
            season: "Saison",
            teamsMulti: "Équipes (sélection multiple)",
        },

        recipients: {
            everyone: "Tout le monde (Managers, Arbitres, Joueurs)",
            managersOnly: "Managers d’équipe בלבד",
            refereesOnly: "Arbitres/Umpires uniquement",
        },

        hints: {
            recipients:
                "Cela détermine quels rôles reçoivent la notification dans la segmentation sélectionnée.",
            teams:
                "Sélectionnez une ou plusieurs équipes, ou laissez vide pour toutes.",
            teamsDisabled:
                "La sélection des équipes est désactivée lorsque les destinataires sont les arbitres.",
        },

        actions: {
            cancel: "Annuler",
            send: "Envoyer",
            sending: "Envoi...",
        },

        labels: {
            all: "Tous",
            selectedCount: "{{count}} sélectionnés",
        },
    },
    "subscriptionLimit": {
        "organization_limit_reached": "Vos abonnements d'organisation permettent seulement {{limit}} {{item}}. Passez à une offre supérieure pour en créer davantage.",
        "limit_reached": "Vous avez atteint la limite de votre abonnement. Améliorez votre abonnement pour continuer.",
        "planLimit": "Votre forfait actuel ({{currentPlan}}) permet seulement {{limit}} {{itemLabel}}. Mettez à niveau votre abonnement pour en débloquer davantage.",
        "feature_required": "Cette fonctionnalité n’est pas disponible avec votre abonnement actuel. Améliorez votre abonnement pour continuer."
    },
    "organizationDivisionSummary": {
        "loading": "Chargement du résumé de l’organisation...",
        "error": "Impossible de charger le résumé de l’organisation.",
        "noData": "Aucune donnée disponible pour le moment.",
        "title": "Aperçu de l’Organisation",
        "subtitle": "Résumé des divisions, saisons actives, équipes, joueurs et matchs.",
        "seasonProgress": "Progression de la Saison",
        "cards": {
            "divisions": "Divisions",
            "activeSeasons": "Saisons Actives",
            "teams": "Équipes",
            "players": "Joueurs",
            "games": "Matchs",
            "completed": "Terminés",
            "scheduled": "Planifiés",
            "issues": "Problèmes"
        },
        "hints": {
            "openDivisions": "{{count}} ouvertes",
            "currentlyRunning": "En cours",
            "registeredTeams": "Équipes inscrites",
            "registeredPlayers": "Joueurs inscrits",
            "completedGames": "{{count}} terminés",
            "finishedGames": "Matchs terminés",
            "upcomingPending": "À venir/en attente",
            "postponedCancelled": "Annulés"
        },
        "charts": {
            "teamsByDivision": {
                "title": "Équipes par Division",
                "subtitle": "Principales divisions par équipes inscrites"
            },
            "playersByDivision": {
                "title": "Joueurs par Division",
                "subtitle": "Principales divisions par joueurs inscrits"
            },
            "gamesByStatus": {
                "title": "Matchs par Statut",
                "subtitle": "État opérationnel actuel"
            }
        },
        "chartLabels": {
            "teams": "Équipes",
            "players": "Jouurs"
        },
        "status": {
            "completed": "Terminé",
            "scheduled": "Planifié",
            "pending": "En attente",
            "open": "Ouvert",
            "postponed": "Reporté",
            "cancelled": "Annulé",
            "done": "Fait",
            "finished": "Terminé",
            "unknown": "Inconnu"
        }
    },
    advertisingDashboard: {
        "United States": "États-Unis",
        "Canada": "Canada",
        "All Statuses": "Tous les statuts",
        "Running": "En cours",
        "Paused": "En pause",
        "Ended": "Terminée",
        "Draft": "Brouillon",
        "Archived": "Archivée",
        "Pending Payment": "Paiement en attente",
        "Active": "Active",
        "Inactive": "Inactive",
        "Scheduled": "Programmée",
        "Completed": "Terminée",
        "Canceled": "Annulée",
        "Cancelled": "Annulée",
        "Expired": "Expirée",
        noAdvertisingDataForPeriod: "Aucune donnée publicitaire pour cette période.",
        "No advertising data for this period.": "Aucune donnée publicitaire pour cette période.",
        "Campaign Details": "Détails de la campagne",
        "Campaign": "Campagne",
        "Sponsor": "Sponsor",
        "Status": "Statut",
        "Impressions": "Impressions",
        "Clicks": "Clics",
        "CTR": "CTR",
        "CPM": "CPM",
        "CPC": "CPC",
        "Budget": "Budget",
        "Spent": "Dépensé",
        "Advertising": "Publicité",
        "Dashboard": "Tableau de bord",
        "All Sponsors": "Tous les sponsors",
        "All Campaigns": "Toutes les campagnes",
        "All Screens": "Tous les écrans",
        "All Countries": "Tous les pays",
        "Start Date": "Date de début",
        "End Date": "Date de fin",
        "Screen": "Écran",
        "Country": "Pays",
        "Reset": "Réinitialiser",
        "Unable to load advertising analytics.": "Impossible de charger les analyses publicitaires.",
        "Loading advertising analytics...": "Chargement des analyses publicitaires...",
        "Total ad views": "Vues totales des annonces",
        "Total ad clicks": "Clics totaux sur les annonces",
        "Click-through rate": "Taux de clics",
        "Cost per thousand impressions": "Coût pour mille impressions",
        "Cost per click": "Coût par clic",
        "Campaigns": "Campagnes",
        "active": "actif",
        "Paid": "Payé",
        "Confirmed ad orders": "Commandes d'annonces confirmées",
        "remaining": "restant",
        "Tracked campaign spend": "Dépenses de campagne suivies",
        "Daily Performance": "Performance quotidienne",
        "Traffic By Country": "Trafic par pays",
        "Traffic By Screen": "Trafic par écran",
        "Traffic By Ad Zone": "Trafic par zone publicitaire",
        "Creative Performance": "Performance créative",
        "Campaign Performance": "Performance de la campagne",
        performanceOverview: "Aperçu des performances de vos campagnes publicitaires.",
        "Performance overview for your advertising campaigns.": "Aperçu des performances de vos campagnes publicitaires."
    },
    advertisingAudience: {
        advertising: "Publicité",
        audience: "Audience",
        description: "Estimations d'audience pour planifier les campagnes publicitaires.",
        scopedDescription: "Les estimations d’audience reflètent les utilisateurs que vos campagnes peuvent atteindre selon les règles de protection Enterprise.",
        staffDescription: "La vue staff affiche par défaut tous les utilisateurs actifs de la plateforme. Les filtres réduisent le tableau par sport ou organisation.",
        sport: "Sport",
        league: "Organisation",
        allSports: "Tous les sports",
        allLeagues: "Toutes les organisations",
        allVisibleLeagues: "Toutes les organisations visibles",
        reset: "Réinitialiser",
        loadError: "Impossible de charger les estimations d'audience.",
        loading: "Chargement des estimations d'audience...",
        activePeriod: "Période active",
        last7Days: "7 derniers jours",
        last30Days: "30 derniers jours",
        last3Months: "3 derniers mois",
        last6Months: "6 derniers mois",
        last1Year: "Dernière année",
        totalUsers: "Utilisateurs totaux",
        totalUsersHint: "Utilisateurs joignables sur la plateforme",
        reachableUsers: "Utilisateurs joignables",
        reachableUsersHint: "Filtré selon la portée publicitaire de votre organisation",
        staffTotalUsersHint: "Tous les utilisateurs actifs de la plateforme",
        staffAllUsersNotice: "Mode staff : ce tableau utilise toute l’audience des utilisateurs actifs, sauf si vous appliquez des filtres.",
        activeUsers: "Utilisateurs actifs",
        newUsers: "Nouveaux utilisateurs",
        active7Days: "Actifs 7 jours",
        active7DaysHint: "Utilisateurs récemment actifs",
        active30Days: "Actifs 30 jours",
        active30DaysHint: "Utilisateurs actifs mensuels",
        newUsersOverTime: "Nouveaux utilisateurs dans le temps",
        audienceBySport: "Audience par sport",
        visibleLeagueAudience: "Audience des organisations visibles",
        topLeagues: "Organisations principales",
        noAudienceData: "Aucune donnée d'audience disponible.",
        noLeagueData: "Aucune donnée d'audience par organisation disponible."
    },
    sponsors: {
        advertising: "Publicité",
        sponsors: "Sponsors",
        deleteSponsor: "Supprimer le sponsor",
        deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer \"{name}\" ?\nCette action est irréversible.",
        delete: "Supprimer",
        cancel: "Annuler",
        deleteError: "Erreur lors de la suppression du sponsor.",
        deleteCouldNot: "Impossible de supprimer le sponsor.",
        deleteSuccess: "Sponsor supprimé avec succès.",
        headers: {
            name: "Nom",
            contactName: "Nom du contact",
            contactEmail: "Email du contact",
            active: "Actif",
            actions: "Actions"
        },
        sport: "Sport",
        billing: "Facturation",
        activeBadge: "Actif",
        inactiveBadge: "Inactif",
        editSponsor: "Modifier le sponsor",
        deleteSponsorTitle: "Supprimer le sponsor",
        form: {
            newBadge: "NOUVEAU",
            editBadge: "MODIFIER",
            newSponsor: "Nouveau sponsor",
            editSponsor: "Modifier le sponsor",
            close: "Fermer",
            save: "Enregistrer",
            saving: "Enregistrement...",
            sponsorBusinessName: "Nom du sponsor / de l’entreprise",
            contactName: "Nom du contact",
            contactEmail: "Email du contact",
            websiteLandingUrl: "Site web / URL de destination",
            primarySport: "Sport principal",
            selectSport: "Sélectionner un sport…",
            multipleGeneralSports: "Sports multiples / généraux",
            billingCountryOptional: "Pays de facturation (facultatif)",
            billingCurrencyOptional: "Devise de facturation (facultatif)",
            useProfileDefault: "Utiliser la valeur par défaut du profil",
            useProfileCountryDefault: "Utiliser la valeur par défaut du profil/pays",
            useBackendDefault: "Utiliser la valeur par défaut du système",
            unitedStatesUs: "États-Unis (US)",
            canadaCa: "Canada (CA)",
            notesInternalOnly: "Notes (interne uniquement)",
            notesPlaceholder: "Contact de facturation, tarif spécial, etc.",
            activeSponsor: "Sponsor actif (peut lancer des campagnes)",
            toast: {
                createError: "Erreur lors de la création du sponsor.",
                createCouldNot: "Impossible de créer le sponsor.",
                created: "Sponsor créé avec succès !",
                updateError: "Erreur lors de la mise à jour du sponsor",
                updated: "Sponsor mis à jour avec succès !"
            }
        }
    },
    campaigns: {
        advertising: "Publicité",
        campaigns: "Campagnes",
        newCampaign: "Nouvelle campagne",
        editCampaign: "Modifier la campagne",
        deleteCampaign: "Supprimer la campagne",
        deleteConfirmMessage: "Vous êtes sur le point de supprimer définitivement la campagne \"{name}\".\n\nCela arrêtera immédiatement la diffusion des annonces.\n\nÊtes-vous sûr de vouloir continuer ?",
        deleteConfirmLabel: "Oui, supprimer",
        cancelLabel: "Non",
        campaignDeleted: "Campagne supprimée",
        failedToDelete: "Échec de la suppression de la campagne",
        allCountries: "Tous les pays",
        allPlatforms: "Toutes les plateformes",
        allSports: "Tous les sports",
        noZones: "Aucune zone",
        zonesCount: "{count} zones",
        headers: {
            name: "Nom",
            status: "Statut",
            sponsor: "Sponsor",
            dates: "Dates",
            targeting: "Ciblage",
            actions: "Actions"
        },
        zones: "Zones",
        start: "Début",
        end: "Fin",
        geo: "Géo",
        platform: "Plateforme",
        sport: "Sport",
        loading: "Chargement...",
        notFound: "Campagne introuvable.",
        status: {
            running: "En cours",
            paused: "En pause",
            ended: "Terminée",
            draft: "Brouillon",
            archived: "Archivée",
            pending_payment: "Paiement en attente",
            active: "Active",
            inactive: "Inactive",
            scheduled: "Programmée",
            completed: "Terminée",
            canceled: "Annulée",
            cancelled: "Annulée",
            expired: "Expirée"
        },
        countries: {
            US: "États-Unis",
            CA: "Canada"
        },
        platforms: {
            ios: "iOS",
            android: "Android"
        }
    },
    checkout: {
        paymentSuccess: "Paiement réussi",
        paymentReceived: "Paiement reçu",
        paymentSuccessMessage: "Le paiement de votre campagne a été effectué avec succès. Elle sera activée une fois la confirmation du webhook traitée.",
        openReview: "Ouvrir la révision de la campagne",
        campaignList: "Liste des campagnes",
        backToCampaigns: "Retour aux campagnes",
        checkoutCanceled: "Paiement annulé",
        checkoutCanceledMessage: "Aucun frais n'a été facturé. Vous pouvez modifier votre campagne et réessayer.",
        openDraft: "Ouvrir le brouillon",
        backToReview: "Retour à la révision"
    },
    campaignReview: {
        notFound: "Campagne introuvable.",
        addPlacement: "Ajoutez au moins un emplacement avant de payer.",
        couldNotCreateSession: "Impossible de créer la session de paiement.",
        checkoutFailed: "Le paiement a échoué.",
        errorLoading: "Erreur lors du chargement de la campagne",
        reviewConfirm: "Vérifier et Confirmer",
        edit: "Modifier",
        campaign: "Campagne",
        billingCurrency: "Devise de facturation",
        placements: "Emplacements",
        countries: "Pays",
        platforms: "Plateformes",
        sports: "Sports",
        organizations: "Organisations",
        all: "Tous",
        total: "Total",
        calculatedOnStripe: "Le montant final est calculé sur Stripe ({currency})",
        enterpriseMarketplaceNoPaymentRequired: "Inclus avec l’abonnement Enterprise de votre ligue",
        calculatedAtCheckout: "Calculé lors du paiement",
        backToEdit: "Retour à la Modification",
        redirecting: "Redirection en cours...",
        confirmPay: "Confirmer et Payer",
        beforeYouPay: "Avant de payer",
        tip1: "Confirmez les emplacements et les dates.",
        tip2: "Assurez-vous que votre création respecte les consignes de taille et de contenu.",
        tip3: "Les taxes sont calculées automatiquement sur Stripe.",
        tip4: "La devise est liée aux paramètres de facturation du sponsor.",
        footerText: "Vérifiez vos informations, puis continuez vers Stripe pour payer."
    },
    campaignForm: {
        collapse: "Réduire",
        expand: "Développer",
        filePicker: "Sélecteur de fichier",
        chooseFile: "Choisir un fichier",
        existingImage: "Image existante",
        existingImageLower: "image existante",
        noFileSelected: "Aucun fichier sélectionné",
        dragDropHint: "Glissez-déposez un logo carré ici (PNG/JPG). Format recommandé : 1:1.",
        remove: "Supprimer",
        logoPreview: "Aperçu du logo",
        preview: "Aperçu",
        basics: "Informations de base",
        campaignName: "Nom de la campagne",
        campaignNamePlaceholder: "Essais de soccer d’automne - Toronto",
        sponsorBrand: "Sponsor / Marque",
        selectSponsor: "Sélectionner un sponsor",
        inactive: "(inactif)",
        billingCurrency: "Devise de facturation",
        billingCurrencyHint: "Verrouillée selon les paramètres de facturation du sponsor.",
        placement: "Emplacement",
        placementHint: "Où votre publicité apparaîtra-t-elle ?",
        placementFallback: "Emplacement",
        targeting: "Ciblage",
        targetingHint: "Qui doit voir votre campagne ?",
        countries: "Pays",
        countryUnitedStates: "États-Unis",
        countryCanada: "Canada",
        geoTargeting: "Ciblage géographique",
        platforms: "Plateformes",
        sportsAudienceFocus: "Sports / audience ciblée",
        audienceSignal: "Signal d’audience",
        allSportsUncheckedHint: "Si aucun sport n’est coché, cela signifie « tous les sports ».",
        specificOrganizationsOptional: "Organisations spécifiques (facultatif)",
        leagueTournament: "Ligue / Tournoi",
        scheduleBudget: "Calendrier et budget",
        startDate: "Date de début",
        endDate: "Date de fin",
        missingRatesFor: "Tarifs manquants pour",
        estimatedTotal: "Total estimé",
        estimatedTotalShort: "Total est.",
        basedOnPlacementsCountriesDuration: "Basé sur les emplacements, les pays et la durée",
        days: "jours",
        missingRatesLabel: "Tarifs manquants",
        finalPriceHint: "Le prix final est affiché au paiement. Votre publicité ne sera pas diffusée tant que le paiement n’est pas confirmé.",
        creative: "Créatif",
        creativeHint: "Ce que les utilisateurs verront.",
        brandLogoSquare: "Marque / Logo (carré)",
        recommendedRatio: "Recommandé : ratio 1:1, PNG ou JPG",
        headline: "Titre",
        headlinePlaceholder: "Clinique élite de soccer d’hiver - places limitées",
        bodyPitch: "Texte / Argumentaire",
        bodyPitchPlaceholder: "Entraînez-vous avec des entraîneurs certifiés. Âges 10-16. Sessions à Toronto dès le 5 nov.",
        ctaButtonLabel: "Libellé du bouton CTA",
        ctaButtonLabelPlaceholder: "S’inscrire maintenant",
        ctaUrl: "URL du CTA",
        ctaUrlPlaceholder: "https://monacademie.com/essais",
        campaignSummary: "Résumé de la campagne",
        name: "Nom",
        sponsor: "Sponsor",
        currency: "Devise",
        placements: "Emplacements",
        selected: "sélectionnés",
        sports: "Sports",
        all: "Tous",
        dates: "Dates",
        yourLogo: "Votre logo",
        yourLogoFirst: "Votre",
        yourLogoSecond: "Logo",
        logo: "Logo",
        yourBusinessCardTitle: "Votre entreprise — obtenez plus de joueurs, clients ou acheteurs",
        trainWithBestCoaches: "Entraînez-vous avec les meilleurs entraîneurs de la ville. Places limitées ce mois-ci.",
        viewMore: "Voir plus",
        sponsoredPlacement: "Placement sponsorisé dans AngeonX Sports",
        fullScreenHighlight: "Mise en avant plein écran",
        yourBrandFeature: "(Mise en avant de votre marque)",
        yourHeadline: "Votre titre — démarquez-vous auprès de la bonne audience",
        fullStoryText: "C’est ici que vous racontez toute votre histoire : camp, clinique, service ou boutique. Les utilisateurs peuvent appuyer pour en savoir plus, s’inscrire ou vous contacter.",
        exampleExpandedView: "Exemple de vue sponsor développée dans l’application",
        seeMore: "Voir plus",
        editingDraft: "Modification du brouillon...",
        unsavedChanges: "Modifications non enregistrées",
        cancel: "Annuler",
        saving: "Enregistrement...",
        saveDraft: "Enregistrer le brouillon",
        saveChanges: "Enregistrer les modifications",
        reviewConfirm: "Vérifier et confirmer",
        type: "Type",
        campaignReach: "Portée de la campagne",
        standardCampaign: "Campagne standard de sponsor ou de ligue",
        standardCampaignHint: "Utilise les règles normales de paiement ou d’organisation Enterprise.",
        internalCampaign: "Campagne interne AngeonX Sports",
        internalCampaignHint: "Visible par tous les utilisateurs admissibles, y compris les organisations Enterprise.",
        internalCampaignReachHint: "Cette campagne interne peut atteindre les utilisateurs de toutes les organisations. Le ciblage par organisation n’est pas utilisé.",
        enterpriseOrganizationTargetingHint: "Les gestionnaires de ligues Enterprise peuvent cibler toute organisation gérée. Laissez vide pour une campagne globale payante de sponsor.",
        enterprisePlan: "Plan Enterprise",
        managedOrganization: "Organisation gérée",
        internalCampaignIncluded: "Les campagnes internes AngeonX Sports ne nécessitent pas de paiement Stripe.",
        enterpriseCampaignIncluded: "Les campagnes ciblées par organisation sont incluses avec le plan Enterprise. Aucun paiement Stripe n’est requis.",
        enterpriseMarketplaceIncluded: "Cette promotion du marketplace est incluse avec l’abonnement Enterprise de votre ligue. Aucun paiement Stripe n’est requis.",
        enterpriseMarketplaceIncludedShort: "Inclus avec la ligue Enterprise",
        marketplacePromotion: "Promotion du marketplace",
        internalIncludedShort: "Campagne interne",
        enterpriseIncludedShort: "Inclus avec Enterprise",
        organizationCampaign: "Campagne d’organisation",
        globalSponsorCampaign: "Campagne globale de sponsor",
        allUsers: "Tous les utilisateurs",
        global: "Global",
        moreItems: "+{count} de plus",
        platformOptions: {
            ios: "iOS",
            android: "Android"
        },
        adZones: {
            events_banner: { name: "Bannière de l’écran des événements", description: "Bannière à afficher sur l’écran des événements" },
            roster_banner: { name: "Bannière de l’écran de l’effectif", description: "Bannière à afficher sur l’écran de l’effectif" },
            marketplace_banner: { name: "Bannière de l’écran Connect", description: "Bannière à afficher sur l’écran Connect" },
            payments_banner: { name: "Bannière de l’écran des paiements", description: "Bannière à afficher sur l’écran des paiements" },
            more_banner: { name: "Bannière de l’écran plus", description: "Bannière à afficher sur l’écran plus" },
            profiles_banner: { name: "Bannière de l’écran des profils", description: "Bannière à afficher sur l’écran des profils" },
            event_details_banner: { name: "Bannière de l’écran des détails de l’événement", description: "Bannière à afficher sur l’écran des détails de l’événement" },
            event_result_banner: { name: "Bannière de l’écran du résultat d’événement", description: "Bannière à afficher sur l’écran du résultat d’événement" },
            standing_banner: { name: "Bannière de l’écran du classement", description: "Bannière à afficher sur l’écran du classement" },
            edit_team_player_banner: { name: "Bannière de l’écran de modification du joueur de l’effectif", description: "Bannière à afficher sur l’écran de modification du joueur de l’effectif" },
            stats_banner: { name: "Bannière de l’écran des statistiques", description: "Bannière à afficher sur l’écran des statistiques" },
            kbs_fantasy_banner: { name: "Bannière kBs Fantasy", description: "Bannière à afficher sur l’écran kBs Fantasy" },
            preferences_banner: { name: "Bannière des préférences", description: "Bannière à afficher sur l’écran des préférences" },
            add_profile_banner: { name: "Bannière d’ajout de profil", description: "Bannière à afficher sur l’écran d’ajout de profil" },
            add_team_banner: { name: "Bannière d’ajout d’équipe", description: "Bannière à afficher sur l’écran d’ajout d’équipe" },
            edit_team_banner: { name: "Bannière de modification d’équipe", description: "Bannière à afficher sur l’écran de modification d’équipe" },
            organizations_banner: { name: "Bannière de l’écran des organisations", description: "Bannière à afficher sur l’écran des organisations" },
            organization_banner: { name: "Bannière de l’écran de détail d’organisation", description: "Bannière à afficher sur l’écran de détail d’organisation" },
            divisions_banner: { name: "Bannière de l’écran des divisions", description: "Bannière à afficher sur l’écran des divisions" },
            division_banner: { name: "Bannière de l’écran de détail de division", description: "Bannière à afficher sur l’écran de détail de division" },
            division_team_players_banner: { name: "Bannière de l’écran des joueurs de l’équipe de division", description: "Bannière à afficher sur l’écran des joueurs de l’équipe de division" },
            division_teams_add_player_banner: { name: "Bannière de l’écran d’ajout de joueurs à l’équipe de division", description: "Bannière à afficher sur l’écran d’ajout de joueurs à l’équipe de division" },
            kbs_challenges_banner: { name: "Bannière des défis kBs Fantasy", description: "Bannière à afficher sur l’écran des défis kBs Fantasy" },
            chat_list_banner: { name: "Bannière de l’écran de liste des discussions", description: "Bannière à afficher sur l’écran de liste des discussions" },
            leaders_banner: { name: "Bannière de l’écran des leaders", description: "Bannière à afficher sur l’écran des leaders" },
            marketplace_listings_banner: { name: "Bannière de l’écran des annonces du marketplace", description: "Bannière à afficher sur l’écran des annonces du marketplace" },
            marketplace_listing_banner: { name: "Bannière de l’écran de détail de l’annonce du marketplace", description: "Bannière à afficher sur l’écran de détail de l’annonce du marketplace" },
            marketplace_favorites_banner: { name: "Bannière de l’écran des favoris du marketplace", description: "Bannière à afficher sur l’écran des favoris du marketplace" },
            marketplace_my_listings_banner: { name: "Bannière de l’écran de mes annonces du marketplace", description: "Bannière à afficher sur l’écran de mes annonces du marketplace" },
            marketplace_blocked_users_banner: { name: "Bannière de l’écran des utilisateurs bloqués du marketplace", description: "Bannière à afficher sur l’écran des utilisateurs bloqués du marketplace" },
            referee_assignments_banner: { name: "Bannière de l’écran des assignations d’arbitres", description: "Bannière à afficher sur l’écran des assignations d’arbitres" },
            referee_availability_banner: { name: "Bannière de l’écran de disponibilité des arbitres", description: "Bannière à afficher sur l’écran de disponibilité des arbitres" },
            subscription_banner: { name: "Bannière de l’écran d’abonnement", description: "Bannière à afficher sur l’écran d’abonnement" },
            invoices_banner: { name: "Bannière de l’écran des factures", description: "Bannière à afficher sur l’écran des factures" },
            notifications_banner: { name: "Bannière de l’écran des notifications", description: "Bannière à afficher sur l’écran des notifications" },
            team_events_banner: { name: "Bannière de l’écran des événements de l’équipe", description: "Bannière à afficher sur l’écran des événements de l’équipe" },
            team_stats_banner: { name: "Bannière de l’écran des statistiques de l’équipe", description: "Bannière à afficher sur l’écran des statistiques de l’équipe" },
            event_photos_banner: { name: "Bannière de l’écran des photos de l’événement", description: "Bannière à afficher sur l’écran des photos de l’événement" },
            event_referee_rating_banner: { name: "Bannière de l’écran d’évaluation des arbitres de l’événement", description: "Bannière à afficher sur l’écran d’évaluation des arbitres de l’événement" },
            memory_game_banner: { name: "Bannière de l’écran du jeu de mémoire", description: "Bannière à afficher sur l’écran du jeu de mémoire" },
            player_fight_banner: { name: "Bannière de l’écran du combat de joueurs", description: "Bannière à afficher sur l’écran du combat de joueurs" },
            rate_player_banner: { name: "Bannière de l’écran d’évaluation des joueurs", description: "Bannière à afficher sur l’écran d’évaluation des joueurs" },
            marketplace_rating_list_banner: { name: "Bannière de l’écran des évaluations du marketplace", description: "Bannière à afficher sur l’écran des évaluations du marketplace" },
            send_notification_banner: { name: "Bannière de l’écran d’envoi de notifications", description: "Bannière à afficher sur l’écran d’envoi de notifications" },
            player_profile_banner: { name: "Bannière de l’écran du profil du joueur", description: "Bannière à afficher sur l’écran du profil du joueur" },
            player_insights_banner: { name: "Bannière de l’écran des analyses du joueur", description: "Bannière à afficher sur l’écran des analyses du joueur" },
            referee_profile_banner: { name: "Bannière de l’écran du profil de l’arbitre", description: "Bannière à afficher sur l’écran du profil de l’arbitre" },
            referee_assignment_detail_banner: { name: "Bannière de l’écran de détail de l’assignation d’arbitre", description: "Bannière à afficher sur l’écran de détail de l’assignation d’arbitre" },
            referee_rating_comments_banner: { name: "Bannière de l’écran des commentaires d’évaluation de l’arbitre", description: "Bannière à afficher sur l’écran des commentaires d’évaluation de l’arbitre" }
        },
        toast: {
            enterNameSponsorPlacement: "Saisissez un nom, sélectionnez un sponsor et choisissez au moins un emplacement.",
            missingRates: "Tarifs manquants pour la zone/le pays sélectionné dans la devise du sponsor.",
            provideImage: "Ajoutez une image (téléversement ou URL).",
            couldNotSaveDraft: "Impossible d’enregistrer le brouillon :",
            unknownError: "Erreur inconnue",
            draftSaved: "Brouillon enregistré !",
            somethingWentWrongSaving: "Une erreur s’est produite lors de l’enregistrement du brouillon.",
            missingCampaignId: "ID de campagne manquant.",
            completeRequiredFields: "Veuillez compléter les champs obligatoires.",
            updateFailed: "Échec de la mise à jour :",
            draftUpdated: "Brouillon mis à jour !",
            somethingWentWrongUpdating: "Une erreur s’est produite lors de la mise à jour du brouillon.",
            couldNotProceedToReview: "Impossible de passer à la vérification."
        }
    }
};

export default fr;
